import {TranslationTree} from '../types';

const fr: TranslationTree = {
    premiumRoyalties: {
        "accrued": "Cumulé ce mois-ci",
        "accruedNote": "Estimation avant plafonds et examen ; montant non retirable.",
        "held": "En attente d’examen",
        "heldNote": "Comprend les mois précédents. Les montants retenus doivent être approuvés.",
        "adjustments": "Ajustements du mois",
        "adjustmentsNote": "Réductions liées aux plafonds et aux changements de financement.",
        "settlementNote": "Les redevances sont créditées après la fin du mois et leur approbation, puis libérées après le délai de règlement configuré.",
        "pending": "Redevances en attente",
        "externalNotice": "Seule la consultation dans VocalCentric peut générer des redevances. Ouvrir ou télécharger ce fichier ne compte pas.",
        "offlineNotice": "Les redevances nécessitent une connexion. La lecture hors ligne ne compte pas.",
        "internalNote": "Les redevances des chansons internes suivent le processus de paiement des artistes et partenaires.",
        "available": "Solde disponible"
},
    live: {
        "director": "Directeur",
        "directorControls": "Commandes du directeur",
        "directorHint": "Ces commandes coupent les microphones pour tout le monde et arrêtent leur enregistrement. Chaque choriste peut réactiver son microphone.",
        "muteSection": "Couper le pupitre",
        "muteForEveryone": "Couper pour tous",
        "endForEveryone": "Terminer pour tous",
        "endConfirm": "Terminer cette répétition pour tout le monde ? La prise en cours s’arrêtera et tous quitteront l’appel.",
        "notifyPending": "Vous êtes connecté. Les notifications aux membres sont en attente ; nous réessaierons automatiquement.",
        "liveNow": "En direct",
        "liveNowJoin": "En direct · Rejoindre",

        "openRoom": "Ouvrir la répétition en direct",
        "viewRoom": "Voir l’appel",
        "beforeJoin": "Avant de rejoindre",
        "you": "Vous",
        "muted": "Microphone coupé",
        "closePreview": "Fermer l’aperçu",
        "mixer": "Votre mixage",
        "joining": "Connexion…",
        "ended": "Cette répétition est terminée.",
        "noOtherParticipants": "Les autres chanteurs apparaîtront ici lorsqu’ils rejoindront la répétition.",
        "noTakes": "Aucun enregistrement pour le moment.",
        "captureUnavailable": "L’enregistrement est indisponible. Vous pouvez toujours répéter en direct.",
        "armed": "Capture prête",
        "timing": "Estimation de l’horloge (± ms)",
        "timingHint": "L’alignement de l’enregistrement est estimé. Vérifiez chaque prise avant de la publier ; la latence de l’appareil et de l’audio reste à calibrer.",
        "publishHint": "La publication met à jour les voix sélectionnées dans cette section du chant.",
        "quality": "Connexion audio",
        "excellent": "Excellente",
        "good": "Bonne",
        "poor": "Faible",
        "lost": "Perdue",
        "unknown": "Mesure en cours",
        "title": "Répétition en direct",
        "start": "Démarrer la répétition",
        "join": "Rejoindre la répétition",
        "headphones": "J’utilise un casque filaire.",
        "headphonesWarning": "Un casque filaire offre la meilleure synchronisation. Les haut-parleurs peuvent provoquer un écho ou un larsen, et le Bluetooth ajouter du retard. Baissez le volume et coupez le micro quand vous ne chantez pas.",
        "consent": "Autoriser l’enregistrement de mon microphone pour l’Harmonie personnalisée. Couper le microphone arrête l’enregistrement.",
        "waiting": "En attente du démarrage par le chef de chœur.",
        "reopen": "Rouvrir la répétition",
        "connected": "Connecté",
        "recording": "Enregistrement du microphone",
        "monitorHint": "Ces réglages modifient uniquement ce que vous entendez, sans affecter les autres ni les enregistrements.",
        "volume": "Volume",
        "mute": "Couper",
        "solo": "Solo",
        "soprano": "Soprano",
        "alto": "Alto",
        "tenor": "Ténor",
        "bass": "Basse",
        "unassigned": "Non attribué",
        "micOff": "Couper le microphone",
        "micOn": "Activer le microphone",
        "retryUploads": "Réessayer les envois enregistrés",
        "leave": "Quitter la répétition",
        "song": "Chanson",
        "section": "Section de la chanson",
        "record": "Enregistrer une prise",
        "stop": "Arrêter la prise",
        "end": "Terminer la répétition",
        "refreshTakes": "Actualiser les prises",
        "takes": "Prises enregistrées",
        "selectTake": "Choisir la prise",
        "publish": "Créer une Harmonie personnalisée",
        "joinFailed": "Connexion impossible. Vérifiez l’autorisation du microphone et réessayez.",
        "commandFailed": "La répétition a changé ou la commande a échoué. Actualisez et réessayez.",
        "connectionLost": "Connexion interrompue. L’enregistrement peut continuer localement tant que l’application reste active.",
        "captureFailed": "L’enregistrement n’a pas pu continuer. L’audio sauvegardé est conservé. Rejoignez la prochaine prise.",
        "uploadPending": "L’audio est sauvegardé sur cet appareil. Réessayez l’envoi une fois connecté.",
        "published": "Harmonie personnalisée créée. Ouvrez le lecteur d’Harmonie de la chanson pour vous entraîner.",
        "publishFailed": "Choisissez un enregistrement prêt par voix de la même prise, puis réessayez."
},
    common: {
        login: 'Connexion',
        register: 'S’inscrire',
        signUp: 'Créer un compte',
        proceed: 'Continuer',
        confirm: 'Confirmer',
        verify: 'Vérifier',
        forgotPassword: 'Mot de passe oublié',
        settings: 'Paramètres',
        logout: 'Déconnexion',
        profile: 'Profil',
        myApplications: 'Mes candidatures',
        myInvites: 'Mes invitations',
        operationSuccessful: 'Opération réussie',
        yourEmail: 'votre e-mail',
        resendOtp: 'Renvoyer OTP',
        resendOtpIn: 'Renvoyer OTP dans {{time}}',
        preferences: 'Préférences',
        preferredCurrency: 'Devise préférée',
        preferredLanguage: 'Langue préférée',
        saveCurrency: 'Enregistrer la devise',
        saveLanguage: 'Enregistrer la langue',
        save: 'Enregistrer',
        tryAgain: 'Réessayer',
        share: 'Partager',
        cancel: 'Annuler',
        close: 'Annuler',
        delete: 'Supprimer',
        loading: 'Chargement...',
    },
    auth: {
        welcomeBack: 'Bon retour !',
        loginSubtitle: 'Entrez vos informations pour accéder à votre tableau de bord',
        email: 'E-mail',
        password: 'Mot de passe',
        enterYourEmail: 'Entrez votre e-mail',
        enterYourPassword: 'Entrez votre mot de passe',
        noAccount: 'Vous n’avez pas de compte ?',
        haveAccount: 'Vous avez déjà un compte ?',
        alreadyHaveAccount: 'Vous avez déjà un compte ?',
        forgotPasswordPrompt: 'Veuillez entrer votre adresse e-mail',
        welcomeToVocalcentric: 'Bienvenue sur VocalCentric !',
        registerSubtitle: 'Entrez vos informations pour créer un compte',
        registerSubtitleMinimal: 'Créez votre compte en quelques secondes',
        selectPart: 'Sélectionnez une voix',
        firstName: 'Prénom',
        lastName: 'Nom',
        username: 'Nom d’utilisateur',
        phoneNumber: 'Numéro de téléphone',
        firstNamePlaceholder: 'Prénom',
        lastNamePlaceholder: 'Nom',
        usernamePlaceholder: 'Nom d’utilisateur',
        phonePlaceholder: 'Téléphone',
        confirmPassword: 'Confirmer le mot de passe',
        confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
        referral: 'Parrainage',
        confirmOtp: 'Confirmer OTP',
        otpPrompt: 'Veuillez entrer le code OTP envoyé à {{email}}',
        forgotPasswordTitle: 'Mot de passe oublié',
        newPassword: 'Nouveau mot de passe',
        newPasswordSubtitle: 'Entrez votre nouveau mot de passe',
    },
    modals: {
        mobileAppRequired: {
            afterInstall: 'Après l’installation, rouvrez ce lien et appuyez sur « Ouvrir l’application » pour reprendre là où vous en étiez.',
            title: 'Continuez dans l’application',
            description: 'Pour la meilleure expérience mobile, ouvrez l’application.',
            openApp: 'Ouvrir l’application',
            playStore: 'Google Play',
            appStore: 'App Store',
            continueWeb: 'Continuer sur le web',
            close: 'Fermer l’invite de l’application mobile',
        },
        manageServiceTypes: {
            title: 'Gérer les types de service',
            description: 'Créez, mettez à jour ou supprimez les types de service personnalisés utilisés par ce chœur.',
            loading: 'Chargement des types de service...',
            noDescription: 'Aucune description',
            empty: 'Aucun type de service personnalisé n’a encore été ajouté pour ce chœur.',
            emptyHint: 'Utilisez le formulaire à droite pour ajouter le premier.',
            edit: 'Modifier',
            delete: 'Supprimer',
            editServiceType: 'Modifier le type de service',
            createServiceType: 'Créer un type de service',
            editHint: 'Mettez à jour les détails du type de service ci-dessous.',
            createHint: 'Ajoutez un nouveau type de service personnalisé pour ce chœur.',
            name: 'Nom',
            namePlaceholder: 'ex. Service du dimanche',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Note optionnelle sur l’usage de ce type de service.',
            recurrence: 'Récurrence',
            weekday: 'Jour de la semaine',
            firstServiceDate: 'Première date de service',
            monthlyPattern: 'Modèle mensuel',
            dayOfMonth: 'Jour du mois',
            weekOfMonth: 'Semaine du mois',
            month: 'Mois',
            day: 'Jour',
            serviceDate: 'Date du service',
            recurrencePreview: 'Aperçu de la récurrence',
            monthlyModesHint: 'Utilisez “Nᵉ jour de semaine du mois” pour des horaires comme 1er jeudi, 2e jeudi ou 5e jeudi.',
            saving: 'Enregistrement...',
            creating: 'Création...',
            saveChanges: 'Enregistrer les modifications',
            confirmDeleteDescription: 'Supprimer ce type de service supprimera aussi les affectations de jours qui l’utilisent. Voulez-vous continuer ?',
            updateAction: 'mettre à jour',
            createAction: 'créer',
            weekdays: {sunday: 'Dimanche', monday: 'Lundi', tuesday: 'Mardi', wednesday: 'Mercredi', thursday: 'Jeudi', friday: 'Vendredi', saturday: 'Samedi'},
            months: {january: 'Janvier', february: 'Février', march: 'Mars', april: 'Avril', may: 'Mai', june: 'Juin', july: 'Juillet', august: 'Août', september: 'Septembre', october: 'Octobre', november: 'Novembre', december: 'Décembre'},
            weekOrdinals: {first: '1er', second: '2e', third: '3e', fourth: '4e', fifth: '5e'},
            recurrenceTypes: {weekly: 'Hebdomadaire', biweekly: 'Bimensuel', monthly: 'Mensuel', annual: 'Annuel', oneTime: 'Unique'},
            monthlyModes: {dayOfMonth: 'Jour fixe du mois', nthWeekday: 'Nᵉ jour de semaine du mois'},
            summary: {
                weeklyOn: 'Hebdomadaire le {{weekday}}',
                biweeklyOn: 'Bimensuel le {{weekday}}',
                biweeklyFrom: 'Bimensuel le {{weekday}}{{suffix}}',
                fromDate: ' à partir du {{date}}',
                monthlyNthWeekday: 'Mensuel le {{ordinal}} {{weekday}}',
                monthlyDay: 'Mensuel le jour {{day}}',
                annualOn: 'Annuel le {{day}} {{month}}',
                oneTimeOn: 'Unique le {{date}}',
                oneTimeNotSet: 'Date unique de service non définie',
                noRecurrence: 'Aucune récurrence configurée',
            },
            validation: {
                enterName: 'Veuillez saisir un nom de type de service',
                chooseWeekday: 'Veuillez choisir un jour de la semaine',
                chooseFirstServiceDate: 'Veuillez choisir la première date de service',
                chooseDayOfMonth: 'Veuillez choisir le jour du mois',
                chooseWeekOfMonth: 'Veuillez choisir la semaine du mois',
                chooseMonthAndDay: 'Veuillez choisir le mois et le jour',
                chooseServiceDate: 'Veuillez choisir la date du service',
            },
            toast: {
                loadFailed: 'Impossible de charger les types de service',
                updated: 'Type de service mis à jour',
                created: 'Type de service créé',
                saveFailed: 'Impossible de {{action}} le type de service',
                deleted: 'Type de service supprimé',
                deleteFailed: 'Impossible de supprimer le type de service',
            },
        },
        whitelist: {
            status: {
                approvedTitle: 'Candidature approuvée',
                pendingTitle: 'Candidature en attente',
                rejectedTitle: 'Candidature refusée',
                applyTitle: 'Demander la whitelist',
                reapplyTitle: 'Redemander la whitelist',
                approvedMessage: 'Votre candidature whitelist a été approuvée. Vous pouvez maintenant accéder aux outils de profil professionnel.',
                pendingMessage: 'Votre candidature est en attente. Un administrateur la vérifiera dans les prochaines 48 heures.',
                rejectedMessage: 'Votre candidature précédente n’a pas été approuvée. Vous pouvez mettre à jour vos informations et repostuler.',
            },
            applicationStatus: 'Statut de la candidature',
            fillToApply: 'Remplissez correctement pour postuler.',
            closeAria: 'Fermer la fenêtre de candidature whitelist',
            loadingStatus: 'Chargement du statut de candidature...',
            uploadHint: 'Téléversez une vidéo montrant vos compétences et votre niveau.',
            socialPlaceholder: 'Saisissez un profil social *',
            socialLabel: 'Profil social',
            reasonPlaceholder: 'Pourquoi souhaitez-vous être whitelisté ? *',
            reasonLabel: 'Motif',
            websitePlaceholder: 'Lien du site web',
            websiteLabel: 'Lien du site web (optionnel)',
            submitting: 'Envoi...',
            apply: 'Postuler',
            reapply: 'Repostuler',
            unknownState: 'Impossible de déterminer l’état actuel de la candidature whitelist.',
            toast: {submitted: 'Candidature whitelist envoyée avec succès', submitFailed: 'Impossible d’envoyer la candidature whitelist'},
        },
        director: {
            status: {
                approvedTitle: 'Candidature approuvée',
                pendingTitle: 'Candidature en attente',
                rejectedTitle: 'Candidature refusée',
                applyTitle: 'Demander le rôle de directeur',
                reapplyTitle: 'Redemander le rôle de directeur',
                approvedMessage: 'Votre candidature directeur a été approuvée. Vous pouvez maintenant créer et gérer des chœurs.',
                pendingMessage: 'Votre candidature est en attente. Un administrateur la vérifiera dans les prochaines 48 heures.',
                rejectedMessage: 'Votre candidature précédente n’a pas été approuvée. Vous pouvez mettre à jour vos informations et repostuler.',
            },
            applicationStatus: 'Statut de la candidature',
            fillToApply: 'Remplissez correctement pour postuler.',
            closeAria: 'Fermer la fenêtre de candidature directeur',
            loadingStatus: 'Chargement du statut de candidature...',
            uploadHint: 'Téléversez une vidéo montrant vos compétences de leadership et de direction musicale.',
            socialPlaceholder: 'Saisissez un profil social *',
            socialLabel: 'Profil social',
            reasonPlaceholder: 'Pourquoi souhaitez-vous devenir directeur ? *',
            reasonLabel: 'Motif',
            websitePlaceholder: 'Lien du site web',
            websiteLabel: 'Lien du site web (optionnel)',
            apply: 'Postuler',
            reapply: 'Repostuler',
            unknownState: 'Impossible de déterminer l’état actuel de la candidature directeur.',
            toast: {submitted: 'Candidature directeur envoyée avec succès', submitFailed: 'Impossible d’envoyer la candidature directeur'},
        },
        shareSetlist: {
            title: 'Partager "{{name}}"',
            description: 'Gérez la visibilité, les chansons sélectionnées et copiez un lien public pour cette setlist.',
            visibility: 'Visibilité',
            makePublic: 'Rendre la setlist publique',
            renameLabel: 'Nom de la setlist',
            renamePlaceholder: 'Saisissez le nom de la setlist',
            saveName: 'Enregistrer le nom',
            savingName: 'Enregistrement...',
            nameRequired: 'Saisissez un nom de setlist',
            nameLength: 'Le nom doit contenir entre 2 et 100 caractères',
            publishTitle: 'Confirmer le nom public',
            publishDescription: 'Ce nom sera affiché partout où la setlist est partagée publiquement.',
            confirmPublish: 'Rendre publique',
            cancelPublish: 'Annuler',
            publishing: 'Publication...',
            selectedSongs: 'Chansons sélectionnées',
            remove: 'Retirer',
            moveSongUp: 'Monter la chanson',
            moveSongDown: 'Descendre la chanson',
            emptySongs: 'Cette setlist ne contient aucune chanson.',
            addMode: 'Mode d’ajout',
            manualEntry: 'Manuel',
            importFromText: 'Importer depuis le texte',
            importTextLabel: 'Texte de setlist WhatsApp',
            importTextPlaceholder: 'Collez ici un message de setlist au format WhatsApp...',
            songSource: 'Source de chanson',
            search: 'Recherche',
            manualYoutube: 'Manuel (YouTube)',
            publicDomain: 'Domaine public',
            searchPlaceholder: 'Rechercher des chansons...',
            selectLabelPlaceholder: 'Sélectionnez un libellé pour la chanson',
            addSongWithLabel: 'Ajouter la chanson avec libellé',
            addExternalSong: 'Ajouter une chanson externe',
            addPublicDomainSong: 'Ajouter une chanson du domaine public',
            previewImport: 'Aperçu de l’import',
            previewingImport: 'Préparation...',
            importPreview: 'Aperçu de l’import',
            importPreviewSummary: '{{count}} chansons prêtes à être importées',
            importToSetlist: 'Importer dans la setlist',
            importingSetlist: 'Importation...',
            showAddSongs: 'Afficher l’ajout de chansons',
            hideAddSongs: 'Masquer l’ajout de chansons',
            shareLink: 'Lien de partage',
            copyLink: 'Copier le lien',
            public: 'Publique',
            private: 'Privée',
            toast: {
                linkCopied: 'Lien copié dans le presse-papiers !',
                visibilityUpdated: 'La setlist est maintenant {{visibility}}',
                updateVisibilityFailed: 'Échec de mise à jour de la visibilité',
                renameSuccess: 'Nom de setlist mis à jour',
                renameFailed: 'Impossible de mettre à jour le nom de la setlist',
                noSongSelected: 'Aucune chanson sélectionnée',
                songAlreadyExists: 'La chanson existe déjà dans la setlist',
                selectLabel: 'Veuillez sélectionner un libellé pour la chanson',
                songAdded: 'Chanson ajoutée à la setlist',
                errorOccurred: 'Une erreur est survenue',
                songRemoved: 'Chanson supprimée de la setlist',
                removeSongFailed: 'Impossible de supprimer la chanson',
                reorderSongFailed: 'Impossible de réorganiser les chansons',
                enterImportText: 'Collez le texte de la setlist avant l’aperçu',
                importPreviewReady: 'L’aperçu de l’import est prêt',
                importPreviewFailed: 'Impossible de prévisualiser la setlist importée',
                nothingNewToImport: 'Toutes les chansons analysées sont déjà dans cette setlist',
                importSuccess: '{{count}} chansons importées dans la setlist',
                importFailed: 'Impossible d’importer les chansons dans la setlist',
            },
        },
        addSongToRehearsal: {
            title: 'Ajouter une chanson à la répétition',
            description: 'Choisissez une source de chanson ou importez depuis un texte brut, puis ajoutez-la à cette répétition.',
            songSource: 'Source de chanson',
            search: 'Recherche',
            manualYoutube: 'Manuel (YouTube)',
            publicDomain: 'Domaine public',
            searchPlaceholder: 'Rechercher des chansons...',
            cancel: 'Annuler',
            adding: 'Ajout en cours...',
            importing: 'Importation...',
            addToRehearsal: 'Ajouter à la répétition',
            fallbackArtist: 'Artiste inconnu',
            fallbackGenre: 'Inconnu',
            destination: 'Section de répétition',
            additionalSongs: 'Chansons supplémentaires',
            untitledSetlist: 'Liste sans titre',
            toast: {
                selectSongFirst: 'Veuillez d’abord sélectionner une chanson',
                songAdded: 'Chanson ajoutée à la répétition',
                addFailed: 'Impossible d’ajouter la chanson à la répétition',
                enterImportText: 'Collez le texte du setlist avant de prévisualiser',
                importPreviewReady: 'L’aperçu de l’import est prêt',
                importPreviewFailed: 'Impossible de prévisualiser les chansons importées',
                importSuccess: '{{count}} chansons ajoutées à la répétition',
                importFailed: 'Impossible d’ajouter les chansons importées à la répétition',
            },
        },
        shareSetlistWithChoir: {
            title: 'Partager "{{name}}"',
            description: 'Choisissez un chœur et, si besoin, remplacez le nom partagé ou la programmation.',
            chooseChoir: 'Choisir un chœur',
            loadingChoirs: 'Chargement de vos chœurs...',
            searchPlaceholder: 'Rechercher par nom, ID ou UUID',
            loading: 'Chargement...',
            noMatches: 'Aucun résultat',
            nameOptional: 'Nom (optionnel)',
            defaultNamePlaceholder: 'Service du dimanche',
            scheduledForOptional: 'Programmé pour (optionnel)',
            cancel: 'Annuler',
            sharing: 'Partage en cours...',
            shareToChoir: 'Partager au chœur',
            toast: {
                loadChoirsFailed: 'Impossible de charger vos chœurs',
                sharedToChoir: 'Partagé avec {{name}}',
                shareFailed: 'Impossible de partager la setlist',
            },
        },
        confirmation: {
            title: 'Confirmation',
            description: 'Souhaitez-vous continuer ?',
            confirm: 'Confirmer',
            cancel: 'Annuler',
        },
        addChoirSeats: {
            title: 'Ajouter des places au chœur',
            description: 'Choisissez le nombre de places supplémentaires à ajouter à ce chœur.',
            seats: 'Places',
            seatsOption: '{{count}} places',
            cancel: 'Annuler',
            adding: 'Ajout en cours...',
            addSeats: 'Ajouter des places',
            toast: {
                chooseSeats: 'Veuillez choisir le nombre de places',
                completePaymentInNewTab: 'Veuillez finaliser le paiement dans le nouvel onglet',
                addFailed: 'Impossible d’ajouter plus de places au chœur',
            },
        },
        manageChoirEntitlements: {
            title: 'Partage des places Premium',
            sourceDescription: 'Attribuez des places de l’abonnement Premium de ce chœur ou créez un code sécurisé.',
            recipientDescription: 'Utilisez un code sécurisé fourni par le chœur qui partage les places Premium.',
            directTitle: 'Attribuer à un chœur',
            recipientChoir: 'ID du chœur bénéficiaire',
            recipientChoirPlaceholder: 'UUID du chœur',
            seats: 'Places',
            allocate: 'Attribuer les places',
            codeTitle: 'Créer un code d’utilisation',
            codeDescription: 'Le code réserve les places immédiatement et un seul chœur peut l’utiliser.',
            generateCode: 'Créer le code',
            generatedCode: 'Partagez ce code de manière sécurisée',
            allocations: 'Attributions de places',
            noAllocations: 'Aucune attribution de place pour le moment.',
            unredeemedCode: 'Code non utilisé',
            additionalSeats: 'Places supplémentaires',
            increase: 'Augmenter',
            code: 'Code d’utilisation',
            codePlaceholder: 'VC-...',
            redeemCode: 'Utiliser le code',
            toast: {
                loadFailed: 'Impossible de charger les attributions de places',
                actionFailed: 'Impossible de mettre à jour le partage des places Premium',
                allocated: 'Places Premium attribuées',
                codeGenerated: 'Code de places Premium créé',
                increased: 'Attribution de places Premium augmentée',
                redeemed: 'Code de places Premium utilisé',
            },
        },
        createSchedule: {
            title: 'Créer un nouveau planning',
            description: 'Créez une période de planning et définissez les options d’affectation pour ce chœur.',
            scheduleLabel: 'Libellé du planning',
            scheduleLabelPlaceholder: 'Planning de juillet',
            startDate: 'Date de début',
            endDate: 'Date de fin',
            autoAssignMembers: 'Affecter automatiquement les membres',
            perPartCount: 'Nombre par voix',
            cancel: 'Annuler',
            creating: 'Création...',
            createSchedule: 'Créer le planning',
            toast: {
                fillAllFields: 'Veuillez remplir tous les champs',
                created: 'Planning créé !',
                createFailed: 'Impossible de créer le planning',
            },
        },
        inviteChoirMember: {
            title: 'Inviter un membre du chœur',
            description: 'Envoyez une invitation et attribuez une voix par défaut au nouveau membre.',
            email: 'E-mail',
            emailPlaceholder: 'utilisateur@exemple.com',
            assignPart: 'Attribuer une voix',
            addCustomPart: '+ Ajouter une voix personnalisée',
            cancel: 'Annuler',
            sendInvitation: 'Envoyer l’invitation',
            linkDescription: 'Copiez un lien d’invitation au chœur et envoyez-le à plusieurs personnes.',
            copyInvitationLink: 'Copier le lien d’invitation',
            copyingLink: 'Copie...',
            toast: {
                provideEmailAndPart: 'Veuillez renseigner l’e-mail et la voix',
                invitationSent: 'Invitation envoyée',
                sendFailed: 'Impossible d’envoyer l’invitation',
                linkCopied: 'Lien d’invitation copié',
                linkFailed: 'Impossible de copier le lien d’invitation',
            },
        },
        generateShareLink: {
            title: 'Générer un lien de partage',
            description: 'Choisissez combien de temps le lien public d’harmonie doit rester actif avant de le copier.',
            expiration: 'Expiration',
            cancel: 'Annuler',
            generating: 'Génération...',
            generateLink: 'Générer le lien',
            options: {
                oneDay: { label: '1 jour', hint: 'Expire après 24 heures' },
                sevenDays: { label: '7 jours', hint: 'Idéal pour des cycles de révision courts' },
                thirtyDays: { label: '30 jours', hint: 'Recommandé pour le partage des répétitions' },
                ninetyDays: { label: '90 jours', hint: 'Accès répétition plus long' },
                never: { label: 'Jamais', hint: 'Le lien n’expirera pas' },
            },
        },
        renameHarmonyPart: {
            title: 'Renommer la partie d’harmonie',
            description: 'Renommez ou réaffectez cette partie transposée sans modifier son enregistrement source.',
            partName: 'Nom de la partie',
            save: 'Enregistrer le nom',
            saving: 'Enregistrement...',
        },
        serviceDays: {
            title: 'Configurer les jours de service',
            description: 'Assignez un type de service ou indiquez aucun service pour chaque jour de la semaine.',
            empty: 'Aucun type de service n’est encore disponible, donc rien à attribuer pour chaque jour.',
            emptyHint: 'Créez d’abord un type de service hebdomadaire non récurrent, puis revenez configurer les jours de service.',
            createServiceType: 'Créer un type de service',
            noServiceOption: '-- Aucun service --',
            cancel: 'Annuler',
            saving: 'Enregistrement...',
            saveChanges: 'Enregistrer les modifications',
            weekdays: {
                sunday: 'Dimanche',
                monday: 'Lundi',
                tuesday: 'Mardi',
                wednesday: 'Mercredi',
                thursday: 'Jeudi',
                friday: 'Vendredi',
                saturday: 'Samedi',
            },
            toast: {
                loadServiceTypesFailed: 'Impossible de charger les types de service',
                loadExistingDaysFailed: 'Impossible de charger les jours de service existants',
                updated: 'Jours de service mis à jour',
                errorOccurred: 'Une erreur est survenue',
            },
        },
        shareHarmonyLink: {
            title: 'Générer un lien de partage',
            description: 'Choisissez combien de temps le lien de partage d’harmonie doit rester actif.',
            closeAria: 'Fermer la configuration du lien de partage',
            expiration: 'Expiration',
            linkExpiry: 'Expiration du lien :',
            cancel: 'Annuler',
            generating: 'Génération...',
            generateLink: 'Générer le lien',
            options: {
                oneDay: '1 jour',
                sevenDays: '7 jours',
                thirtyDays: '30 jours',
                ninetyDays: '90 jours',
                never: 'Jamais',
            },
        },
        reportContribution: {
            title: 'Signaler une contribution',
            description: 'Choisissez la raison qui décrit le mieux pourquoi cette contribution doit être examinée.',
            cancel: 'Annuler',
            submitReport: 'Envoyer le signalement',
            reasons: {
                wrongPart: 'Mauvaise voix',
                wrongSection: 'Mauvaise section',
                lowQualityAudio: 'Audio de mauvaise qualité',
                poorPerformance: 'Performance insuffisante',
                spamOrIrrelevant: 'Spam ou hors sujet',
                offensiveContent: 'Contenu offensant',
            },
        },
        reportMarketplaceSong: {
            title: 'Signaler une chanson du marketplace',
            description: 'Choisissez la raison qui explique le mieux pourquoi cette chanson doit être examinée.',
            detailsPlaceholder: 'Ajouter un contexte optionnel',
            cancel: 'Annuler',
            submitReport: 'Envoyer le signalement',
            reasons: {
                plagiarizedSong: 'Chanson plagiée',
                copyrightIssue: 'Problème de droits d’auteur',
                misleadingMetadata: 'Métadonnées trompeuses',
                poorAudioQuality: 'Qualité audio médiocre',
                offensiveContent: 'Contenu offensant',
                spamOrIrrelevant: 'Spam ou hors sujet',
                other: 'Autre',
            },
        },
        requestContribution: {
            title: 'Demander une contribution',
            selectedSong: 'Sélectionné : {{title}} - {{artist}}',
            noSongSelected: 'Aucune chanson sélectionnée. Recherchez d’abord une chanson.',
            searchPlaceholder: 'Rechercher une chanson (interne ou externe)',
            selectPart: 'Sélectionner une voix',
            section: 'Section',
            songKeyOptional: 'Tonalité (optionnel)',
            bountyXpOptional: 'Prime XP (optionnel)',
            additionalNotesOptional: 'Notes supplémentaires (optionnel)',
            cancel: 'Annuler',
            submitting: 'Envoi...',
            submitRequest: 'Soumettre la demande',
            toast: {
                selectSongAndPartType: 'Veuillez sélectionner une chanson et un type de voix',
                submitted: 'Demande de contribution envoyée',
                submitFailed: 'Impossible d’envoyer la demande',
            },
        },
        submitContribution: {
            title: 'Soumettre une contribution',
            selectedSong: 'Sélectionné : {{title}} - {{artist}}',
            noSongSelected: 'Aucune chanson sélectionnée. Recherchez d’abord une chanson.',
            searchPlaceholder: 'Rechercher une chanson (interne ou externe)',
            selectPart: 'Sélectionner une voix',
            sectionPlaceholder: 'Section (ex. Refrain, Pont)',
            uploadMode: 'Mode de téléversement :',
            file: 'Fichier',
            record: 'Enregistrer',
            uploadYourAudio: 'Téléversez votre audio',
            cancel: 'Annuler',
            submitting: 'Envoi...',
            submitContribution: 'Soumettre la contribution',
            toast: {
                recordingUploadFailed: 'Échec du téléversement de l’enregistrement',
                completeAllFields: 'Veuillez remplir tous les champs avant de soumettre.',
                submittedSuccessfully: 'Votre contribution a été soumise avec succès !',
                submissionFailed: 'Échec de la soumission',
            },
        },
        submitChallengeEntry: {
            title: 'Soumettre une participation',
            description: 'Téléversez votre performance de challenge et soumettez-la au classement.',
            uploadVideo: 'Téléverser la vidéo de participation',
            captionPlaceholder: 'Parlez de votre participation',
            cancel: 'Annuler',
            submitting: 'Envoi...',
            submitEntry: 'Soumettre la participation',
        },
        updateDefaultPart: {
            title: 'Choisissez votre voix et votre nom d’utilisateur par défaut !',
            description: 'Quelle voix souhaitez-vous chanter ou jouer ? Elle sera utilisée comme voix par défaut.',
            selectDefaultPart: 'Sélectionner la voix par défaut',
            chooseUsername: 'Choisissez un nom d’utilisateur',
            usernameValidation: 'Le nom d’utilisateur doit contenir 3 à 15 caractères et ne peut contenir que des lettres, chiffres et underscores.',
            chooseDifferentUsername: 'Choisissez un nom d’utilisateur différent pour continuer.',
            usernameTaken: 'Ce nom d’utilisateur est déjà pris.',
            loading: '...Chargement',
            setDefaultPart: 'Définir la voix par défaut',
            toast: {
                profileUpdated: 'Profil mis à jour avec succès',
            },
        },
        challengeVote: {
            title: 'Voter',
            description: 'Saisissez votre avis',
            commentPlaceholder: 'Commentaire',
            score: 'Score {{score}}%',
            disqualify: 'Disqualifier',
            cancel: 'Annuler',
            submitting: 'Envoi...',
            submitVote: 'Soumettre le vote',
        },
        deleteHarmonyConfirm: {
            cancel: 'Annuler',
            delete: 'Supprimer',
            deleting: 'Suppression...',
        },
        shareSchedule: {
            title: 'Partager le planning',
            description: 'Générez un lien public du planning à partager ou téléchargez le planning actuel en PDF.',
            closeAria: 'Fermer la fenêtre de partage du planning',
            publicScheduleLink: 'Lien public du planning',
            publicScheduleHint: 'Choisissez combien de temps le lien public doit rester actif avant de le générer.',
            linkExpiry: 'Expiration du lien',
            generating: 'Génération...',
            generateLink: 'Générer le lien',
            regenerateLink: 'Régénérer le lien',
            generatedLink: 'Lien généré',
            readyToShare: 'Prêt à partager',
            copyLink: 'Copier le lien',
            openLink: 'Ouvrir le lien',
            generateToReveal: 'Générez un lien pour afficher ici l’URL publique partageable du planning.',
            pdfDownload: 'Téléchargement PDF',
            pdfDescription: 'Téléchargez le planning actuel sous forme de PDF imprimable.',
            pdfHint: 'Utilisez ceci lorsque le directeur veut une copie imprimable fixe plutôt qu’une page publique en direct.',
            preparingPdf: 'Préparation du PDF...',
            downloadPdf: 'Télécharger le PDF',
            options: {
                oneDay: '1 jour',
                sevenDays: '7 jours',
                thirtyDays: '30 jours',
                ninetyDays: '90 jours',
                never: 'Jamais',
            },
            toast: {
                linkCopied: 'Lien copié dans le presse-papiers',
            },
        },
        fullScreen: {
            confirmationIllustrationAlt: 'illustration de confirmation',
            passwordResetSuccess: 'Félicitations, votre mot de passe a été réinitialisé.',
            login: 'Se connecter',
        },
        postSignupOnboarding: {
            welcomeToVocalcentric: 'Bienvenue sur VocalCentric',
            skipForNow: 'Passer pour le moment',
            back: 'Retour',
            continue: 'Continuer',
            steps: {
                welcome: {
                    title: 'On vous configure rapidement',
                    description: 'VocalCentric vous aide à pratiquer votre voix, mieux répéter avec votre chœur, découvrir des chansons et des stems, et progresser via la communauté.',
                    items: {
                        practiceWithStems: 'Pratiquez avec des stems et des parties isolées',
                        prepareRehearsals: 'Préparez les répétitions et organisez les setlists',
                        collaborate: 'Collaborez dans des chœurs, projets et communautés',
                        buildConsistency: 'Créez de la régularité avec des workflows musicaux structurés',
                    },
                },
                interests: {
                    title: 'Qu’est-ce qui vous amène ici ?',
                    description: 'Choisissez une ou plusieurs options pour personnaliser votre démarrage.',
                },
                role: {
                    title: 'Comment utilisez-vous VocalCentric ?',
                    description: 'Optionnel, mais cela nous aide à mieux vous orienter.',
                },
                recommendation: {
                    title: 'Point de départ recommandé',
                    description: 'Selon vos choix, c’est le meilleur premier endroit pour commencer.',
                    recommendedLabel: 'Recommandé',
                    exploreEverythingInstead: 'Tout explorer à la place',
                },
            },
            toast: {
                saveFailed: 'Impossible d’enregistrer les préférences d’onboarding',
            },
        },
        personalizedOnboarding: {
            title: 'Configuration personnalisée',
            skipForNow: 'Passer pour le moment',
            back: 'Retour',
            continue: 'Continuer',
            finish: 'Terminer la configuration',
            saveFailed: 'Impossible d’enregistrer la progression d’onboarding',
            intentTitle: 'Qu’est-ce qui vous amène ici ?',
            intentDescription: 'Choisissez une ou plusieurs options pour personnaliser votre démarrage.',
            roleTitle: 'Comment utilisez-vous VocalCentric ?',
            roleDescription: 'Optionnel, mais cela nous aide à mieux vous orienter.',
            profileTitle: 'Configurez votre parcours de départ',
            profileDescription: 'Ces choix rapides personnalisent votre prochaine étape.',
            usernameStepTitle: 'Choisissez votre nom d’utilisateur',
            usernameStepDescription: 'Cela aide les collaborateurs à vous trouver et garde votre profil cohérent.',
            partStepTitle: 'Choisissez votre rôle',
            partStepDescription: 'Choisissez votre rôle principal (ténor, alto, pianiste, etc.) pour une meilleure guidance.',
            nameStepTitle: 'Ajoutez votre nom',
            nameStepDescription: 'Utilisez votre vrai prénom et nom pour que les membres puissent vous reconnaître.',
            recommendationTitle: 'Votre meilleure prochaine action',
            recommendationDescription: 'Commencez ici pour atteindre rapidement votre première action utile.',
            recommendedLabel: 'Recommandé',
            exploreInstead: 'Explorer l’accueil à la place',
            selectPart: 'Sélectionner un rôle',
            usernameLabel: "Nom d'utilisateur",
            usernamePlaceholder: "Choisissez un nom d'utilisateur",
            usernameRequired: "Le nom d'utilisateur est requis",
            usernameValidation: 'Le nom doit contenir 3 à 30 caractères (lettres, chiffres ou underscores).',
            usernameTaken: "Ce nom d'utilisateur est déjà pris.",
            usernameValidationUnavailable: "Impossible de vérifier le nom d'utilisateur pour le moment.",
            firstNameLabel: 'Prénom',
            lastNameLabel: 'Nom',
            firstNamePlaceholder: 'Prénom',
            lastNamePlaceholder: 'Nom',
            firstNameRequired: 'Le prénom est requis.',
            lastNameRequired: 'Le nom est requis.',
            defaultNameValidation: 'Veuillez remplacer le nom par défaut New User.',
            roleOptions: {
                choir_member: {label: 'Membre de chœur', description: 'Je répète et je me produis surtout comme choriste.'},
                vocalist: {label: 'Vocaliste / Artiste solo', description: 'Je veux des outils pour renforcer mon flux de performance personnel.'},
                choir_director: {label: 'Chef/Admin de chœur', description: 'Je veux organiser les répétitions, les personnes et le flux du chœur.'},
                vocal_coach: {label: 'Coach vocal / Professeur', description: 'Je veux enseigner et organiser des cours, groupes et devoirs.'},
                producer: {label: 'Producteur', description: 'Je contribue des chansons et des stems à la marketplace.'},
                project_owner: {label: 'Propriétaire de projet', description: 'Je crée des projets et j’invite d’autres personnes à collaborer.'},
                collaborator: {label: 'Collaborateur', description: 'J’explore les gigs/projets et je garde mon profil prêt pour les opportunités.'},
                exploring: {label: 'Simple exploration', description: 'Je veux le parcours guidé le plus rapide et ajuster ensuite.'},
            },
            intentOptions: {
                practice_part: {label: 'Pratiquer ma partie', description: 'Utilisez des stems et une écoute ciblée pour verrouiller votre section.'},
                join_manage_choir: {label: 'Rejoindre ou gérer un chœur', description: 'Travaillez avec membres, parties et activités du chœur au même endroit.'},
                prepare_rehearsals: {label: 'Préparer les répétitions', description: 'Soyez prêt avec setlists, planning et organisation des chants.'},
                discover_songs_stems: {label: 'Découvrir chansons et stems', description: 'Parcourez chansons, artistes et ressources musicales pour la répétition.'},
                improve_vocal_skills: {label: 'Améliorer mes compétences vocales', description: 'Développez la régularité avec une pratique structurée et ciblée.'},
                teach_students: {label: 'Enseigner à des élèves', description: 'Organisez un programme, donnez des exercices et suivez les progrès.'},
                explore_community_challenges: {label: 'Explorer la communauté et les défis', description: 'Rejoignez contributions, reels et activités basées sur les défis.'},
                work_on_projects: {label: 'Travailler sur des projets', description: 'Trouvez des opportunités de collaboration et gérez les workflows projet.'},
                just_explore: {label: 'Juste explorer', description: 'Je veux parcourir et découvrir ce qui me convient.'},
                contribute_stems: {label: 'Contribuer des chansons et stems', description: 'Téléversez du contenu pour la marketplace et gérez votre catalogue.'},
                recruit_collaborators: {label: 'Recruter des collaborateurs', description: 'Invitez des contributeurs qualifiés sur des opportunités actives.'},
            },
            recommendations: {
                director_first_choir: {title: 'Créez votre premier chœur', description: 'Commencez par un espace chœur, puis créez des répétitions à l’intérieur.', ctaLabel: 'Créer un chœur'},
                coach_first_workspace: {title: 'Créez votre espace d’enseignement', description: 'Commencez avec un espace indépendant, puis ajoutez cours et groupes d’élèves.', ctaLabel: 'Commencer à enseigner'},
                producer_upload_song: {title: 'Téléversez votre première chanson', description: 'Le téléversement est disponible pour les comptes autorisés. Continuez vers les uploads du compte.', ctaLabel: 'Ouvrir les uploads'},
                project_owner_first_project: {title: 'Créez votre premier projet', description: 'Créez d’abord un projet, puis invitez des collaborateurs pour démarrer.', ctaLabel: 'Créer un projet'},
                collaborator_discover_projects: {title: 'Explorez les projets actifs', description: 'Découvrez des gigs et opportunités de collaboration adaptées à votre profil.', ctaLabel: 'Ouvrir les projets'},
                projects_first_step: {title: 'Démarrez votre premier flux projet', description: 'Ouvrez les projets pour découvrir rapidement des opportunités actives.', ctaLabel: 'Ouvrir les projets'},
                community_first_step: {title: 'Explorez les défis communautaires', description: 'Rejoignez un défi pour découvrir la valeur de VocalCentric.', ctaLabel: 'Ouvrir les défis'},
                practice_general: {title: 'Écoutez votre partie isolée', description: 'Commencez avec votre partie sélectionnée pour une pratique mieux guidée.', ctaLabel: 'Lire ma partie'},
                explore_first_practice: {title: 'Commencez à explorer VocalCentric', description: 'Parcourez les modules clés et faites une action pour trouver votre meilleur parcours.', ctaLabel: 'Explorer maintenant'},
            },
        },
        upgrade: {
            takeYourChoralExperience: 'Faites passer votre expérience chorale',
            toNextLevel: 'au niveau supérieur',
            premiumDescription: 'Passer en premium débloque un ensemble de fonctionnalités exclusives pour booster votre entraînement vocal et vos compétences de direction.',
            advancedRehearsalTools: 'Outils de répétition avancés :',
            advancedRehearsalDescription: 'Prenez le contrôle de vos répétitions avec des fonctionnalités premium comme des échauffements personnalisables, des pistes par section (soprano, alto, ténor, basse) et un contrôle du tempo variable pour maîtriser les passages difficiles.',
            directorsToolkit: 'Boîte à outils du directeur :',
            directorsToolkitDescription: 'Devenez un leader choral avec des fonctions exclusives comme l’annotation de partitions, le partage de notes de performance avec votre chœur et des analyses avancées pour suivre les progrès individuels et collectifs.',
            seats: 'Places :',
            seatsDescription: 'Ajoutez ou retirez des places pour les membres de votre chœur.',
            notDirector: 'Vous n’êtes pas le directeur de ce chœur, vous ne pouvez donc pas effectuer la mise à niveau.',
            choirBillingAdminTitle: 'Contactez l’administrateur de votre chœur',
            contactChoirAdmin: 'L’abonnement de ce chœur nécessite une action. Contactez l’administrateur ou le membre responsable de la facturation pour mettre à jour le plan ou le paiement avant d’utiliser cette fonctionnalité.',
            upgrade: 'Mettre à niveau',
            toast: {
                planNotFound: 'Plan introuvable',
            },
        },
        upload: {
            clickToUploadDocument: 'Cliquez pour téléverser un document',
            supportedFormats: 'Pdf, txt, ppt, docx (max. 20MB)',
            upload: 'Téléverser',
            cancel: 'Annuler',
        },
        setRehearsalSongKey: {
            title: 'Définir la tonalité',
            description: 'Choisissez une tonalité par défaut pour cette chanson. Vous pouvez utiliser la transposition automatique pour ajuster les parties si nécessaire.',
            note: 'NB : cela ne changera pas la tonalité originale de la chanson, seulement la valeur par défaut pour cette répétition.',
            songKey: 'Tonalité',
            placeholder: 'Sélectionnez la tonalité pour cette répétition',
            setKey: 'Définir la tonalité',
            toast: {
                selectSongKey: 'Veuillez sélectionner une tonalité',
            },
        },
        addCustomSection: {
            title: 'Ajouter une section personnalisée',
            description: 'Saisissez le nom de la section à ajouter, comme Intro, Pont ou Tag.',
            sectionName: 'Nom de la section',
            placeholder: 'ex. : Pont',
            addSection: 'Ajouter la section',
        },
        addCustomPart: {
            title: 'Ajouter une partie personnalisée',
            description: 'Choisissez la partie harmonique que vous souhaitez ajouter à cette section.',
            partName: 'Nom de la partie',
            placeholder: 'Sélectionner la partie par défaut',
            addPart: 'Ajouter la partie',
        },
        duplicateMidiPart: {
            title: 'Dupliquer la piste MIDI',
            description: 'Choisissez la partie que doit devenir ce doublon MIDI. Vous pourrez ensuite modifier la partie dupliquée dans l’éditeur MIDI.',
            targetPart: 'Partie cible',
            selectPart: 'Sélectionner une partie',
            destinationInterval: 'Intervalle cible',
            duplicate: 'Dupliquer',
            intervals: {
                '0': 'Même mélodie',
                '4': 'Tierce au-dessus',
                '-4': 'Tierce en dessous',
                '7': 'Quinte au-dessus',
                '-7': 'Quinte en dessous',
            },
        },
        addSongToSetlist: {
            title: 'Ajouter une chanson à la setlist',
            description: 'Sélectionnez ou créez des setlists pour inclure cette chanson.',
            createNewSetlist: '+ Créer une nouvelle setlist',
            songSource: 'Source de la chanson',
            backToExisting: '← Retour aux existantes',
            source: {
                search: 'Rechercher',
                manualYoutube: 'Manuel (YouTube)',
                publicDomain: 'Domaine public',
            },
            selectLabelPlaceholder: 'Sélectionnez un libellé pour cette chanson...',
            setlistNamePlaceholder: 'Nom de la nouvelle setlist',
            searchSongsPlaceholder: 'Rechercher des chansons...',
            noSongs: 'Aucune chanson',
            songCount: '{{count}} chanson(s)',
            createAndAdd: 'Créer et ajouter',
            addToSetlists: 'Ajouter aux setlists',
            toast: {
                setlistUpdatedSuccessfully: 'Setlist mise à jour avec succès',
                noChangesMade: 'Aucun changement effectué',
                failedToUpdateSetlists: 'Impossible de mettre à jour les setlists',
                selectLabelForSong: 'Veuillez sélectionner un libellé pour cette chanson',
                completeRequiredFields: 'Veuillez compléter les champs requis',
                newSetlistCreatedAndSongAdded: 'Nouvelle setlist créée et chanson ajoutée',
                failedToCreateSetlist: 'Impossible de créer la setlist',
            },
        },
    },
    components: {
        autoCompleteSearch: {
            fromSpotify: 'Depuis Spotify',
            fromLibrary: 'Depuis la bibliothèque',
            nothingFound: 'Aucun résultat.',
        },
        manualSongInput: {
            unlabeled: 'Sans libellé',
            youtubeLink: 'Lien YouTube',
            songTitle: 'Titre de la chanson',
            artistName: "Nom de l'artiste",
            invalidYoutubeLink: 'Lien YouTube invalide.',
            youtubeThumbnailAlt: 'Miniature YouTube',
            selectLabelForSong: 'Sélectionnez un libellé pour la chanson',
        },
        publicSongInput: {
            unlabeled: 'Sans libellé',
            songTitle: 'Titre de la chanson',
            composerOrSource: 'Compositeur ou source',
            selectLabelForSong: 'Sélectionnez un libellé pour la chanson',
        },
        searchInput: {
            searchAlt: 'rechercher',
            clearAlt: 'effacer la recherche',
            defaultPlaceholder: 'Rechercher chanson, artiste, partition, album',
        },
        songSearchInput: {
            searchForSongs: 'Rechercher des chansons...',
            selectedSong: 'Sélectionné : {{title}} – {{artist}}',
        },
        songArt: {
            userAlt: 'utilisateur',
        },
        passwordInput: {
            updatePassword: 'Mettre à jour le mot de passe',
        },
        planCard: {
            currentPlan: 'Forfait actuel',
            payment: 'Paiement',
            nextBillPrefix: 'Votre prochaine facture est de ',
            on: ' le ',
            perMonth: 'Par mois',
            processing: 'Traitement...',
            active: 'Actif',
            upgrade: 'Mettre à niveau',
            downgrade: 'Rétrograder',
        },
        floatingSupport: {
            openSupportMenuAria: 'Ouvrir le menu d’assistance',
            support: 'Support',
            needHelp: 'Besoin d’aide ?',
            weAreHereForYou: 'Nous sommes là pour vous.',
            closeSupportMenuAria: 'Fermer le menu d’assistance',
            contactSupport: 'Contacter le support',
            sendUsAMessageFromTheApp: 'Envoyez-nous un message depuis l’application',
            emailUs: 'Envoyez-nous un e-mail',
            accountDeletion: 'Suppression de compte',
            googleAccountDeletionSteps: 'Étapes de suppression du compte Google',
            tipPrefix: 'Astuce : appuyez sur',
            escKey: 'Échap',
            tipSuffix: 'pour fermer.',
        },
        switchInput: {
            useSetting: 'Utiliser ce réglage',
        },
        mobileSidebar: {
            search: 'Recherche',
        },
        customPopover: {
            menuAlt: 'menu',
            select: 'Sélectionner',
            searchPlaceholder: 'Rechercher...',
            nothingFound: 'Aucun résultat',
        },
        partSelectDropdown: {
            selectPart: 'Sélectionner une partie',
            fromLibrary: 'Depuis la bibliothèque',
            noPartsFound: 'Aucune partie trouvée.',
        },
        keySelectDropdown: {
            selectSongKey: 'Sélectionner la tonalité',
            fromLibrary: 'Depuis la bibliothèque',
            noKeysFound: 'Aucune tonalité trouvée.',
        },
        creditCard: {
            cardNumberLabel: 'Numéro de carte',
            cardNumberPlaceholder: 'Saisissez votre numéro de carte',
            cardTypeIconAlt: 'Icône {{name}}',
            cvvLabel: 'CVV',
            cvvPlaceholder: 'CVV',
            expiryDateLabel: 'Date d’expiration',
            expiryDatePlaceholder: 'MM/AA',
        },
        practiseCards: {
            allSectionsSubmitted: 'Toutes les sections ont été soumises. Beau travail !',
            progress: 'Progression : {{submittedCount}} sur {{totalSections}} sections soumises',
            nothingHereYet: 'Rien ici pour le moment',
        },
        upgrade: {
            previewOnlyMessage: 'Vous ne pouvez prévisualiser que les pistes originales. Passez au plan premium pour voir toutes les pistes.',
            upgradeToSeeAllTracks: 'Passer à la version premium pour tout voir',
        },
        toast: {
            musicAlt: 'Musique',
        },
        choirCard: {
            leaveChoir: 'Quitter le chœur',
            choirAlt: 'Chœur',
            choirAvatarAlt: 'Avatar du chœur',
            members: '{{count}} membres',
            noMembers: 'Aucun membre',
            created: 'Créé :',
            toast: {
                choirDeleted: 'Chœur supprimé avec succès',
            },
        },
        audioPlayer: {
            vocalPlaying: 'Lecture vocale',
            expandToFullView: 'Passer en vue complète',
            fullscreenAlt: 'plein écran',
            playbackSpeed: 'vitesse+',
            speed: {
                slow: 'Lent',
                normal: 'Normal',
                faster: 'Plus rapide',
                fastest: 'Très rapide',
            },
        },
        audioController: {
            repeatAlt: 'répéter',
            pauseAlt: 'pause',
            playAlt: 'lecture',
            micAlt: 'micro',
            speakerAlt: 'haut-parleur',
            initialTime: '00:00',
        },
        multiTrackWaveform: {
            mute: 'Muet',
            solo: 'Solo',
            pause: 'Pause',
            play: 'Lecture',
            sync: 'Synchroniser',
        },
        header: {
            userAvatarAlt: 'avatar utilisateur',
            premium: 'Premium',
            moduleHelp: {
                openHelpAria: 'Ouvrir la vidéo d’aide pour {{module}}',
                firstVisit: 'Première visite de {{module}} ? Regardez le guide',
                watchGuide: 'Besoin d’aide ? Voir le guide',
                watchGuideShort: 'Aide',
                videoTitle: 'Guide de {{module}}',
                primaryAction: 'Aller à {{module}}',
                openInNewTab: 'Ouvrir dans un nouvel onglet',
                close: 'Fermer',
                unavailable: 'Cette vidéo d’aide n’est pas encore configurée. Définissez l’URL de la vidéo du module pour l’activer.',
                guidance: {
                    community_challenges: 'Ouvrez un défi, lisez la consigne, puis participez ou partagez quand vous êtes prêt.',
                    community_reels: 'Parcourez les reels pour voir l’activité de la communauté, puis créez ou réagissez quand vous avez quelque chose à partager.',
                    community_contributions: 'Explorez les contributions de la communauté, puis ouvrez un élément pour écouter, commenter ou contribuer.',
                    community_requests: 'Consultez les demandes ouvertes, puis contribuez la partie ou le stem qui correspond à votre compétence.',
                    choirs_overview: 'Créez d’abord votre chœur, puis avancez dans répétitions, setlists, planning, membres et intégrations.',
                    choir_rehearsals: 'Après les répétitions, passez aux setlists pour clarifier le flux des chants.',
                    choir_setlists: 'Setlists prêts. Ensuite, mettez à jour le planning pour aligner répétitions et services.',
                    choir_schedule: 'Planning en place. Étape suivante : affecter les membres par pupitre.',
                    choir_members: 'Membres configurés. Continuez vers les intégrations pour préparer la synchronisation externe.',
                    choir_integrations: 'Finalisez les intégrations, puis revenez aux répétitions pour le cycle complet.',
                    choir_rehearsal_runthrough: 'Terminez cette session, puis passez aux revues pour donner du feedback.',
                    projects_discover: 'Commencez par créer un projet pour gérer rôles, budget et collaboration.',
                    projects_create: 'Projet créé. Continuez vers Mes projets pour le piloter.',
                    projects_mine: 'Depuis Mes projets, traitez les invitations et candidatures.',
                    projects_invites: 'Gérez les invitations, puis examinez les candidatures.',
                    projects_applications: 'Après les candidatures, passez au détail du projet.',
                    project_overview: 'Vérifiez le résumé du projet, puis ouvrez les candidatures.',
                    project_applications: 'Sélectionnez les profils, puis passez à Membres.',
                    project_members: 'Équipe prête. Continuez vers Budget.',
                    project_budget: 'Budget prêt. Continuez vers Accords.',
                    project_agreements: 'Suivez les accords, puis passez aux invitations.',
                    project_invites: 'Finalisez les invitations restantes, puis revenez à la vue d’ensemble.',
                    uploads: 'Ajoutez les informations du chant et au moins un stem utile, puis envoyez-le pour marketplace ou communauté.',
                },
                whatToDoNext: {
                    title: 'Que faire ensuite',
                    steps: {
                        choirs_overview: 'Vue du chœur',
                        choir_rehearsals: 'Répétitions',
                        choir_setlists: 'Setlists',
                        choir_schedule: 'Planning',
                        choir_members: 'Membres',
                        choir_integrations: 'Intégrations',
                        choir_rehearsal_runthrough: 'Session',
                        choir_rehearsal_review: 'Revue des envois',
                    },
                    copy: {
                        choirs_overview: 'Créez d’abord le chœur, puis ouvrez les répétitions pour démarrer le cycle hebdomadaire.',
                        choir_rehearsals: 'Définissez les objectifs de répétition et les chants, puis passez aux setlists.',
                        choir_setlists: 'Finalisez les chants par répétition ou service, puis mettez à jour le planning.',
                        choir_schedule: 'Confirmez les dates et créneaux, puis assignez les membres par pupitre.',
                        choir_members: 'Affectez les voix et responsabilités, puis connectez les intégrations.',
                        choir_integrations: 'Finalisez les intégrations externes, puis revenez aux répétitions pour le cycle suivant.',
                        choir_rehearsal_runthrough: 'Terminez cette session, puis passez en revue pour feedback et validation.',
                    },
                    cta: {
                        choirs_overview: 'Aller à Créer un chœur',
                        choir_rehearsals: 'Aller aux Setlists',
                        choir_setlists: 'Aller au Planning',
                        choir_schedule: 'Aller aux Membres',
                        choir_members: 'Aller aux Intégrations',
                        choir_integrations: 'Aller aux Répétitions',
                        choir_rehearsal_runthrough: 'Aller à la Revue',
                    },
                },
            },
            quickStart: {
                label: 'Démarrage rapide',
                eyebrow: 'Adoption guidée',
                title: 'Vos prochaines victoires produit',
                progress: '{{completed}} sur {{total}} terminés',
                primaryBadge: 'Étape recommandée',
                cta: 'Ouvrir l’étape',
                header: {
                    early: {
                        badge: 'Premiers pas',
                        title: 'Guide de configuration pour {{role}}',
                        description: 'Terminez d’abord l’essentiel pour que VocalCentric façonne le bon parcours autour de vous.',
                    },
                    mid: {
                        badge: 'En cours',
                        title: 'Guide d’adoption pour {{role}}',
                        description: 'Les bases sont prêtes. Terminez la prochaine action recommandée puis élargissez votre usage du produit.',
                    },
                    mature: {
                        badge: 'Configuration terminée',
                        title: 'Guide d’évolution pour {{role}}',
                        description: 'Votre configuration de base est en place. Utilisez ces prochaines étapes pour approfondir votre usage de VocalCentric.',
                    },
                },
                phaseLabels: {
                    early: 'Début',
                    mid: 'En expansion',
                    mature: 'Établi',
                },
                groups: {
                    completeSetup: 'Finaliser la configuration',
                    recommendedNext: 'À faire ensuite',
                    exploreMore: 'Explorer davantage',
                    completed: 'Terminé',
                },
                roles: {
                    choirDirector: 'Chef de chœur',
                    choirMember: 'Membre du chœur',
                    vocalist: 'Vocaliste',
                    producer: 'Producteur',
                    projectOwner: 'Responsable de projet',
                    collaborator: 'Collaborateur',
                    explorer: 'Explorateur',
                },
                categories: {
                    profile: 'Profil',
                    practice: 'Pratique',
                    choirs: 'Chœurs',
                    projects: 'Projets',
                    community: 'Communauté',
                    uploads: 'Imports',
                },
                items: {
                    chooseRole: {
                        title: 'Choisissez votre usage de VocalCentric',
                        description: 'Définissez d’abord votre rôle pour prioriser les bons parcours.',
                    },
                    choosePart: {
                        title: 'Définissez votre partie ou instrument principal',
                        description: 'Votre partie par défaut personnalise la pratique, les stems et les guides.',
                    },
                    confirmUsername: {
                        title: 'Confirmez votre nom d’utilisateur',
                        description: 'Rendez votre profil trouvable avant de collaborer dans les modules.',
                    },
                    hearPart: {
                        title: 'Écoutez votre partie isolée',
                        description: 'Ouvrez la bibliothèque et passez sur votre stem pour une première écoute utile.',
                    },
                    submitPractice: {
                        title: 'Envoyez votre première pratique',
                        description: 'Terminez un premier flux de pratique pour entrer dans un usage réel.',
                    },
                    tryGames: {
                        title: 'Essayez les jeux rapides',
                        description: 'Lancez des jeux courts pour l’oreille, la justesse et la théorie.',
                    },
                    joinChoir: {
                        title: 'Rejoignez un chœur',
                        description: 'Parcourez les chœurs disponibles et envoyez une demande pour entrer dans un vrai flux.',
                    },
                    createChoir: {
                        title: 'Créez votre premier chœur',
                        description: 'Créez un espace de chœur pour les répétitions, membres et setlists.',
                    },
                    createRehearsal: {
                        title: 'Créez une répétition',
                        description: 'Passez de la configuration du chœur à une vraie répétition exploitable.',
                    },
                    createSetlist: {
                        title: 'Créez une setlist',
                        description: 'Regroupez les chants dans un vrai plan avant de planifier l’équipe.',
                    },
                    inviteMember: {
                        title: 'Invitez votre premier membre',
                        description: 'Ajoutez une première personne pour lancer la collaboration.',
                    },
                    uploadFirstSong: {
                        title: 'Importez votre premier chant ou stem',
                        description: 'Ouvrez l’import pour alimenter le pipeline marketplace.',
                    },
                    createProject: {
                        title: 'Créez votre premier projet',
                        description: 'Lancez un projet pour donner un cadre clair aux rôles et livrables.',
                    },
                    applyToProject: {
                        title: 'Candidatez à un projet',
                        description: 'Explorez les opportunités actives et envoyez une candidature adaptée.',
                    },
                    inviteProjectCollaborator: {
                        title: 'Invitez un collaborateur',
                        description: 'Pourvoyez un rôle du projet pour passer de la préparation à l’exécution.',
                    },
                    joinChallenge: {
                        title: 'Rejoignez un défi communauté',
                        description: 'Faites une première action communauté pour élargir la valeur du produit.',
                    },
                },
            },
        },
        breadcrumb: {
            home: 'Accueil',
            community: 'Communauté',
            marketplace: 'Marketplace',
            choirs: 'Chœurs',
            teaching: 'Écoles',
            projects: 'Projets',
            rehearsals: 'Répétitions',
            accountInformation: 'Informations du compte',
            vocalContributions: 'Contributions vocales',
            uploads: 'Téléversements',
            requestSongs: 'Demander des chansons',
            requestRole: 'Demander un rôle',
            notifications: 'Notifications',
            transactionHistory: 'Historique des transactions',
            search: 'Recherche',
        },
        routeItems: {
            songLibrary: 'Bibliothèque de chansons',
            community: 'Communauté',
            marketplace: 'Marketplace',
            rehearsals: 'Répétitions',
            exercises: 'Exercices',
            choirs: 'Chœurs',
            projects: 'Projets',
            requestSongs: 'Demander des chansons',
            personal: 'Personnel',
            vocalContributions: 'Contributions vocales',
            setlists: 'Setlists',
            settings: 'Paramètres',
            accountInformation: 'Informations du compte',
            requestRole: 'Demander un rôle',
            transactionHistory: 'Historique des transactions',
            notifications: 'Notifications',
        },
        memberTableItem: {
            userAlt: 'utilisateur',
            menu: {
                makeModerator: 'Nommer modérateur',
                removeMember: 'Retirer le membre',
            },
            confirmation: {
                grantModeratorPrivileges: 'Cette personne pourra créer et ajuster les répétitions planifiées, ainsi que gérer l’ajout et le retrait des membres. Voulez-vous continuer et accorder les privilèges de modérateur ?',
                approveRequest: 'Voulez-vous approuver cette demande ?',
                rejectRequest: 'Voulez-vous rejeter cette demande ?',
            },
            toast: {
                songAddedToRehearsals: 'Chanson ajoutée aux répétitions',
                memberMadeModeratorSuccessfully: 'Membre promu modérateur avec succès',
                userSuspendedSuccessfully: 'Utilisateur suspendu avec succès',
                userBlockedSuccessfully: 'Utilisateur bloqué avec succès',
                userRemovedSuccessfully: 'Utilisateur retiré avec succès',
                requestApprovedSuccessfully: 'Demande approuvée avec succès',
                requestRejectedSuccessfully: 'Demande rejetée avec succès',
                upgradeSeatsToApproveRequest: 'Aucune place disponible. Ajoutez des places pour approuver cette demande.',
            },
        },
        memberTable: {
            name: 'Nom',
            email: 'E-mail',
            part: 'Voix',
            dateJoined: "Date d'adhésion",
        },
        communityCard: {
            upvoteFailed: 'Impossible de voter positivement',
            songTitle: 'Titre de la chanson',
            expandToFullView: 'Passer en vue complète',
            fullscreenAlt: 'plein écran',
            songArtAlt: 'Visuel de la chanson',
            missingPartAlt: 'Voix manquante',
            partNeeded: 'Voix requise',
            topContributors: 'Principaux contributeurs',
            contributorFallback: 'Contributeur',
            contributorAvatarAlt: 'avatar du contributeur',
            seeAllContributions: 'Voir toutes les contributions',
        },
        communityCards: {
            loadFailed: 'Impossible de charger les contributions de la communauté',
            errorGeneric: 'Une erreur est survenue lors du chargement des contributions de la communauté.',
            searchBySongTitle: 'Rechercher par titre de chanson',
            all: 'Tous',
            errorAlt: 'Erreur',
            emptyAlt: 'Aucune contribution',
            emptyDescription: 'Aucune contribution communautaire trouvée pour votre recherche.',
            emptyPrompt: 'Vous voulez obtenir de l’aide de la communauté ?',
            requestContribution: 'Demander une contribution',
            loadMore: 'Charger plus',
        },
        requestCards: {
            loadFailed: 'Impossible de charger les demandes',
            searchBySongTitle: 'Rechercher par titre de chanson',
            all: 'Tous',
            emptyAlt: 'Aucune contribution',
            emptyDescription: 'Aucune contribution communautaire trouvée pour votre recherche.',
            emptyPrompt: 'Vous voulez obtenir de l’aide de la communauté ?',
            requestContribution: 'Demander une contribution',
            loadMore: 'Charger plus',
        },
    },
    account: {
        currencyUpdated: 'Devise préférée mise à jour.',
        languageUpdated: 'Langue préférée mise à jour.',
        unableToUpdateCurrency: 'Impossible de mettre à jour la devise préférée.',
        unableToUpdateLanguage: 'Impossible de mettre à jour la langue préférée.',
    },
    accountInfo: {
        breadcrumbBase: 'Informations du compte',
        actions: {
            editProfile: 'Modifier le profil',
            updateCard: 'Mettre à jour la carte',
        },
        sections: {
            subscription: 'Abonnement',
            payments: 'Paiements',
            marketplace: 'Marketplace',
            community: 'Communauté',
            privacy: 'Confidentialité',
            help: 'Aide',
        },
        links: {
            availablePlans: 'Plans disponibles',
            managePlans: 'Gérer les plans',
            orderHistory: 'Historique des commandes',
            savedPaymentCard: 'Carte enregistrée',
            myPurchases: 'Mes achats',
            myOrders: 'Mes commandes',
            uploadSong: 'Téléverser une chanson',
            myListings: 'Mes annonces',
            earnings: 'Revenus',
            myChallenges: 'Mes défis',
            notifications: 'Notifications',
            support: 'Support VocalCentric',
        },
        languages: {
            en: 'Anglais',
            es: 'Espagnol',
            fr: 'Français',
            zh: 'Chinois',
        },
        activePlan: {
            title: 'Plan actif',
            yourPlan: 'Votre plan',
            freePlan: 'Plan gratuit',
            referralCopied: 'Lien de parrainage copié dans le presse-papiers',
            nextBill: 'Votre prochaine facture est de {{price}} le {{date}}',
            currentlyFree: 'Vous êtes actuellement sur un plan gratuit,',
            upgradeToPremium: 'passez en premium',
        },
        editProfile: {
            updated: 'Profil mis à jour avec succès',
            selectDefaultPart: 'Sélectionner la voix par défaut',
            enterCountry: 'Entrer le pays',
            country: 'Pays',
            update: 'Mettre à jour',
        },
        payment: {
            title: 'Carte de paiement enregistrée',
            subtitle: 'Gérez vos informations de paiement pour les achats ponctuels. Pour l’abonnement mensuel, allez dans le récapitulatif du compte.',
        },
        changePassword: {
            title: 'Changer le mot de passe',
            step1Subtitle: 'Pour définir un nouveau mot de passe VocalCentric, vous devez ressaisir votre ancien mot de passe.',
            enterOldPassword: 'Entrez votre ancien mot de passe',
            step2Subtitle: 'Veuillez entrer l’OTP envoyé à votre e-mail.',
            step3Subtitle: 'Veuillez définir votre mot de passe préféré',
            success: 'Félicitations, votre mot de passe a été modifié avec succès.',
        },
        challenges: {
            subtitle: 'Gérez l’historique de vos défis et finalisez le financement des défis avec récompense en espèces.',
            create: 'Créer un défi',
            empty: 'Vous n’avez encore créé aucun défi.',
            explore: 'Explorer la communauté',
            entries: 'entrées',
            interests: 'intérêts',
            created: 'Créé',
            fundingRequired: 'Financement requis',
            view: 'Voir',
            funding: 'Financement...',
            fundNow: 'Financer maintenant',
            updating: 'Mise à jour...',
            moveToUpcoming: 'Passer en à venir',
            filters: {
                all: 'Tous',
                active: 'En direct',
                upcoming: 'À venir',
                closed: 'Passés',
                draft: 'Brouillon',
            },
            sort: {
                highestReward: 'Récompense la plus élevée',
                latest: 'Plus récents',
                mostEntries: 'Le plus d’entrées',
            },
            table: {
                title: 'Titre',
                status: 'Statut',
                entries: 'Entrées',
                reward: 'Récompense',
                dates: 'Dates',
                action: 'Action',
            },
            status: {
                active: 'En direct',
                upcoming: 'À venir',
                closed: 'Passés',
                draft: 'Brouillon',
                pendingWinner: 'Gagnant en attente',
            },
            toast: {
                fundingWindowOpened: 'La fenêtre de financement est ouverte. Finalisez le paiement pour passer le défi en direct.',
                fundingInitialized: 'Financement initialisé avec succès.',
                alreadyFunded: 'Le défi est déjà financé. Le statut a été actualisé.',
                fundingFailed: 'Échec de l’initialisation du financement du défi.',
                movedToUpcoming: 'Le défi a été déplacé vers À venir avec succès.',
                moveToUpcomingFailed: 'Impossible de déplacer le défi vers À venir.',
            },
        },
    },
    dashboard: {
        new: 'Nouveautés',
        newDescription: 'Dernières chansons ajoutées',
        popular: 'Populaires',
        popularDescription: 'Chansons les plus populaires',
        albums: 'Albums',
        albumsDescription: 'Tous les albums',
        artists: 'Artistes',
        artistsDescription: 'Tous les artistes',
        genres: 'Genres',
        genresDescription: 'Tous les genres',
        addSongToRehearsalPrompt: 'Êtes-vous sûr de vouloir ajouter cette chanson à la répétition ?',
        gettingStarted: {
            label: 'Premiers pas',
            progress: '{{completed}} sur {{total}} terminé',
            primaryCta: 'Ouvrir le module suggéré',
            resumeCta: 'Reprendre l’onboarding',
            nextActions: {
                selectRole: 'Choisissez votre rôle pour personnaliser votre espace.',
                selectPart: 'Choisissez votre partie vocale pour activer des réglages de pratique ciblés.',
                confirmUsername: 'Confirmez votre nom d’utilisateur afin que les collaborateurs puissent vous trouver.',
                takeFirstAction: 'Effectuez votre première action guidée pour terminer l’onboarding.',
                completed: 'Tout est prêt.',
            },
        },
        songGuide: {
            eyebrow: 'Guide de la bibliothèque de chansons',
            notNow: 'Pas maintenant',
            resume: 'Reprendre',
            progress: 'Étape {{completed}} sur {{total}}',
            hint: 'Terminez l’action mise en avant pour débloquer l’étape suivante',
            empty: {
                eyebrow: 'Commencez ici',
                title: 'Aucune chanson chargée pour le moment',
                body: 'Dès que des chansons sont disponibles, nous guiderons ici vos premières actions d’écoute et de répétition.',
            },
            steps: {
                open_song: {
                    title: 'Lancez une chanson depuis la liste',
                    body: 'Cliquez sur une ligne de chanson pour ouvrir la lecture et démarrer votre premier flux d’écoute.',
                },
                switch_stem: {
                    title: 'Passez sur un stem isolé',
                    body: 'Choisissez votre partie dans le lecteur pour commencer avec le bon stem.',
                },
                open_multitrack: {
                    title: 'Ouvrez la vue multitrack complète',
                    body: 'Passez en vue multitrack pour vous concentrer sur chaque stem et répéter avec plus de contrôle.',
                },
                close_multitrack: {
                    title: 'Fermez la vue multitrack complète',
                    body: 'Quittez la vue complète pour revenir à la liste et poursuivre le guide.',
                },
                add_to_rehearsal: {
                    title: 'Ajoutez une chanson à la répétition',
                    body: 'Ajoutez une chanson à la répétition pour relier ce module à votre workflow réel.',
                },
                view_in_rehearsal: {
                    title: 'Ouvrez la chanson en répétition',
                    body: 'Passez en répétition pour terminer le flux chanson de bout en bout.',
                },
            },
        },
        search: {
            noResultForKeyword: 'Aucun résultat pour le mot-clé {{keyword}}',
        },
        albumDetail: {
            fetchFailed: 'Impossible de charger l’album :',
            breadcrumb: 'Albums > {{title}}',
            breadcrumbLoading: 'Albums > Chargement...',
            notFound: 'Album introuvable ...',
            bannerAlt: 'visuel de l’album',
            albumLabel: 'Album',
            byLabel: 'Par : ',
            releasedYearLabel: 'Année de sortie : ',
            songNumberLabel: 'Nombre de chansons : ',
            albumDurationLabel: 'Durée de l’album : ',
        },
        artistDetail: {
            breadcrumbNamed: 'Artiste > {{name}}',
            breadcrumbLoading: 'Artiste > Chargement...',
            empty: 'Artiste introuvable ...',
            label: 'Artiste',
            bioLabel: 'Bio :',
            tags: {
                popular: {
                    title: 'Populaire',
                    description: 'Chansons les plus populaires',
                },
                albums: {
                    title: 'Albums',
                    description: 'Tous les albums',
                },
            },
        },
        cards: {
            songArtworkAlt: 'illustration de {{title}}',
            albumArtAlt: "visuel de l'album",
            albumLabel: 'Album',
            artistLabel: 'Artiste',
        },
        songTable: {
            title: 'Titre',
            album: 'Album',
            genre: 'Genre',
            votes: 'Votes',
            duration: 'Durée',
            action: 'Action',
            single: 'Single',
            viewInRehearsal: 'Voir en répétition',
            addToRehearsal: 'Ajouter à la répétition',
            addToSetlist: 'Ajouter à la setlist',
            viewCommunityReels: 'Voir les reels de la communauté',
            likeOrVote: 'Aimer ou voter',
            toast: {
                songAddedToRehearsals: 'Chanson ajoutée aux répétitions',
                songAlreadyInRehearsals: 'La chanson est déjà dans les répétitions',
            },
        },
        topHits: {
            song: 'Chanson',
            votes: 'Votes',
            duration: 'Durée',
            actions: 'Actions',
            rehearsed: 'Répétée',
            addToRehearsal: 'Ajouter à la répétition',
            iconAlt: 'icône',
        },
        topResult: {
            title: 'Meilleur résultat',
            artist: 'Artiste',
            albumWithTitle: 'Album · {{title}}',
            songWithTitle: 'Chanson · {{title}}',
            choirWithBio: 'Chœur · {{bio}}',
            choirFallback: 'Chœur',
        },
        searchGroup: {
            artists: 'Artistes',
            albums: 'Albums',
            contributionRequests: 'Demandes de contribution',
            communityContributions: 'Contributions de la communauté',
            choirs: 'Chœurs',
        },
    },
    projects: {
        breadcrumbBase: 'Projets',
        discover: 'Découvrir',
        discoverDescription: 'Parcourir les projets ouverts',
        myProjects: 'Mes projets',
        myProjectsDescription: 'Projets que vous possédez',
        myInvites: 'Mes invitations',
        myInvitesDescription: 'Rôles auxquels vous avez été invité',
        myApplications: 'Mes candidatures',
        myApplicationsDescription: 'Rôles auxquels vous avez postulé',
        headerSubtitle: 'Constituez des équipes temporaires, découvrez des opportunités actives et déplacez les collaborateurs acceptés dans un espace de travail si nécessaire.',
        createProject: 'Créer un projet',
        discoverInner: 'Découvrir',
        searchPlaceholder: 'Rechercher des projets, artistes, gigs, productions',
        allModes: 'Tous les modes',
        remote: 'À distance',
        physical: 'Présentiel',
        hybrid: 'Hybride',
        compensation: 'Rémunération',
        paid: 'Payé',
        unpaid: 'Non payé',
        allRoles: 'Tous les rôles',
        allCountries: 'Tous les pays',
        noOpenProjects: 'Aucun projet ouvert ne correspond à ces filtres.',
        myProjectsEmpty: 'Vous n’avez encore créé aucun projet.',
        roleFallback: 'Rôle',
        detailsUnavailable: 'Détails du projet indisponibles',
        locationLabel: 'Localisation :',
        unavailable: 'Indisponible',
        components: {
            projectCard: {
                positionsRequested: '{{count}} postes demandés',
                requirementsOnDetailView: 'Les exigences du projet sont disponibles dans la vue de détail',
                more: 'de plus',
                projectAlt: 'Projet',
                paidOpportunity: 'Opportunité rémunérée',
                unpaidCollaboration: 'Collaboration non rémunérée',
                projectOwnerAvatarAlt: 'Avatar du propriétaire du projet',
                byOwner: 'par {{owner}}',
                needsLabel: 'Besoins :',
                openSlots: '{{count}} postes ouverts',
            },
            userProfileHover: {
                userFollowed: 'Utilisateur suivi.',
                userUnfollowed: 'Utilisateur non suivi.',
                unableToFollowUser: 'Impossible de suivre cet utilisateur.',
                unableToUnfollowUser: 'Impossible de ne plus suivre cet utilisateur.',
                vocalcentricMember: 'Membre VocalCentric',
                followersCount: 'Abonnés : {{count}}',
                followingCount: 'Abonnements : {{count}}',
                viewProfile: 'Voir le profil',
                follow: 'Suivre',
                unfollow: 'Ne plus suivre',
            },
            applicantProfileCard: {
                applicant: 'Candidat',
                unknownApplicant: 'Candidat inconnu',
                noPublicProfileSnapshotAttached: 'Aucun aperçu de profil public n’est joint.',
                noHeadlineProvided: 'Aucun titre fourni.',
                featuredWork: 'Travaux mis en avant',
                shortlistApplication: 'Présélectionner la candidature',
                acceptApplication: 'Accepter la candidature',
                rejectApplication: 'Refuser la candidature',
                viewFullProfile: 'Voir le profil complet',
            },
        },
        table: {
            project: 'Projet',
            role: 'Rôle',
            status: 'Statut',
            actions: 'Actions',
        },
        actions: {
            viewProject: 'Voir le projet',
            viewApplication: 'Voir la candidature',
        },
        invites: {
            empty: 'Aucun rôle de projet sur invitation ne vous attend pour le moment.',
            fallbackProjectTitle: 'Invitation de projet',
            invitedBy: 'Invité par',
            invitedByLabel: 'Invité par :',
            invitationStatus: 'Statut de l’invitation',
            projectStatus: 'Statut du projet',
            visibility: 'Visibilité',
            sent: 'Envoyé',
        },
        applications: {
            empty: 'Vous n’avez postulé à aucun rôle de projet pour le moment.',
            fallbackProjectTitle: 'Candidature de projet',
            ownedBy: 'Propriété de',
            ownerLabel: 'Propriétaire :',
            applicationStatus: 'Statut de la candidature',
            projectStatus: 'Statut du projet',
            visibility: 'Visibilité',
            submitted: 'Soumis',
            message: 'Message',
            noNote: 'Aucune note jointe.',
        },
        createForm: {
            createProject: 'Créer un projet',
            editProject: 'Modifier le projet',
            updateProject: 'Mettre à jour le projet',
            saveProject: 'Enregistrer le projet',
            create: 'créer',
            update: 'mettre à jour',
            projectNotFound: 'Projet introuvable.',
            ownerOnlyEdit: 'Seul le propriétaire du projet peut modifier ce projet.',
            projectBrief: 'Brief du projet',
            projectBriefDescription: 'Définissez les détails clés de la collaboration et la manière dont les créatifs la découvrent.',
            editDescription: 'Mettez à jour le brief du projet, les paramètres de disponibilité et les règles de collaboration.',
            createDescription: 'Publiez un brief de collaboration ciblé sans l’imposer à la structure de la chorale.',
            projectTitle: 'Titre du projet',
            projectTitlePlaceholder: 'Groupe session du dimanche, appel BGV studio, casting production de Pâques',
            projectDescription: 'Description du projet',
            projectDescriptionPlaceholder: 'Décrivez le gig, le style, les attentes de répétition et ce que les candidats doivent savoir.',
            projectType: 'Type de projet',
            selectProjectType: 'Sélectionnez un type de projet',
            location: 'Lieu',
            locationPlaceholder: 'Lagos, Abuja, À distance, Londres',
            country: 'Pays',
            countryPlaceholder: 'Nigéria, États-Unis, Royaume-Uni',
            compensationDetails: 'Détails de rémunération',
            selectCompensationDetails: 'Sélectionnez les détails de rémunération',
            projectSettings: 'Paramètres du projet',
            projectSettingsDescription: 'Définissez comment les créatifs découvrent le projet et le niveau d’engagement attendu.',
            visibility: 'Visibilité',
            visibilityDescription: 'Contrôlez si ce projet est public.',
            public: 'Public',
            private: 'Privé',
            engagementMode: 'Mode de collaboration',
            engagementModeDescription: 'Choisissez comment les collaborateurs participent.',
            remote: 'À distance',
            physical: 'Présentiel',
            hybrid: 'Hybride',
            compensation: 'Rémunération',
            compensationDescription: 'Définissez si cette opportunité est rémunérée ou non.',
            paid: 'Payé',
            unpaid: 'Non payé',
            projectBudget: 'Budget du projet',
            projectBudgetDescription: 'Définissez un plafond de budget global pour les rôles rémunérés afin de suivre les engagements.',
            totalBudget: 'Budget total',
            applicationAccess: 'Accès aux candidatures',
            applicationAccessDescription: 'Choisissez si le projet accepte les candidatures ouvertes ou uniquement sur invitation.',
            open: 'Ouvert',
            inviteOnly: 'Sur invitation',
            projectStatus: 'Statut du projet',
            projectStatusDescription: 'Contrôlez si le projet commence en brouillon, s’ouvre aux candidatures ou passe en revue.',
            rolesNeeded: 'Rôles recherchés',
            rolesNeededDescription: 'Ajoutez les postes à pourvoir puis définissez les règles de candidature pour chaque rôle.',
            roleN: 'Rôle {{index}}',
            done: 'Terminé',
            remove: 'Retirer',
            pluralSuffix: 's',
            openApplication: 'Candidature ouverte',
            edit: 'Modifier',
            roleType: 'Type de rôle',
            selectRole: 'Sélectionnez un rôle',
            quantity: 'Quantité',
            category: 'Catégorie',
            chooseRoleTypeHint: 'Choisissez un type de rôle pour déduire la catégorie',
            openApplicationDescription: 'Décidez si ce rôle est visible par tous ou uniquement par les créatifs invités.',
            roleBudget: 'Budget du rôle',
            roleBudgetDescription: 'Définissez le budget de {{type}} pour ce rôle.',
            payment: 'paiement',
            revenueSharePercentage: 'Pourcentage de partage des revenus',
            minimumBudget: 'Budget minimum',
            budget: 'Budget',
            maximumBudget: 'Budget maximum',
            roleNotes: 'Notes du rôle',
            roleNotesPlaceholder: 'Attentes d’audition, exigences stylistiques, matériel, disponibilités requises.',
            addRole: 'Ajouter un rôle',
            toast: {
                projectUpdated: 'Projet mis à jour avec succès',
                projectCreated: 'Projet créé avec succès',
                saveFailed: 'Impossible de {{action}} le projet',
            },
        },
        projectDetail: {
            ownerOnlyBudget: 'Seul le propriétaire du projet peut gérer le budget.',
            ownerOnlyApplications: 'Seul le propriétaire du projet peut examiner les candidatures ici.',
            ownerOnlyInvites: 'Seul le propriétaire du projet peut gérer les invitations ici.',
            common: {
                collaborator: 'Collaborateur',
                compensation: 'Rémunération',
                updated: 'Mis à jour',
                view: 'Voir',
                submitted: 'Soumis',
                reviewed: 'Révisé',
                message: 'Message',
                noMessage: 'Aucun message joint.',
                portfolio: 'Portfolio',
                openPortfolio: 'Ouvrir le portfolio',
                auditionMedia: 'Média d’audition',
                openAuditionMedia: 'Ouvrir le média d’audition',
                socialMedia: 'Réseau social',
                openProfile: 'Ouvrir le profil',
                auditionPreview: 'Aperçu de l’audition',
                reviewNotes: 'Notes de révision',
            },
            budget: {
                breadcrumbTitle: 'Budget',
                onlyPaid: 'La gestion du budget est disponible uniquement pour les projets payants.',
                enterValidAmount: 'Entrez un montant valide non négatif.',
                updated: 'Budget du projet mis à jour.',
                updateFailed: 'Impossible de mettre à jour le budget du projet',
                settingsTitle: 'Paramètres du budget',
                settingsSubtitle: 'Définissez le budget du projet et suivez les engagements de rôle avant d’ajouter de nouveaux rôles payants.',
                projectBudget: 'Budget du projet',
                enterTotalBudget: 'Entrez le budget total',
                currency: 'Devise',
                saveBudget: 'Enregistrer le budget',
                snapshotTitle: 'Aperçu du budget',
                notSet: 'Non défini',
                committed: 'Engagé',
                remaining: 'Restant',
                overrun: 'Les engagements dépassent le budget de {{amount}}.',
            },
            agreements: {
                breadcrumbTitle: 'Accords',
                title: 'Accords',
                ownerSubtitle: 'Gérez le financement en un seul paiement pour tous les accords éligibles.',
                viewerSubtitle: 'Consultez votre rémunération et l’avancement du paiement pour ce projet.',
                noEligibleFunding: 'Aucun accord éligible au financement.',
                mixedCurrencies: 'Les accords éligibles ont des devises mixtes et ne peuvent pas être financés en un seul paiement.',
                fundingInitialized: 'Financement du projet initialisé.',
                fundingInitFailed: 'Impossible d’initialiser le financement du projet',
                onlyPaid: 'Ce projet n’est pas configuré pour des accords de rémunération payante.',
                fundEligible: 'Financer les accords éligibles',
                openMembers: 'Ouvrir les membres',
                confirmWithSummary: 'Cela lancera un paiement pour {{summary}}. Continuer ?',
                confirmDefault: 'Cela lancera un paiement pour tous les accords éligibles. Continuer ?',
                continue: 'Continuer',
                noneAssigned: 'Aucun accord de rémunération ne vous est encore attribué.',
                addPayoutPrompt: 'Ajoutez un compte de paiement pour recevoir les transferts lorsque cet accord est traité.',
                setupPayout: 'Configurer le compte de paiement',
                withdrawalLabel: 'Retrait :',
                withdrawalRequested: 'Demandé',
                withdrawalPending: 'Demande en attente',
                payoutSetupRequired: 'Configuration du compte de paiement requise',
            },
            agreementDetail: {
                breadcrumbTitle: 'Détail de l’accord',
                agreementTitle: 'Accord #{{id}}',
                detailsLoadFailed: 'Impossible de charger les détails de l’accord.',
                payee: 'Bénéficiaire',
                compensation: 'Rémunération',
                escrow: 'Séquestre',
                payout: 'Paiement',
                financialActivity: 'Activité financière',
                noFinancialEvents: 'Aucun événement financier enregistré pour le moment.',
                payoutSnapshot: 'Aperçu du paiement',
                gross: 'Brut',
                platformFee: 'Frais de plateforme',
                netPayout: 'Paiement net',
                na: 'N/A',
                fundAgreement: 'Financer l’accord',
                requestRelease: 'Demander la libération',
                refund: 'Rembourser',
                ownerActionsRestricted: 'Les actions du propriétaire sont restreintes. Le paiement progresse seulement après la demande de libération du propriétaire, votre demande de retrait et le traitement administrateur.',
                payoutSetupRequired: 'La configuration du compte de paiement est requise avant que l’administrateur puisse traiter le virement.',
                withdrawalRequestedOn: 'Retrait demandé le {{date}}.',
                requestWithdrawal: 'Demander un retrait',
                confirmReleaseTitle: 'Confirmer la demande de libération',
                confirmReleaseDescription: 'Cela envoie le paiement pour confirmation et traitement par l’administrateur. Les fonds ne sont pas versés instantanément au collaborateur.',
                confirmRefundTitle: 'Rembourser les fonds sous séquestre',
                confirmRefundDescription: 'Les fonds détenus sous séquestre seront marqués comme remboursés et cet accord sera annulé.',
                toast: {
                    notEligibleForFunding: 'Cet accord n’est pas éligible au financement pour le moment.',
                    fundingInitialized: 'Financement initialisé.',
                    initializeFundingFailed: 'Impossible d’initialiser le financement',
                    releaseRequested: 'Demande de libération envoyée. Une confirmation administrateur est requise avant le paiement.',
                    requestReleaseFailed: 'Impossible de demander la libération',
                    escrowRefundProcessed: 'Remboursement du séquestre traité.',
                    processRefundFailed: 'Impossible de traiter le remboursement',
                    withdrawalRequested: 'Demande de retrait envoyée. L’administrateur peut maintenant traiter votre paiement.',
                    requestWithdrawalFailed: 'Impossible de demander le retrait',
                },
            },
            compensationPanel: {
                compensation: 'Rémunération',
                notCreated: 'Non créé',
                noAgreement: 'Aucun accord',
                agreement: 'Accord',
                escrow: 'Séquestre',
                payout: 'Paiement',
                pendingAgreement: 'Accord en attente',
                percentageRevenueShare: '{{percentage}}% de partage des revenus',
                pendingAmount: 'Montant en attente',
                createAgreement: 'Créer un accord',
                viewAgreement: 'Voir l’accord',
                flowHint: {
                    noAgreement: 'Aucun accord n’a encore été créé pour ce collaborateur.',
                    completed: 'Accord terminé et paiement traité.',
                    payoutFailed: 'Le paiement a échoué. Un nouvel essai administrateur est requis.',
                    releaseRequested: 'Libération demandée. En attente du traitement administrateur du paiement.',
                    escrowSyncing: 'Le paiement a été reçu. L’enregistrement de séquestre est en cours de synchronisation.',
                    escrowHeld: 'Les fonds sont retenus en séquestre et prêts pour une demande de libération.',
                    cancelledRefunded: 'L’accord a été annulé et le séquestre remboursé.',
                    awaitingFunding: 'En attente de financement pour faire passer cet accord en séquestre.',
                },
            },
            header: {
                defaultShareTitle: 'Projet VocalCentric',
                defaultShareText: 'Découvrez ce projet sur VocalCentric.',
                projectLinkCopied: 'Lien du projet copié.',
                unableToShareProjectLink: 'Impossible de partager le lien du projet.',
                projectArtAlt: 'Visuel du projet',
                global: 'Global',
                positionsRequested: '{{count}} postes demandés',
                shareProject: 'Partager le projet',
                editProject: 'Modifier le projet',
                tags: {
                    roles: {title: 'Rôles', description: 'Exigences du rôle'},
                    applications: {title: 'Candidatures', description: 'Candidatures du projet'},
                    members: {title: 'Membres', description: 'Collaborateurs acceptés'},
                    budget: {title: 'Budget', description: 'Budget du projet'},
                    invites: {title: 'Invitations', description: 'Gérer les invitations du projet'},
                    agreements: {title: 'Accords', description: 'Suivi de la rémunération'},
                },
            },
            members: {
                breadcrumbTitle: 'Membres',
                title: 'Membres',
                subtitle: 'Consultez les collaborateurs acceptés actuellement actifs sur ce projet.',
                unpaidCollaboration: 'Collaboration non rémunérée',
                pendingAmount: 'Montant en attente',
                compensationAgreementCreated: 'Accord de rémunération créé.',
                createAgreementFailed: 'Impossible de créer l’accord',
                empty: 'Aucun collaborateur accepté n’est actif sur ce projet.',
                assignedCollaborator: 'Collaborateur assigné',
                joined: 'Rejoint',
                agreement: 'Accord',
                manage: 'Gérer',
                createAgreement: 'Créer un accord',
                noAgreementAssigned: 'Aucun accord assigné',
                noAgreement: 'Aucun accord',
            },
            applications: {
                breadcrumbTitle: 'Candidatures',
                title: 'Candidatures',
                subtitle: 'Examinez les candidatures entrantes et concentrez-vous sur l’étape nécessaire.',
                paidHint: 'Les collaborateurs acceptés peuvent être financés depuis l’écran Membres.',
                statusUpdated: 'Candidature {{status}}.',
                updateFailed: 'Impossible de mettre à jour la candidature',
                loadDetailsFailed: 'Impossible de charger les détails de la candidature',
                empty: 'Aucune candidature n’a encore été reçue pour ce projet.',
                noMatchFilter: 'Aucune candidature {{status}} ne correspond à ce filtre.',
                noNote: 'Aucune note jointe.',
                shortlist: 'Présélectionner la candidature',
                accept: 'Accepter la candidature',
                reject: 'Rejeter la candidature',
                viewDetails: 'Voir les détails de la candidature',
                applicant: 'Candidat',
                applicantProfile: 'Profil du candidat',
                closeModalAria: 'Fermer la fenêtre de candidature',
                filters: {
                    all: 'Toutes les candidatures',
                    pending: 'En attente',
                    shortlisted: 'Présélectionnée',
                    accepted: 'Acceptée',
                    rejected: 'Rejetée',
                    withdrawn: 'Retirée',
                },
            },
            applicationDetail: {
                breadcrumbTitle: 'Détail de la candidature',
                notFound: 'Candidature du projet introuvable.',
                snapshotTitle: 'Aperçu de la candidature',
                backToApplications: 'Retour aux candidatures',
            },
            overview: {
                breadcrumbTitle: 'Aperçu',
                collaborationRolesLabel: 'Rôles de collaboration',
                applyToCollaborate: 'Postuler pour collaborer',
                applyToCollaborateSubtitle: 'Choisissez le rôle qui correspond à vos compétences et envoyez votre candidature.',
                ownerManagementLabel: 'Gestion propriétaire',
                roleManagement: 'Gestion des rôles',
                roleManagementSubtitle: 'Créez et gérez les rôles de collaboration pour ce projet.',
                addRole: 'Ajouter un rôle',
                inviteOnly: 'Sur invitation',
                inviteOnlyHint: 'Ce rôle accepte les candidatures uniquement sur invitation directe du propriétaire.',
                openSlots: '{{count}} ouverts',
                overrunDriver: 'Principal dépassement',
                inviteParticipants: 'Inviter des participants',
                editRole: 'Modifier le rôle',
                deleteRole: 'Supprimer le rôle',
                selected: 'Sélectionné',
                apply: 'Postuler',
                projectSnapshot: 'Aperçu du projet',
                owner: 'Propriétaire',
                visibility: 'Visibilité',
                applicationAccess: 'Accès aux candidatures',
                projectType: 'Type de projet',
                currentOverrun: 'Dépassement actuel : {{amount}}',
                workspaceBridge: 'Pont d’espace de travail',
                workspaceBridgeSubtitle: 'Liez ce projet à un espace chœur et synchronisez les membres acceptés.',
                syncFundedRequirementPrefix: 'La synchronisation des membres est disponible lorsque tous les accords payants sont marqués comme',
                funded: 'financés',
                syncFundedRequirementSuffix: '.',
                useExistingChoir: 'Utiliser un chœur existant',
                createChoirFromProject: 'Créer un chœur à partir du projet',
                useProjectTitleAsChoirName: 'Utiliser le titre du projet comme nom du chœur',
                choirName: 'Nom du chœur',
                enterChoirName: 'Saisissez le nom du chœur',
                createAndLinkChoir: 'Créer et lier le chœur',
                choirWorkspace: 'Espace chœur',
                selectDirectedChoir: 'Sélectionnez un chœur que vous dirigez',
                linkChoir: 'Lier le chœur',
                membersToSync: 'Membres à synchroniser',
                noActiveMembers: 'Aucun membre actif à synchroniser pour le moment.',
                contributor: 'Contributeur',
                selectAll: 'Tout sélectionner',
                clear: 'Effacer',
                syncSeatsHint: 'Places disponibles : {{available}} • Membres sélectionnés : {{selected}}',
                syncSeatsExceededHint: 'Le nombre de membres sélectionnés dépasse les places disponibles ({{selected}} sélectionnés, {{available}} disponibles). Réduisez la sélection ou ajoutez des places.',
                syncSelectedMembers: 'Synchroniser les membres sélectionnés',
                linkedChoirWorkspace: 'Espace chœur lié : {{choir}}',
                syncedMembers: 'Membres synchronisés : {{count}}',
                linkedNoSyncedYet: 'Liaison réussie. Aucun membre n’a encore été synchronisé.',
                noExtraNotesYet: 'Aucune note supplémentaire pour le moment.',
                viewerState: {
                    label: 'État du visiteur',
                    memberTitle: 'Vous êtes déjà sur ce projet',
                    memberBody: 'Vous êtes actuellement un collaborateur actif sur ce projet.',
                    applicationSubmittedTitle: 'Candidature envoyée',
                    applicationSubmittedBody: 'Votre candidature est en cours de révision. Le propriétaire vous informera bientôt.',
                    inviteAccessTitle: 'Accès par invitation accordé',
                    inviteAccessBody: 'Vous pouvez voir et postuler aux rôles accessibles par invitation.',
                    inviteAccessPrivateBody: 'Vous pouvez accéder à ce projet privé grâce à votre invitation.',
                    limitedAccessTitle: 'Accès limité',
                    limitedAccessBody: 'Ce projet est privé. Vous avez besoin d’une invitation pour postuler.',
                },
                unavailable: {
                    alreadyMember: 'Vous êtes déjà assigné à ce projet.',
                    alreadyApplied: 'Vous avez déjà soumis une candidature pour ce projet.',
                    inviteRequired: 'Ce rôle est sur invitation. Demandez un lien d’invitation au propriétaire.',
                    notAccepting: 'Les candidatures sont actuellement indisponibles car ce projet est {{status}}.',
                    roleUnavailable: 'Ce rôle n’est actuellement pas disponible pour les candidatures.',
                },
                toast: {
                    invalidReelLink: 'Saisissez un lien reel valide avant le chargement.',
                    reelNoPlayableMedia: 'Ce reel ne contient aucun média lisible.',
                    resolveReelFailed: 'Impossible de charger le média reel pour le moment.',
                    chooseRoleBeforeApply: 'Choisissez un rôle avant d’envoyer votre candidature.',
                    applicationSent: 'Candidature envoyée avec succès.',
                    submitApplicationFailed: 'Impossible d’envoyer votre candidature.',
                    selectChoirToLink: 'Sélectionnez un chœur à lier.',
                    choirLinked: 'Chœur lié à l’espace de travail du projet.',
                    linkChoirFailed: 'Impossible de lier l’espace chœur.',
                    enterChoirName: 'Saisissez un nom de chœur avant de créer.',
                    resolveCreatedChoirFailed: 'Impossible de résoudre le chœur nouvellement créé.',
                    choirCreatedAndLinked: 'Chœur créé et lié avec succès.',
                    createAndLinkFailed: 'Impossible de créer et lier l’espace chœur.',
                    linkBeforeSync: 'Liez un espace chœur avant de synchroniser les membres.',
                    selectMembersToSync: 'Sélectionnez au moins un membre à synchroniser.',
                    notEnoughSeatsForSelection: 'Les membres sélectionnés dépassent les places disponibles du chœur. Réduisez la sélection ou ajoutez des places.',
                    membersSynced: 'Membres synchronisés avec succès.',
                    membersSyncedCount: '{{count}} membres synchronisés avec succès.',
                    syncChoirFailed: 'Impossible de synchroniser les membres vers l’espace chœur.',
                    chooseRoleBeforeAdd: 'Choisissez un type de rôle avant d’enregistrer.',
                    roleAdded: 'Rôle ajouté avec succès.',
                    roleUpdated: 'Rôle mis à jour avec succès.',
                    addRoleFailed: 'Impossible d’enregistrer le rôle.',
                    roleDeleted: 'Rôle supprimé avec succès.',
                    deleteRoleFailed: 'Impossible de supprimer le rôle.',
                    enterInviteEmail: 'Saisissez une adresse e-mail invitée valide.',
                },
                applyModal: {
                    title: 'Postuler pour {{role}}',
                    description: 'Partagez le contexte qui aidera le propriétaire à décider rapidement.',
                    openCount: '{{count}} ouverts',
                    messageLabel: 'Message',
                    messagePlaceholder: 'Présentez-vous, votre disponibilité et pourquoi vous correspondez à ce rôle.',
                    portfolioLabel: 'Lien portfolio',
                    portfolioPlaceholder: 'Spotify, YouTube, site web, EPK',
                    auditionMediaSource: 'Source média d’audition',
                    auditionSource: {
                        external: 'URL externe',
                        upload: 'Import VocalCentric',
                        reel: 'URL Reel VocalCentric',
                    },
                    auditionLinkLabel: 'Lien d’audition',
                    auditionLinkPlaceholder: 'Drive, YouTube, Dropbox',
                    uploadReady: 'Import prêt. Le propriétaire pourra prévisualiser ce média dans la revue.',
                    uploadHint: 'Importez un extrait d’audition. VC fournira des manifests HLS/DASH.',
                    reelUrlLabel: 'URL Reel',
                    reelUrlPlaceholder: 'https://.../reel/<reel-id>',
                    loadReel: 'Charger le reel',
                    loading: 'Chargement...',
                    reelLinked: 'Reel lié avec succès. Le propriétaire pourra prévisualiser ce média en ligne.',
                    socialMediaLabel: 'Lien réseau social',
                    socialMediaPlaceholder: 'Instagram, TikTok, X, Facebook',
                    submitApplication: 'Envoyer la candidature',
                    submitting: 'Envoi...',
                    applicationsUnavailable: 'Candidatures indisponibles',
                    close: 'Fermer',
                },
                addRoleModal: {
                    addTitle: 'Ajouter un rôle',
                    editTitle: 'Modifier le rôle',
                    addDescription: 'Ajoutez un nouveau rôle ici. La gestion des invitations se fait dans l’onglet dédié.',
                    editDescription: 'Mettez à jour ce rôle ici. La gestion des invitations se fait dans l’onglet dédié.',
                    roleType: 'Type de rôle',
                    selectRole: 'Sélectionner un rôle',
                    quantity: 'Quantité',
                    applicationAccess: 'Accès aux candidatures',
                    accessOpen: 'Ouvert',
                    accessInviteOnly: 'Sur invitation',
                    category: 'Catégorie',
                    chooseRoleTypeToDeriveCategory: 'Choisissez un type de rôle pour dériver la catégorie',
                    roleBudget: 'Budget du rôle',
                    payment: 'paiement',
                    setBudgetForRole: 'Définissez le budget de {{paymentType}} pour ce rôle.',
                    revenueSharePercentage: 'Pourcentage de partage des revenus',
                    revenueSharePlaceholder: '15',
                    fixedBudget: 'Budget fixe',
                    budgetRange: 'Plage de budget',
                    budget: 'Budget',
                    minimumBudget: 'Budget minimum',
                    maximumBudget: 'Budget maximum',
                    projectedOverrunWarning: 'Avertissement : l’engagement projeté dépasse le budget de {{amount}}.',
                    projectedCommitmentAfterSave: 'Engagement projeté après sauvegarde : {{projected}} sur {{budget}}.',
                    roleNotes: 'Notes du rôle',
                    roleNotesPlaceholder: 'Attentes d’audition, exigences stylistiques, matériel, disponibilités.',
                    saveChanges: 'Enregistrer les modifications',
                    saveRole: 'Enregistrer le rôle',
                },
                inviteModal: {
                    title: 'Inviter à {{role}}',
                    description: 'Envoyez une invitation directe par e-mail pour ce rôle sur invitation.',
                    openCount: '{{count}} ouverts',
                    inviteeEmail: 'E-mail de l’invité',
                    inviteeEmailPlaceholder: 'nom@exemple.com',
                },
                deleteModal: {
                    title: 'Supprimer le rôle',
                    description: 'Retirez {{role}} de ce projet. Cela fonctionne uniquement si aucune place n’est occupée.',
                    deleteRole: 'Supprimer le rôle',
                },
            },
            invites: {
                breadcrumbTitle: 'Invitations',
                title: 'Invitations',
                subtitle: 'Suivez les invitations de rôle en attente et gérez la diffusion propriétaire.',
                revoked: 'Invitation révoquée.',
                resent: 'Invitation renvoyée.',
                updateFailed: 'Impossible de mettre à jour l’invitation',
                chooseRoleAndEmail: 'Choisissez un rôle et saisissez une adresse e-mail.',
                addRoleFirst: 'Ajoutez ce rôle au projet avant d’y inviter des collaborateurs.',
                sent: 'Invitation envoyée avec succès.',
                sendFailed: 'Impossible d’envoyer l’invitation',
                sendInvite: 'Envoyer une invitation',
                sendNewTitle: 'Envoyer une nouvelle invitation',
                sendNewDescription: 'Choisissez un rôle et envoyez une invitation directe par e-mail.',
                chooseRole: 'Choisir un rôle',
                emailPlaceholder: 'createur@exemple.com',
                noMatchFilters: 'Aucune invitation ne correspond aux filtres actuels.',
                empty: 'Aucune invitation de rôle n’a encore été envoyée pour ce projet.',
                resend: 'Renvoyer l’invitation',
                revoke: 'Révoquer l’invitation',
                invitee: 'Invité',
                filters: {
                    all: 'Toutes les invitations',
                    pending: 'En attente',
                    applied: 'Appliquée',
                    revoked: 'Révoquée',
                },
            },
        },
    },
    choir: {
        belongTo: 'J’en fais partie',
        belongToDescription: 'Chœurs dont vous faites partie',
        canJoin: 'Chœurs à rejoindre',
        canJoinDescription: 'Chœurs que vous pouvez rejoindre',
        managedByYou: 'Gérés par vous',
        managedByYouDescription: 'Chœurs que vous gérez',
        headerSubtitle: 'Voyez les chœurs dont vous faites partie et ceux que vous gérez',
        createChoir: 'Créer un chœur',
        emptyStart: 'Qu’attendez-vous ? Vous pouvez lancer votre propre initiative et diriger le groupe !',
        createAChoir: 'Créer un chœur',
        becomeDirector: 'Devenir directeur',
        emptySeenAll: 'Vous avez fait du chemin, vous avez tout vu',
        join: 'Rejoindre',
        noJoinedChoirYet: 'Vous n’avez encore rejoint aucun chœur',
        joinAChoir: 'Rejoindre un chœur',
        requestToJoin: 'Demander à rejoindre le chœur',
        publicPage: {
            feedTab: 'Flux',
            setlistsTab: 'Setlists',
            resourcesTab: 'Ressources',
            joinTab: 'Rejoindre',
            feedTitle: 'Flux public',
            setlistsTitle: 'Setlists publics',
            resourcesTitle: 'Ressources publiques',
            joinTitle: 'Rejoindre ce chœur',
            joinSubtitle: 'Créez un compte ou connectez-vous pour demander l’accès.',
            noPublicPosts: 'Aucune publication publique pour le moment.',
            noPublicSetlists: 'Aucune setlist publique pour le moment.',
            noPublicResources: 'Aucune ressource publique pour le moment.',
            signUpToJoin: 'S’inscrire pour demander l’accès',
            signInToJoin: 'Vous avez déjà un compte ? Connectez-vous',
            joinClosed: 'Ce chœur n’accepte pas les demandes d’adhésion pour le moment.',
            resourceFrom: 'Depuis {{name}}',
            publicProfileLoadFailed: 'Impossible de charger cette page de chœur.',
            feedLoadFailed: 'Impossible de charger le flux public.',
            setlistsLoadFailed: 'Impossible de charger les setlists publiques.',
            postTopic: 'Publier un sujet',
            postTopicPlaceholder: 'Partagez un sujet à propos de ce chœur',
            postTopicFailed: 'Impossible de publier votre sujet. Réessayez.',
            newUpdates: '{{count}} nouvelle(s) mise(s) à jour',
            follow: 'Suivre',
            following: 'Suivi',
            followersCount: '{{count}} abonné(s)',
            followed: 'Chœur suivi.',
            unfollowed: 'Vous ne suivez plus ce chœur.',
            followFailed: 'Impossible de mettre à jour le suivi du chœur.',
        },
        claimPage: {
            eyebrow: 'Annuaire des chœurs',
            title: 'Revendiquer ce chœur',
            description: 'Reliez {{name}} au chœur interne que vous administrez. Un administrateur VocalCentric examinera vos preuves avant toute modification.',
            unavailable: 'Ce chœur public est indisponible ou ne peut plus être revendiqué.',
            signInTitle: 'Connectez-vous pour revendiquer ce chœur',
            signInDescription: 'Choisissez le chœur interne que vous administrez et fournissez la preuve que vous représentez ce chœur.',
            signIn: 'Se connecter',
            signUp: 'Créer un compte',
            noChoirs: 'Créez d’abord un chœur interne, puis revenez ici pour envoyer une revendication.',
            createChoir: 'Créer un chœur',
            choirLabel: 'Votre chœur interne',
            proofUrlLabel: 'URL de preuve (facultatif)',
            proofNoteLabel: 'Note de preuve (facultatif)',
            proofHint: 'Fournissez une URL ou une note. Les revendications sont examinées manuellement.',
            submit: 'Envoyer la revendication',
            submitting: 'Envoi de la revendication...',
            submitFailed: 'Impossible d’envoyer cette revendication.',
            submittedTitle: 'Revendication envoyée',
            submittedDescription: 'Votre revendication est en attente de vérification. La page de l’annuaire redirigera vers votre chœur interne après approbation.',
        },
        planBadge: {
            premium: 'Premium',
            free: 'Gratuit',
        },
        paywall: {
            upgradeRequiredTitle: 'Mise à niveau du chœur requise',
            upgradeRequiredBody: 'Passez ce chœur à un forfait supérieur pour continuer.',
            rehearsalLimitReached: 'Les chœurs gratuits peuvent créer jusqu’à {{limit}} répétitions. Passez ce chœur à un forfait supérieur pour en ajouter davantage.',
            setlistLimitReached: 'Les chœurs gratuits peuvent créer jusqu’à {{limit}} setlists. Passez ce chœur à un forfait supérieur pour en ajouter davantage.',
            memberLimitReached: 'Les chœurs gratuits peuvent avoir jusqu’à {{limit}} membres. Passez ce chœur à un forfait supérieur pour ajouter plus de membres.',
            privateSetlistsRequireUpgrade: 'Les setlists des chœurs gratuits sont publiques. Passez ce chœur à un forfait supérieur pour rendre les setlists privées.',
            profileVisibilityRequiresUpgrade: 'Les profils des chœurs gratuits doivent rester publics sur l’écran de recherche de chœurs. Passez ce chœur à un forfait supérieur pour masquer le profil.',
            rehearsalResourcesExpired: 'Les ressources de répétition gratuites du chœur sont disponibles pendant {{days}} jours. Passez ce chœur à un forfait supérieur pour continuer à utiliser paroles, harmonies personnalisées, diapositives et outils de pratique.',
            harmonyVisibilityRequiresUpgrade: 'Les harmonies personnalisées des chœurs gratuits sont publiques. Passez ce chœur à un forfait supérieur pour utiliser des harmonies privées ou réservées au chœur.',
            rehearsalLimitTitle: 'Limite de répétitions atteinte ({{current}} sur {{limit}})',
            setlistLimitTitle: 'Limite de setlists atteinte ({{current}} sur {{limit}})',
            memberLimitTitle: 'Limite de membres atteinte ({{current}} sur {{limit}})',
            privateSetlistsTitle: 'Les setlists privées nécessitent une mise à niveau',
            rehearsalResourcesExpiredTitle: 'Accès aux ressources expiré',
            profileVisibilityTitle: 'Visibilité du profil verrouillée',
            harmonyVisibilityTitle: 'Visibilité des harmonies verrouillée',
        },
        guide: {
            eyebrow: 'Guide des chœurs',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            join: {
                title: 'Rejoignez un chœur',
                body: 'Choisissez un chœur et envoyez votre demande pour commencer à participer.',
            },
            create: {
                title: 'Créez un chœur',
                body: 'Créez d’abord un chœur, puis ouvrez les répétitions pour lancer le rythme hebdomadaire.',
            },
        },
        rehearsalGuide: {
            eyebrow: 'Guide des répétitions',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            create: {
                title: 'Créez votre première répétition',
                body: 'Lancez une répétition pour faire passer votre chœur de la configuration à une vraie session de travail.',
            },
        },
        setlistsGuide: {
            eyebrow: 'Guide des setlists',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            create: {
                title: 'Créez votre premier setlist',
                body: 'Créez un setlist du chœur pour regrouper les chants avant d’organiser le planning global.',
            },
            rehearsal: {
                title: 'Créez une répétition depuis votre setlist',
                body: 'Transformez ce setlist en vraie répétition pour faire entrer les chants dans une session active du chœur.',
            },
        },
        scheduleGuide: {
            eyebrow: 'Guide du planning',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            serviceDays: {
                title: 'Définissez vos jours de service',
                body: 'Ajoutez d’abord les jours de service afin que VocalCentric puisse construire un planning de chœur exploitable.',
            },
            create: {
                title: 'Créez votre premier planning',
                body: 'Créez le premier planning pour que les membres voient les affectations et les prochains services.',
            },
        },
        membersGuide: {
            eyebrow: 'Guide des membres',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            invite: {
                title: 'Invitez votre premier membre',
                body: 'Invitez une personne pour faire passer le chœur de la configuration à une équipe active.',
            },
        },
        rehearsalSongsGuide: {
            eyebrow: 'Guide des chants de répétition',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            add_song: {
                title: 'Ajoutez des chants à cette répétition',
                body: 'Ajoutez d’abord des chants à la répétition pour donner au chœur une vraie liste de travail.',
            },
            open: {
                title: 'Ouvrez un chant de répétition',
                body: 'Ouvrez le premier chant pour faire passer le chœur de la préparation à la vraie répétition.',
            },
        },
        rehearsalRunthroughGuide: {
            eyebrow: 'Guide de déroulé de répétition',
            resume: 'Reprendre le guide',
            notNow: 'Pas maintenant',
            progress: 'Étape {{completed}} sur {{total}}',
            add_lyrics: {
                title: 'Ajoutez les paroles de ce chant',
                body: 'Ajoutez ou collez d’abord les paroles pour que les membres répètent avec un contenu structuré.',
            },
            upload_reference_audio: {
                title: 'Téléversez un audio de référence',
                body: 'Ajoutez une référence audio adaptée au chœur pour que tout le monde répète sur la bonne version.',
            },
            add_custom_harmony: {
                title: 'Ajoutez une harmonie personnalisée',
                body: 'Créez les parties d’harmonie du chœur pour que les chanteurs répètent sur le véritable arrangement.',
            },
            review_submission: {
                title: 'Passez en revue une soumission',
                body: 'Ouvrez une soumission d’un membre et laissez une direction claire pour boucler la répétition.',
            },
            open_practise: {
                title: 'Ouvrez la pratique de ce chant',
                body: 'Passez à l’onglet pratique pour commencer à enregistrer votre partie sur l’arrangement du chœur.',
            },
            record_practice_section: {
                title: 'Enregistrez votre première section',
                body: 'Enregistrez une section pour démarrer une vraie soumission de pratique au lieu de seulement parcourir le chant.',
            },
            submit_practice: {
                title: 'Envoyez votre pratique',
                body: 'Envoyez votre première prise pour que le directeur puisse la relire et compléter la boucle de répétition.',
            },
        },
        management: {
            detailHeader: {
                rehearsalsTitle: 'Répétitions',
                rehearsalsDescription: 'Chaque samedi',
                setlistsTitle: 'Setlists',
                setlistsDescription: 'Setlists du chœur',
                setlistsExtra: 'Setlists',
                scheduleTitle: 'Planning',
                scheduleDescription: 'Planning du chœur sur une période',
                scheduleExtra: 'Planning',
                membersTitle: 'Membres',
                membersExtra: 'Membres',
                feedsTitle: 'Flux',
                feedsExtra: 'Flux',
                integrateTitle: 'Intégrations',
                integrateDescription: 'Intégrations',
            },
            edit: {
                title: 'Modifier le chœur',
            },
            rehearsals: {
                title: 'Répétitions du chœur',
                createRehearsal: 'Créer une répétition',
                deleteRehearsal: 'Supprimer la répétition',
                empty: 'Vous n’avez créé aucune répétition pour ce chœur',
                noPermission: 'Vous n’avez pas la permission de créer une répétition',
                toast: {
                    deleted: 'Répétition du chœur supprimée',
                    deleteFailed: 'Impossible de supprimer la répétition du chœur',
                    choirIdRequired: 'ID du chœur requis',
                },
            },
            createRehearsal: {
                title: 'Créer une répétition',
                manualMode: 'Mode manuel',
                fromSetlist: 'Depuis un setlist',
                rehearsalTitle: 'Titre de la répétition',
                rehearsalTitleOptional: 'Titre de la répétition (optionnel)',
                shortDescription: 'Description courte',
                shortDescriptionOptional: 'Description courte (optionnel)',
                pasteSetlistLink: 'Coller le lien du setlist',
                pasteSetlistLinkPlaceholder: 'Collez le lien du setlist ici',
                usingSetlist: 'Setlist {{kind}} utilisé',
                choirSetlistKind: 'du chœur',
                personalSetlistKind: 'personnel',
                addSongsPrompt: 'Ajoutez des chansons à la répétition.',
                searchSongsPlaceholder: 'Rechercher des chansons à ajouter à la répétition',
                removeSong: 'Retirer',
                songsInSetlist: 'Chansons du setlist',
                notAvailable: '—',
                external: 'Externe',
                internal: 'Interne',
                addSelectedSong: 'Ajouter le chant',
                additionalResourcesOptional: 'Ressources supplémentaires (optionnel)',
                additionalResourcesPrompt: 'Souhaitez-vous ajouter des ressources supplémentaires ?',
                uploadResources: 'Cliquez pour téléverser des ressources d’apprentissage depuis votre ordinateur ou téléphone',
                date: 'Date',
                from: 'De',
                fromOptional: 'De (optionnel)',
                to: 'À',
                toOptional: 'À (optionnel)',
                virtual: 'Virtual',
                physical: 'Présentiel',
                setReminder: 'Définir un rappel',
                setReminderOptional: 'Définir un rappel (optionnel)',
                selectReminderTime: 'Choisir l’heure du rappel',
                createButton: 'Créer une répétition',
                reminders: {
                    oneHour: '1 heure avant',
                    twoHours: '2 heures avant',
                    threeHours: '3 heures avant',
                    fourHours: '4 heures avant',
                    fiveHours: '5 heures avant',
                    sixHours: '6 heures avant',
                    twelveHours: '12 heures avant',
                    twentyFourHours: '24 heures avant',
                },
                toast: {
                    fillRequired: 'Veuillez remplir tous les champs requis',
                    created: 'Répétition créée avec succès',
                    createFailed: 'Erreur lors de la création de la répétition',
                    choirSetlistNotFound: 'Setlist du chœur introuvable',
                    loadChoirSetlistFailed: 'Impossible de charger le setlist du chœur',
                    setlistNotFound: 'Setlist introuvable',
                    fetchSetlistFailed: 'Impossible de récupérer le setlist',
                },
            },
            setlists: {
                title: 'Setlists du chœur',
                newChoirSetlist: 'Nouveau setlist du chœur',
                empty: 'Aucun setlist du chœur pour le moment.',
                copyLink: 'Copier le lien',
                createRehearsalFromSetlist: 'Créer une répétition depuis ce setlist',
                delete: 'Supprimer',
                linked: 'Lié',
                sharedBy: 'Partagé par {{name}}',
                songCount: '{{count}} chanson(s)',
                updatedDate: 'Mis à jour : {{date}}',
                searchPlaceholder: 'Rechercher par setlist, chant ou métadonnées',
                searchEmpty: 'Aucun setlist du chœur ne correspond à votre recherche.',
                searchFailed: 'Impossible de rechercher les setlists du chœur',
                loadFailed: 'Impossible de charger les setlists du chœur',
                linkCopied: 'Lien copié dans le presse-papiers !',
                deleted: 'Setlist du chœur supprimé',
                deleteFailed: 'Impossible de supprimer le setlist',
                createModal: {
                    title: 'Créer un setlist du chœur',
                    description: 'Commencez par un nom. Vous pourrez ajouter des chants et en faire ensuite une répétition.',
                    nameLabel: 'Nom du setlist',
                    namePlaceholder: 'Setlist de répétition du dimanche',
                    confirm: 'Créer le setlist',
                    creating: 'Création...',
                    toast: {
                        created: 'Setlist du chœur créé',
                        createFailed: 'Impossible de créer le setlist du chœur',
                    },
                },
                manageModal: {
                    title: 'Gérer "{{name}}"',
                    description: 'Consultez les chants de ce setlist du chœur, ajoutez-en et supprimez-en si besoin.',
                    viewOnlyDescription: 'Consultez les chants de ce setlist du chœur.',
                    viewOnlyNotice: 'Seuls les directeurs et modérateurs du chœur peuvent modifier ce setlist.',
                    addSongs: 'Ajouter des chants',
                    shareLink: 'Lien du setlist',
                },
            },
            rehearsalSongs: {
                resourcesTitle: 'Ressources d’apprentissage',
                resourcesDescription: 'Partitions, documents et fichiers audio pour cet ensemble.',
                addResources: 'Ajouter des ressources',
                closeResourceUpload: 'Terminé',
                resourceType: 'Type de ressource',
                documentResource: 'Document',
                scoreResource: 'Partition',
                resourceLabel: 'Libellé de ressource (facultatif)',
                resourceLabelPlaceholder: 'ex. guide d’échauffement',
                uploadDocuments: 'Téléverser des partitions ou documents',
                uploadMusicXml: 'Téléverser une partition MusicXML',
                musicXmlDescription: 'MusicXML, XML ou MXL accepté',
                uploadMidiOptional: 'Téléverser un MIDI (facultatif)',
                uploadDryRun: 'Téléverser un fichier audio',
                dryRunAudio: 'Audio',
                previewResource: 'Prévisualiser la ressource',
                playResource: 'Lire l’audio',
                practiceDryRun: 'Répéter {{name}}',
                openLyrics: 'Ouvrir les paroles de {{title}}',
                openPractice: 'Ouvrir la répétition de {{title}}',
                openPracticeReview: 'Ouvrir la révision de la répétition de {{title}}',
                editDryRun: 'Modifier {{name}}',
                dryRunLyrics: 'Paroles de la répétition',
                dryRunLyricsPlaceholder: 'Ajoutez des paroles ou des notes...',
                listenEntireAudio: 'Écouter tout l’audio',
                listenSegment: 'Écouter un segment',
                segmentStart: 'Début (secondes)',
                segmentEnd: 'Fin (secondes)',
                invalidListenSegment: 'La fin du segment doit suivre son début.',
                deleteResource: 'Supprimer {{name}}',
                deleteResourceConfirm: 'Supprimer {{name}} de cette répétition ?',
                playYouTubeReference: 'Lire {{title}} sur YouTube',
                youtubePlayer: 'Lecteur YouTube',
                viewListenAudit: 'Voir le suivi des écoutes',
                listenAudit: 'Suivi des écoutes',
                listenAuditSummary: '{{listeners}} auditeur(s) • {{listens}} écoute(s)',
                listenAuditDescription: 'Suivez les membres ayant écouté cette répétition.',
                loadingListenAudit: 'Chargement du suivi des écoutes...',
                listenAuditLoadFailed: 'Impossible de charger le suivi des écoutes.',
                noListens: 'Aucune écoute enregistrée pour le moment.',
                nudgeChoir: 'Relancer le chœur',
                nudgingChoir: 'Envoi du rappel...',
                nudgeSent: 'Rappel envoyé à {{count}} membre(s) du chœur.',
                nudgeFailed: 'Impossible d’envoyer le rappel.',
                audioPlaybackUnavailable: 'La lecture audio est indisponible pour le moment.',
                openInNewTab: 'Ouvrir dans un nouvel onglet',
                noResources: 'Aucune ressource d’apprentissage n’a encore été ajoutée.',
                setlistResource: 'Ressource de liste',
                resourceOpenFailed: 'Impossible d’ouvrir cette ressource.',
                addSetlists: 'Ajouter des listes',
                addSetlistsDescription: 'Joignez les chants et ressources de listes du chœur.',
                addSelectedSetlists: 'Ajouter les listes sélectionnées',
                addingSetlists: 'Ajout des listes...',
                setlistsLoadFailed: 'Impossible de charger les listes.',
                setlistsAdded: 'Listes ajoutées à la répétition',
                setlistsAddFailed: 'Impossible d’ajouter les listes.',
                noSetlistsAvailable: 'Toutes les listes disponibles sont déjà jointes.',
                additionalSongs: 'Chansons supplémentaires',
                expandSetlist: 'Développer {{name}}',
                collapseSetlist: 'Réduire {{name}}',
                songsInSetlist: '{{count}} chansons',
                noSongsInSetlist: 'Aucune chanson dans cette liste.',
                savingResources: 'Enregistrement des ressources...',
                resourcesSaved: 'Ressources de répétition mises à jour',
                resourcesSaveFailed: 'Échec de la mise à jour des ressources',
                title: 'Chansons de répétition',
                addSong: 'Ajouter un chant',
                addToRehearsal: 'Ajouter à la répétition',
                startRehearsal: 'Démarrer la répétition',
                startingRehearsal: 'Démarrage de la répétition',
                deleteConfirm: 'Supprimer cette chanson de la répétition ?',
                moveSongUp: 'Monter la chanson',
                moveSongDown: 'Descendre la chanson',
                songActions: 'Actions pour {{title}}',
                currentSongSettings: 'Tonalité : {{key}} • Cible : {{target}}',
                noKeySet: 'Non définie',
                entireSong: 'Chanson entière',
                openCustomHarmonies: 'Harmonies personnalisées',
                songSettings: 'Réglages de la chanson',
                songSettingsDescription: 'Définissez les détails de répétition pour {{title}}.',
                songKey: 'Tonalité',
                songLabel: 'Libellé de répétition',
                songLabelPlaceholder: 'ex. Reprise ou Offrande',
                listenTarget: 'Cible d’écoute',
                youtubeReference: 'Référence YouTube',
                deleteSong: 'Supprimer la chanson',
                savingSettings: 'Enregistrement...',
                settingsNoChanges: 'Aucun réglage n’a changé.',
                settingsSaved: 'Réglages de la chanson mis à jour.',
                settingsPartiallySaved: 'Certains réglages n’ont pas pu être mis à jour.',
                settingsSaveFailed: 'Impossible de mettre à jour les réglages.',
                toast: {
                    removed: 'Chanson supprimée de la répétition',
                    removeFailed: 'Impossible de supprimer la chanson',
                    choirIdRequired: 'ID du chœur requis',
                    reorderFailed: 'Impossible de réorganiser les chansons de la répétition',
                },
            },
            members: {
                title: 'Membres {{seatCount}} sur {{maxSeatCount}}',
                addSeats: 'Ajouter des places',
                manageSharedSeats: 'Partager des places',
                redeemSharedSeats: 'Utiliser un code de place',
                addMember: 'Ajouter un membre',
                addMembersPage: 'Ajouter des membres',
                searchPlaceholder: 'Rechercher des membres',
                searchEmpty: 'Aucun membre ne correspond à votre recherche.',
                actions: 'Actions',
                tabs: {
                    all: {
                        title: 'Tous',
                        description: 'Membres actuels du chœur',
                    },
                    invite: {
                        title: 'Invités',
                        description: 'Membres invités dans le chœur',
                    },
                    requests: {
                        title: 'Demandes',
                        description: 'Demandes pour rejoindre le chœur',
                    },
                },
                empty: {
                    members: 'Aucun membre dans votre groupe pour le moment, pourquoi ne pas inviter du renfort 🙂',
                    invitations: 'Aucune invitation en attente pour le moment, pourquoi ne pas inviter du renfort 🙂',
                    requests: 'Aucune demande en attente pour le moment, pourquoi ne pas inviter du renfort 🙂',
                    inviteCta: 'Inviter un nouveau membre',
                },
                invitations: {
                    fetchFailed: 'Impossible de récupérer les invitations',
                    deleted: 'Invitation supprimée',
                    deleteFailed: 'Impossible de supprimer l’invitation',
                    resent: 'Invitation renvoyée',
                    resendFailed: 'Impossible de renvoyer l’invitation',
                },
                badges: {
                    awarded: 'Badge attribué avec succès',
                    awardButton: 'Attribuer le badge',
                    confirmation: 'Êtes-vous sûr de vouloir attribuer le badge {{type}} à cet utilisateur ?',
                    typeLabel: 'Badge {{type}}',
                },
            },
            integrations: {
                title: 'Outils',
                connect: 'Connecter',
                platforms: {
                    whatsapp: {
                        name: 'WhatsApp',
                        description: 'Application de messagerie populaire pour messages et groupes.',
                        toast: 'Connecter WhatsApp',
                    },
                    calendar: {
                        name: 'Calendrier',
                        description: 'Connectez votre calendrier pour synchroniser événements et rappels.',
                        toast: 'Connecter le calendrier',
                    },
                    telegram: {
                        name: 'Telegram',
                        description: 'Application de messagerie pour canaux et groupes.',
                        toast: 'Connecter Telegram',
                    },
                },
            },
            feeds: {
                loadFailed: 'Échec du chargement du flux du chœur :',
                emptyTitle: 'Aucun flux pour le moment',
                emptyDescription: 'Ton groupe est un peu calme, il faut les motiver !',
                startPractising: 'Commencer à pratiquer',
                loadMore: 'Charger plus de publications',
                newUpdates: '{{count}} nouvelle(s) mise(s) à jour',
                log: {
                    normalizedFeeds: 'Flux normalisés :',
                },
                comment: {
                    placeholder: 'Écrire un commentaire',
                    post: 'Publier',
                    logPost: 'Publication du commentaire',
                },
                composer: {
                    placeholder: 'Partagez une mise à jour avec votre chœur',
                    internal: 'Membres uniquement',
                    public: 'Public uniquement',
                    both: 'Membres et public',
                    post: 'Publier',
                },
                mentions: {
                    loading: 'Chargement des personnes...',
                    empty: 'Personne à mentionner',
                },
                references: {
                    loading: 'Chargement des références...',
                    empty: 'Aucune setlist ou répétition trouvée',
                },
                engagement: {
                    like: 'J’aime',
                    likeWithCount: 'J’aime ({{count}})',
                    comment: 'Commenter',
                    noComments: 'Aucun commentaire pour le moment.',
                    loadingComments: 'Chargement des commentaires...',
                    loadingReplies: 'Chargement des réponses...',
                    viewReplies: 'Voir les réponses ({{count}})',
                    viewMoreComments: 'Voir plus de commentaires',
                    viewMoreReplies: 'Voir plus de réponses',
                    hideReplies: 'Masquer les réponses',
                    reply: 'Répondre',
                    replyPlaceholder: 'Écrire une réponse',
                    posting: 'Publication...',
                    signInToEngage: 'Connectez-vous pour aimer ou commenter.',
                    loadCommentsFailed: 'Impossible de charger les commentaires.',
                    postFailed: 'Impossible de publier le commentaire.',
                    updateLikeFailed: 'Impossible de mettre à jour le like.',
                    deleteFeed: 'Supprimer l’élément du flux',
                    editFeed: 'Modifier l’élément du flux',
                    feedActions: 'Actions du flux',
                    report: 'Signaler',
                    editFeedPrompt: 'Modifier cet élément du flux',
                    editCommentPrompt: 'Modifier ce commentaire',
                    reportFeedConfirm: 'Signaler cet élément aux modérateurs du chœur ?',
                    reportCommentConfirm: 'Signaler ce commentaire aux modérateurs du chœur ?',
                    reportReasonPrompt: 'Sélectionnez le motif qui décrit le mieux le problème.',
                    reportReason: {
                        spam: 'Spam',
                        abuse: 'Contenu abusif',
                        harassment: 'Harcèlement',
                        other: 'Autre',
                    },
                    submitReport: 'Envoyer le signalement',
                    submittingReport: 'Envoi...',
                    reported: 'Signalement envoyé.',
                    alreadyReported: 'Signalé',
                    reportFailed: 'Impossible d’envoyer le signalement.',
                    updated: 'Mis à jour.',
                    updateFailed: 'Impossible d’enregistrer les modifications.',
                    deleteFeedConfirm: 'Supprimer cet élément du flux ?',
                    deleteCommentConfirm: 'Supprimer ce commentaire ?',
                    deleted: 'Supprimé',
                    deleteFailed: 'Suppression impossible.',
                },
                moderation: {
                    openQueue: 'Examiner les signalements',
                    title: 'Signalements du fil',
                    description: 'Examinez les publications et commentaires signalés de ce chœur.',
                    pending: 'En attente',
                    resolved: 'Résolus',
                    dismissed: 'Rejetés',
                    empty: 'Aucun signalement dans cette file.',
                    feed: 'Publication',
                    comment: 'Commentaire',
                    author: 'Auteur : {{email}}',
                    reporter: 'Signalé par : {{email}}',
                    view: 'Voir dans le fil',
                    remove: 'Supprimer le contenu',
                    resolve: 'Résoudre',
                    dismiss: 'Rejeter',
                    removeConfirm: 'Supprimer ce contenu et résoudre tous ses signalements ?',
                    removed: 'Contenu supprimé et signalements résolus.',
                    updated: 'Signalement mis à jour.',
                    loadFailed: 'Impossible de charger les signalements.',
                    updateFailed: 'Impossible de mettre à jour le signalement.',
                    removeFailed: 'Impossible de supprimer le contenu signalé.',
                    previous: 'Précédent',
                    next: 'Suivant',
                },
                card: {
                    welcome: '👋 Bienvenue dans le chœur Refinery !',
                    practiceSubmitted: '🎤 {{name}} vient de soumettre une pratique pour « {{song}} »',
                    practiceApproved: '✅ La pratique de {{name}} a été approuvée pour « {{song}} »',
                    practiceNeedsImprovement: '❗ La pratique de {{name}} pour « {{song}} » doit être améliorée',
                    rehearsalActivity: '📝 {{name}} a créé une répétition pour « {{song}} »',
                    defaultUpdate: '{{name}} a publié une mise à jour',
                    unknownTypeLog: 'Type de flux inconnu : {{type}}',
                    pinned: 'Épinglé',
                },
            },
            schedule: {
                title: 'Planning du chœur',
                document: 'document',
                manageServiceTypes: 'Gérer les types de service',
                manageServiceTypesAria: 'Créer et gérer les types de service',
                setServiceDays: 'Définir les jours de service',
                createSchedule: 'Créer le planning',
                reshuffleAssignments: 'Réorganiser les affectations du planning',
                reshuffleUnavailable: 'Réorganisation indisponible tant qu’aucun planning n’existe',
                shareSchedule: 'Partager le planning',
                shareUnavailable: 'Partage indisponible tant qu’aucun planning n’existe',
                deleteSchedule: 'Supprimer le planning',
                deleteUnavailable: 'Suppression indisponible tant qu’aucun planning n’existe',
                noServiceDays: 'Aucun jour de service défini pour le moment.',
                noScheduleYet: 'Aucun planning créé pour le moment',
                getStarted: 'Commencez par ajouter le premier planning pour ce chœur.',
                addSinger: 'Ajouter un chanteur',
                replaceSinger: 'Remplacer un chanteur',
                chooseReplacementFor: 'Choisissez un remplaçant pour',
                chooseSingerFor: 'Choisissez un chanteur pour',
                leadSection: 'la section lead',
                deleteService: 'Supprimer le service',
                deleteServiceDescription: 'Supprimer {{service}} du planning actuel ? Cela supprime uniquement cette occurrence planifiée.',
                thisService: 'ce service',
                deleting: 'Suppression...',
                removeSingerPrompt: 'Retirer {{singer}} de {{part}} ?',
                reshufflePrompt: 'Réorganiser toutes les affectations actuelles avec les services existants et {{count}} chanteur(s) par partie ?',
                deleteSchedulePrompt: 'Supprimer le planning actuel du chœur ? Cela supprimera semaines, services, leads et affectations BGV générés.',
                toast: {
                    downloadPdfFailed: 'Impossible de télécharger le PDF du planning. Réessayez.',
                    publicLinkReady: 'Lien public du planning prêt',
                    publicLinkFailed: 'Impossible de générer le lien public du planning',
                    scheduleDeleted: 'Planning supprimé',
                    deleteScheduleFailed: 'Impossible de supprimer le planning',
                    reshuffled: 'Planning réorganisé',
                    reshuffleFailed: 'Impossible de réorganiser le planning',
                    serviceTypeUpdated: 'Type de service mis à jour',
                    serviceTypeUpdateFailed: 'Impossible de mettre à jour le type de service',
                    serviceDeleted: 'Service supprimé',
                    serviceDeleteFailed: 'Impossible de supprimer le service',
                    serviceAdded: 'Service ajouté',
                    serviceAddFailed: 'Impossible d’ajouter le service',
                    scheduleUpdated: 'Planning mis à jour',
                    assignmentUpdateFailed: 'Impossible de mettre à jour l’affectation',
                    singerRemoved: 'Chanteur retiré',
                    singerRemoveFailed: 'Impossible de retirer le chanteur',
                },
                components: {
                    lead: 'Lead',
                    noLeadAssigned: 'Aucun lead assigné.',
                    assignLead: 'Assigner un lead',
                    assignLeadComingSoon: 'Assigner un lead (bientôt disponible)',
                    noSingerAssigned: 'Aucun chanteur assigné.',
                    addVoiceSectionSinger: 'Ajouter {{section}}',
                    addVoiceSectionSingerComingSoon: 'Ajouter {{section}} (bientôt disponible)',
                    replaceSinger: 'Remplacer le chanteur',
                    replaceSingerComingSoon: 'Remplacer le chanteur (bientôt disponible)',
                    removeSinger: 'Retirer le chanteur',
                    removeSingerComingSoon: 'Retirer le chanteur (bientôt disponible)',
                    unassignedSinger: 'Chanteur non assigné',
                    assigned: 'Assignés',
                    open: 'Ouverts',
                    total: 'Total',
                    sopranoShort: 'S',
                    altoShort: 'A',
                    tenorShort: 'T',
                    bassShort: 'B',
                    changeServiceTypeTooltip: 'Changer le type de service pour ce service',
                    deleteScheduledServiceTooltip: 'Supprimer ce service planifié',
                    addServiceToWeek: 'Ajouter un service à cette semaine',
                },
                modals: {
                    serviceType: 'Type de service',
                    onlyChoirServiceTypes: 'Seuls les types de service créés pour ce chœur sont disponibles ici.',
                    noChoirServiceTypes: 'Aucun type de service spécifique au chœur disponible.',
                    customName: 'Nom personnalisé',
                    customNamePlaceholder: 'ex. Service spécial improvisé',
                    customNameHint: 'Choisissez un type de service existant ou saisissez un nom ponctuel.',
                    serviceDateTime: 'Date et heure du service',
                    selectExistingServiceType: 'Sélectionner un type de service existant',
                    saveChanges: 'Enregistrer les modifications',
                    saving: 'Enregistrement...',
                    adding: 'Ajout...',
                    addService: {
                        title: 'Ajouter un service',
                        description: 'Ajouter un service à cette semaine.',
                        descriptionWithWeek: 'Ajouter un service à {{week}} ({{start}} – {{end}}).',
                        action: 'Ajouter un service',
                    },
                    updateServiceType: {
                        title: 'Changer le type de service',
                        description: 'Mettre à jour le type de service pour ce service planifié.',
                    },
                    recurrence: {
                        weekly: 'Chaque semaine le {{day}}',
                        biweekly: 'Toutes les deux semaines le {{day}}',
                        monthlyNthWeekday: 'Chaque mois le {{ordinal}} {{day}}',
                        monthlyDayOfMonth: 'Chaque mois le jour {{day}}',
                        annual: 'Chaque année le {{day}} {{month}}',
                        oneTime: 'Unique le {{date}}',
                        none: 'Aucune récurrence configurée',
                    },
                    noEligibleSingers: 'Aucun chanteur éligible disponible pour cette section.',
                    saveSinger: 'Enregistrer le chanteur',
                },
            },
        },
    },
    community: {
        breadcrumbBase: 'Communauté',
        challenges: 'Défis',
        challengesDescription: 'Créez, découvrez et rejoignez des campagnes de défis.',
        vocalPerformances: 'Performances vocales',
        vocalPerformancesDescription: 'Une collection de performances vocales de différents artistes.',
        reels: 'Reels',
        reelsDescription: 'Une collection de courtes vidéos de performances vocales.',
        welcomeTitle: 'Bienvenue dans la communauté',
        welcomeSubtitle: 'Trouvez votre préférence dans différentes couleurs',
        searchChallenges: 'Rechercher des défis',
        noChallengesFound: 'Aucun défi trouvé.',
        challengeTitleLabel: 'Titre du défi',
        entriesLabel: 'Nb d’entrées',
        rewardLabel: 'Récompense du défi',
        challengeLinkCopied: 'Lien du défi copié dans le presse-papiers',
        unableToShareChallenge: 'Impossible de partager le défi pour le moment',
        challengeLeaderboard: {
            breadcrumb: 'Classement du défi',
            breadcrumbNamed: '{{title}} > Classement',
            title: 'Classement',
            subtitle: 'Les meilleures entrées sont classées par score pondéré des modérateurs, puis par likes.',
            empty: 'Aucune donnée de classement pour le moment.',
            entryAlt: 'entrée',
            anonymous: 'Anonyme',
            noCaption: 'Aucune légende',
            scoreLabel: 'Score :',
            votesLikes: '{{votes}} votes · {{likes}} likes',
        },
        challengeEditor: {
            createTitle: 'Créer un défi',
            editTitle: 'Modifier le défi',
            createSubtitle: 'Configurez un nouveau défi pour la communauté.',
            editSubtitle: 'Mettez à jour les métadonnées et le calendrier du défi.',
            ownerOnly: 'Seul le propriétaire du défi peut le modifier.',
            form: {
                titleLabel: 'Titre',
                titlePlaceholder: 'Titre du défi',
                rewardTypeLabel: 'Type de récompense',
                rewardTypeCash: 'Argent',
                rewardTypePrize: 'Prix',
                startDateLabel: 'Date de début',
                endDateLabel: 'Date de fin',
                rewardAmountLabel: 'Montant de la récompense',
                rewardAmountCashPlaceholder: '100',
                rewardAmountPrizePlaceholder: '0',
                rewardCurrencyLabel: 'Devise de la récompense',
                entryTypeLabel: 'Type d’entrée',
                entryTypeOpen: 'Ouvert',
                entryTypeInviteOnly: 'Sur invitation',
                participationTypeLabel: 'Type de participation',
                participationTypeIndividual: 'Individuel',
                participationTypeChoir: 'Chorale',
                maxParticipantsLabel: 'Participants maximum',
                maxParticipantsPlaceholder: 'Aucune limite',
                minXpLabel: 'XP minimum',
                maxXpLabel: 'XP maximum',
                xpPlaceholder: 'Optionnel',
                descriptionLabel: 'Description',
                descriptionPlaceholder: 'Décrivez le défi',
                rewardDescriptionLabel: 'Description de la récompense',
                rewardDescriptionPlaceholder: 'Détails optionnels de la récompense',
                rulesLabel: 'Règles et directives',
                rulesPlaceholder: 'Règles du défi',
            },
            uploads: {
                promoVideoLabel: 'Téléverser une vidéo promo',
                promoVideoHint: 'Obligatoire. La miniature peut être générée automatiquement depuis cette vidéo.',
                thumbnailLabel: 'Téléverser la miniature du défi',
                thumbnailHint: 'Optionnel. Si absent, la miniature de la vidéo promo sera utilisée.',
                thumbnailPreview: 'Aperçu de la miniature',
                thumbnailAlt: 'Miniature du défi',
            },
            actions: {
                saving: 'Enregistrement...',
                updateChallenge: 'Mettre à jour le défi',
                createChallenge: 'Créer le défi',
            },
            toasts: {
                updated: 'Défi mis à jour avec succès.',
                created: 'Défi créé avec succès.',
                saveFailed: 'Impossible d’enregistrer le défi.',
            },
        },
        challengeComments: {
            title: 'Commentaires de la communauté',
            empty: 'Aucun commentaire communautaire pour le moment.',
            you: 'Vous',
            avatarAlt: 'avatar',
            reply: 'Répondre',
            loading: 'Chargement...',
            hideReplies: 'Masquer les réponses',
            viewReplies: 'Voir les réponses{{suffix}}',
            replyPlaceholder: 'Écrire une réponse...',
            commentPlaceholder: 'Ajouter un commentaire...',
            send: 'Envoyer',
        },
        challengeReviewsModal: {
            title: 'Avis et commentaires',
            communityMember: 'Membre de la communauté',
            avatarAlt: 'avatar',
            moderatorReviewBadge: 'Avis modérateur',
            noPreviewVideo: 'Aucune vidéo de prévisualisation',
            moderatorReviews: 'Avis des modérateurs',
            hide: 'Masquer',
            show: 'Afficher',
            emptyModeratorReviews: 'Aucun avis de modérateur pour le moment',
            voteAndReview: 'Vote et avis modérateur (retour du jury)',
            scoreLabel: 'Score {{score}}%',
            reviewInputPlaceholder: 'Rédiger un avis de modérateur...',
            vote: 'Voter',
            voted: 'Voté',
            voting: 'Vote en cours...',
        },
        reelsComments: {
            title: 'Commentaires',
            empty: 'Aucun commentaire pour le moment',
            avatarAlt: 'avatar',
            loading: 'Chargement...',
            hideReplies: 'Masquer les réponses',
            viewReplies: 'Voir les réponses ({{count}})',
            reply: 'Répondre',
            replyingTo: 'Réponse à @{{username}}...',
            commentPlaceholder: 'Ajouter un commentaire...',
            send: 'Envoyer',
            follow: 'Suivre',
            following: 'Suivi',
            profileFutureFeatures: 'Suivre, Voir le profil (fonctionnalités futures)',
            fetchMoreFailed: 'Échec du chargement de commentaires supplémentaires :',
            fetchFailed: 'Échec du chargement des commentaires :',
            likeUpdateFailed: 'Échec de la mise à jour du like :',
            fetchRepliesFailed: 'Échec du chargement des réponses :',
            replyPostFailed: 'Échec de l’envoi de la réponse :',
            commentPostFailed: 'Échec de l’envoi du commentaire :',
        },
        challengeDetails: {
            title: 'Détails du défi',
            notFound: 'Défi introuvable.',
            reward: 'Récompense',
            entries: 'Participations',
            duration: 'Durée',
            challengeTitle: 'Défi - {{title}}',
            startsIn: 'Ce défi commencera dans :',
            upcomingDescription: 'Ce défi commencera dans {{days}} jour(s). En attendant, invitez vos amis à participer.',
            upcomingAlt: 'Défi à venir',
            mascotAlt: 'Mascotte du défi',
            noCaption: 'Aucune légende',
            noDescription: 'Aucune description fournie.',
            noEntriesYet: 'Aucune participation pour le moment.',
            noRulesSpecified: 'Aucune règle spécifiée par le propriétaire du défi.',
            noReferenceVideo: 'Aucune vidéo de référence fournie.',
            noReviewComment: 'Aucun commentaire d’avis',
            noReviewsAvailable: 'Aucun avis disponible.',
            noModeratorsAssigned: 'Aucun modérateur assigné pour le moment.',
            noDisqualifiedEntries: 'Aucune participation disqualifiée.',
            noModerationLogs: 'Aucun journal de modération pour le moment.',
            noReasonProvided: 'Aucune raison fournie',
            noDetails: 'Aucun détail',
            unknown: 'Inconnu',
            notResolved: 'Non résolu',
            prize: 'Prix',
            challengeMeta: 'Métadonnées du défi',
            creator: 'Créateur : {{creator}}',
            entriesCount: 'Participations : {{count}}',
            moderatorsCount: 'Modérateurs : {{count}}',
            moderatorWeight: 'Poids du modérateur : {{weight}}%',
            moderatorWeightRow: '{{email}} · Poids {{weight}}%',
            resolvedEmail: 'E-mail résolu : {{email}}',
            challengeWindow: 'Fenêtre du défi : {{start}} - {{end}}',
            informationTitle: 'Informations du défi',
            referenceVideo: 'Vidéo de référence',
            openReferenceMedia: 'Ouvrir le média de référence',
            engagementRules: 'Règles d’engagement',
            shareYourChallenge: 'Partagez votre défi',
            shareToGetEntries: 'Partagez le défi pour commencer à recevoir des participations.',
            submitEntryTitle: 'Soumettre une participation',
            submitEntrySubtitle: 'Téléversez votre performance du défi et soumettez-la au classement.',
            uploadEntryVideo: 'Téléverser la vidéo de participation',
            captionOptional: 'Légende (optionnel)',
            captionPlaceholder: 'Parlez de votre participation',
            moderators: 'Modérateurs',
            moderator: 'Modérateur',
            moderatorReviews: 'Avis des modérateurs',
            moderatorReviewComment: 'Commentaire d’avis modérateur',
            entryReviews: 'Avis de la participation',
            voteScore: 'Score du vote : {{score}}%',
            optionalReviewComment: 'Commentaire d’avis optionnel',
            makeReviewPublic: 'Rendre l’avis public',
            disqualifiedEntries: 'Participations disqualifiées',
            moderationActivity: 'Activité de modération',
            activity: 'activité',
            upcomingChallenge: 'Défi à venir',
            expressInterestHint: 'Exprimez votre intérêt pour rester informé et montrer votre intention de participer.',
            interestAlreadyExpressed: 'Intérêt déjà exprimé.',
            interestedUsers: 'Utilisateurs intéressés : {{count}}',
            likes: 'Likes',
            likesCount: '{{count}} likes',
            showLess: 'Afficher moins',
            showMore: '... plus',
            entryDisqualified: 'Cette participation est disqualifiée.',
            viewReviewsAndComments: 'Voir les avis et commentaires',
            assignModeratorsSubtitle: 'Assignez et gérez des co-juges pour ce défi.',
            inviteParticipants: 'Inviter des participants',
            inviteParticipantsSubtitle: 'Invitez des personnes par e-mail ou des chorales par ID.',
            inviteUserEmail: 'E-mail du participant',
            inviteChoirId: 'ID de la chorale',
            enterUsernameOrEmail: 'Entrez un nom d’utilisateur ou un e-mail',
            alreadyVotedOnEntry: 'Vous avez déjà voté sur cette participation.',
            anonymous: 'Anonyme',
            communityMember: 'Membre de la communauté',
            public: 'public',
            private: 'privé',
            scorePrefix: 'Score {{score}}',
            shareJoinText: 'Rejoignez ce défi : {{title}}',
            you: 'Vous',
            actions: {
                submitting: 'Envoi...',
                expressInterest: 'Exprimer son intérêt',
                interestExpressed: 'Intérêt exprimé',
                enterChallenge: 'Participer au défi',
                shareChallenge: 'Partager le défi',
                vote: 'Voter',
                voted: 'Voté',
                editChallenge: 'Modifier le défi',
                manageModerators: 'Gérer les modérateurs',
                leaderboard: 'Classement',
                share: 'Partager',
                resolve: 'Résoudre',
                assigning: 'Attribution...',
                assignModerator: 'Assigner un modérateur',
                inviting: 'Invitation...',
                inviteUser: 'Inviter l’utilisateur',
                inviteChoir: 'Inviter la chorale',
                remove: 'Retirer',
                submitEntry: 'Soumettre la participation',
                submitVote: 'Soumettre le vote',
                disqualify: 'Disqualifier',
                loadReviews: 'Charger les avis',
                submitReview: 'Soumettre l’avis',
            },
            countdown: {
                days: 'Jours',
                hours: 'H',
                minutes: 'Min',
                seconds: 'Sec',
            },
            aria: {
                openLeaderboard: 'Ouvrir le classement',
                openChallengeInformation: 'Ouvrir les informations du défi',
                shareChallenge: 'Partager le défi',
                copyChallengeLink: 'Copier le lien du défi',
                voteOnEntry: 'Voter sur cette participation',
                alreadyVotedOnEntry: 'Vous avez déjà voté sur cette participation',
                likes: 'Likes',
                viewReviewsAndComments: 'Voir les avis et commentaires',
                previousEntry: 'Participation précédente',
                nextEntry: 'Participation suivante',
                submitChallengeEntry: 'Soumettre une participation au défi',
            },
            prompts: {
                disqualifyReason: 'Indiquez la raison de disqualification (min 5 caractères) :',
            },
            toasts: {
                entrySubmitted: 'Participation soumise avec succès.',
                entrySubmitFailed: 'Impossible de soumettre la participation.',
                interestExpressed: 'Intérêt exprimé avec succès.',
                interestFailed: 'Impossible d’exprimer l’intérêt.',
                userNotFound: 'Aucun utilisateur trouvé pour ce nom.',
                userLookupFailed: 'Impossible de trouver l’utilisateur par nom.',
                resolveModeratorFirst: 'Résolvez d’abord une adresse e-mail de modérateur valide.',
                moderatorAssigned: 'Modérateur assigné avec succès.',
                assignModeratorFailed: 'Impossible d’assigner le modérateur.',
                moderatorRemoved: 'Modérateur retiré avec succès.',
                removeModeratorFailed: 'Impossible de retirer le modérateur.',
                inviteCreated: 'Invitation au défi créée avec succès.',
                inviteFailed: 'Impossible de créer l’invitation au défi.',
                enterInviteTarget: 'Saisissez d’abord une cible d’invitation valide.',
                voteSubmitted: 'Vote soumis avec succès.',
                voteFailed: 'Impossible de soumettre le vote.',
                disqualified: 'Participation disqualifiée avec succès.',
                disqualifyFailed: 'Impossible de disqualifier la participation.',
                reviewTooShort: 'Le commentaire d’avis doit contenir au moins 3 caractères.',
                reviewSubmitted: 'Avis de participation soumis.',
                reviewFailed: 'Impossible de soumettre l’avis.',
                linkCopied: 'Lien du défi copié dans le presse-papiers.',
                shareFailed: 'Impossible de partager le défi pour le moment.',
                copyFailed: 'Impossible de copier le lien du défi pour le moment.',
                likeUpdateFailed: 'Impossible de mettre à jour le like pour le moment.',
            },
            entryAlt: 'participation',
            entryAvatarAlt: 'avatar de participation',
            entryByActor: 'Participation #{{entryId}}{{actorPart}}',
            byActor: 'par {{actor}}',
            moderatorSharePrompt: 'Partagez ce défi pour attirer plus de participations.',
        },
        contribution: {
            breadcrumb: 'Contributions > {{title}}',
            unknownTitle: 'Titre inconnu',
            filters: {
                all: 'Tous',
                searchByUsername: 'Rechercher par nom d’utilisateur du contributeur',
                updating: 'Mise à jour',
            },
            empty: {
                needHelp: 'Aucune contribution pour cette partie pour le moment. Besoin d’aide pour avancer ?',
                requestHelp: 'Demander de l’aide pour cette partie',
                beFirst: 'Aucune contribution pour cette partie pour le moment. Soyez le premier à contribuer !',
                submitContribution: 'Soumettre votre contribution',
            },
            pagination: {
                prev: 'Préc.',
                next: 'Suiv.',
                pageOf: 'Page {{page}} sur {{total}}',
            },
            error: {
                generic: 'Une erreur est survenue',
            },
        },
        requests: {
            title: 'Demandes',
            searchBySongTitle: 'Rechercher par titre de chanson',
            loadMore: 'Charger plus',
            filters: {
                all: 'Tous',
            },
            empty: {
                alt: 'Aucune demande',
                description: 'Aucune demande trouvée pour vos filtres.',
                prompt: 'Vous souhaitez demander une partie à la communauté ?',
                cta: 'Demander une contribution',
            },
            error: {
                alt: 'Erreur',
                loadFailed: 'Impossible de charger les demandes',
            },
        },
        requestDetail: {
            comingSoon: 'Les détails de la demande arrivent bientôt.',
            error: {
                generic: 'Une erreur est survenue',
            },
        },
        reelDetails: {
            title: 'Détails du reel',
            invalidId: 'ID de reel invalide. Utilisez un lien de reel au format UUID.',
        },
        reelsFeed: {
            swipeUp: 'Glissez vers le haut',
            clipboardUnsupported: 'API Presse-papiers non prise en charge',
            linkShared: 'Lien partagé avec succès !',
            linkShareFailed: 'Impossible de partager le lien',
            linkCopied: 'Lien copié dans le presse-papiers !',
            linkCopyFailed: 'Impossible de copier le lien',
        },
    },
    marketplace: {
        loadSongsFailed: 'Impossible de charger les chansons de la marketplace',
        noListings: 'Aucune annonce marketplace disponible pour le moment.',
        goBack: 'Retour',
        title: 'Titre',
        artist: 'Artiste',
        access: 'Accès',
        price: 'Prix',
        duration: 'Durée',
        action: 'Action',
        accessPremium: 'Premium',
        accessMasterOnly: 'Master uniquement',
        accessStems: 'Stems',
        premiumPreview: 'Premium / Aperçu',
        buyRent: 'Acheter/Louer',
        orders: {
            loadFailed: 'Impossible de charger les commandes marketplace',
            empty: 'Vous n’avez pas encore de commande marketplace.',
            browseMarketplace: 'Parcourir la marketplace',
            title: 'Mes commandes',
            subtitle: 'Consultez l’activité de paiement marketplace, l’état des paiements et les liens directs vers les chansons débloquées.',
            columns: {
                order: 'Commande',
                status: 'Statut',
                amount: 'Montant',
                date: 'Date',
            },
            unavailable: 'Indisponible',
            viewOrder: 'Voir la commande',
        },
        purchases: {
            loadFailed: 'Impossible de charger les achats marketplace',
            empty: 'Vous n’avez pas encore d’achats marketplace actifs.',
            browseMarketplace: 'Parcourir la marketplace',
            title: 'Mes achats',
            subtitle: 'Chansons déjà débloquées via achat direct, location ou paiement marketplace finalisé.',
            paid: 'Payé',
            owned: 'Acheté',
            rental: 'Location',
            masterOnly: 'Master uniquement',
            stemsIncluded: 'Stems inclus',
            unavailable: 'Indisponible',
            openSong: 'Ouvrir la chanson',
        },
        orderDetail: {
            loadFailed: 'Impossible de charger la commande marketplace',
            notFound: 'Commande marketplace introuvable',
            marketplaceOrder: 'Commande marketplace',
            backToOrders: 'Retour aux commandes',
            openSong: 'Ouvrir la chanson',
            status: 'Statut',
            entitlement: 'Droit d’accès :',
            expires: 'Expire :',
            payment: 'Paiement',
            provider: 'Fournisseur :',
            reference: 'Référence :',
            accessScope: 'Portée d’accès',
            orderSuffix: 'commande',
            detailsTitle: 'Détails de la commande',
            detailsSubtitle: 'Informations de référence pour cette transaction marketplace.',
            orderType: 'Type de commande',
            created: 'Créé le',
            updated: 'Mis à jour le',
            song: 'Chanson',
        },
        orderModal: {
            referenceCopied: 'Référence copiée dans le presse-papiers',
            copyPaymentReferenceAria: 'Copier la référence de paiement',
            copyReference: 'Copier la référence',
        },
        listings: {
            loadFailed: 'Impossible de charger les annonces marketplace',
            updated: 'Annonce marketplace mise à jour.',
            updateFailed: 'Impossible de mettre à jour l’annonce marketplace',
            loadOrdersFailed: 'Impossible de charger les commandes de l’annonce',
            listingForfeited: 'Annonce abandonnée.',
            appealSubmitted: 'Recours envoyé.',
            reportResponseFailed: 'Impossible d’envoyer la réponse au signalement',
            empty: 'Vous n’avez pas encore créé de chansons communautaires éligibles au marketplace.',
            title: 'Mes annonces',
            subtitle: 'Gérez la visibilité marketplace, les prix et le flux de commandes pour vos chansons.',
            table: {
                listing: 'Annonce',
                revenue: 'Revenu',
            },
            stats: {
                activeListings: 'Annonces actives',
                stillDraft: '{{count}} encore en brouillon',
                premiumEnabled: 'Premium activé',
                premiumHint: 'Annonces avec déverrouillage par abonnement',
                revenue: 'Revenu',
                zeroUsd: 'USD 0.00',
                revenueHint: 'Revenus directs marketplace suivis',
                loadedOrders: 'Commandes chargées',
                loadedOrdersHint: 'Commandes vendeur consultées dans cette session',
            },
            buySummary: 'Achat {{price}}',
            rentSummary: 'Location {{price}}{{duration}}',
            notConfigured: 'Non configuré',
            listed: 'Publié',
            processingHint: 'Le traitement en arrière-plan est en cours. L’annonce sera activée une fois prête.',
            noneYet: 'Aucun pour le moment',
            editListing: 'Modifier l’annonce',
            viewOrders: 'Voir les commandes',
            health: {
                processing: 'Traitement',
                ready: 'Prêt',
                reported: 'Signalé',
                draft: 'Brouillon',
                needsAccessPath: 'Chemin d’accès requis',
                premiumOnly: 'Premium uniquement',
                missingRentalDays: 'Jours de location manquants',
                missingBuyPrice: 'Prix d’achat manquant',
                missingRentPrice: 'Prix de location manquant',
            },
            editor: {
                title: 'Modifier l’annonce',
                byline: '{{title}} par {{artist}}',
                processingHint: 'Cette chanson est encore en cours de traitement en arrière-plan. L’annonce reste désactivée jusqu’à la fin de l’empaquetage.',
                songReport: 'Signalement de chanson',
                reportedForReview: 'Signalée pour examen',
                lastReported: 'Dernier signalement {{date}}',
                open: 'ouvert',
                adminRequestedExplanation: 'Un administrateur a demandé une explication pour cette annonce. Vous pouvez envoyer un recours ou abandonner l’annonce.',
                explanationPlaceholder: 'Expliquez pourquoi cette annonce doit rester disponible',
                submitting: 'Envoi...',
                submitAppeal: 'Envoyer le recours',
                forfeitListing: 'Abandonner l’annonce',
                creatorResponseStatus: 'Statut de la réponse du créateur : {{status}}',
                listSong: 'Publier la chanson',
                premiumAccess: 'Accès premium',
                enableSale: 'Activer la vente',
                salePricePlaceholder: 'Prix de vente en unités mineures',
                enableRent: 'Activer la location',
                rentPricePlaceholder: 'Prix de location en unités mineures',
                rentalDurationPlaceholder: 'Durée de location en jours',
                accessScope: 'Portée d’accès',
                currency: 'Devise',
                saving: 'Enregistrement...',
                saveListing: 'Enregistrer l’annonce',
            },
            sellerOrders: {
                title: 'Commandes vendeur',
                fallbackSubtitle: 'Commandes de l’annonce marketplace',
                orders: 'Commandes',
                paidRevenue: 'Revenu encaissé',
                listedScope: 'Portée publiée',
                noneYet: 'Aucun pour le moment',
                empty: 'Aucune commande marketplace pour cette annonce pour le moment.',
            },
        },
        earnings: {
            loadFailed: 'Impossible de charger les revenus marketplace',
            unavailable: 'Les revenus marketplace sont indisponibles pour le moment.',
            title: 'Revenus',
            subtitle: 'Revenus bruts marketplace et royalties créateur pour vos annonces de chansons communautaires.',
            reportingWindow: 'Fenêtre de rapport',
            chart: {
                listings: 'Annonces',
                active: 'Actives',
                premium: 'Premium',
                paidSongs: 'Chansons payantes',
                orders: 'Commandes',
                royalties: 'Royalties',
                series: {
                    listingHealth: 'Santé des annonces',
                    marketplaceActivity: 'Activité marketplace',
                    royaltyEvents: 'Événements de royalties',
                },
            },
            filters: {
                allTime: 'Depuis toujours',
                start: 'Début',
                now: 'Maintenant',
                from: 'De',
                to: 'À',
                apply: 'Appliquer',
                reset: 'Réinitialiser',
            },
            cards: {
                totalEarnings: {
                    title: 'Revenus totaux',
                    multiMarketValue: '{{count}} marchés',
                    singleCurrencyNote: 'Revenu brut marketplace',
                    multiCurrencyNote: 'Revenu direct multi-devises',
                },
                creatorRoyalty: {
                    title: 'Royalty créateur',
                    multiLedgerValue: '{{count}} registres',
                    singleCurrencyNote: 'Votre part de royalties',
                    multiCurrencyNote: 'Part créateur multi-devises',
                },
                totalTracks: {
                    title: 'Titres totaux',
                    note: '{{count}} annonces actives',
                },
                totalEngagement: {
                    title: 'Engagement total',
                    note: '{{orders}} commandes • {{events}} événements de royalties',
                },
                projectContribution: {
                    title: 'Contribution projet',
                    pendingValue: '{{count}} en attente',
                    noPendingValue: 'Aucun paiement en attente',
                    pendingNote: 'Paiement(s) en attente des contributions projet',
                    noPendingNote: 'Aucun paiement de contribution projet en attente de retrait/traitement admin',
                },
            },
            analytics: {
                title: 'Analytique globale',
                subtitle: 'Activité marketplace, santé des annonces et couverture royalties sur la fenêtre sélectionnée.',
            },
            topSongs: {
                title: 'Titres les plus rentables',
                subtitle: 'Leaders de revenus bruts marketplace dans la fenêtre sélectionnée.',
                empty: 'Aucune chanson rentable disponible pour le moment.',
                goToListings: 'Aller à mes annonces',
            },
            table: {
                revenue: 'Revenu',
                orders: 'Commandes',
                openSong: 'Ouvrir {{song}}',
            },
            royalty: {
                title: 'Répartition des royalties créateur',
                subtitle: 'Revenus de part créateur issus des événements de royalties réglés sur la fenêtre sélectionnée.',
                emptyTitle: 'Aucun événement de royalties pour le moment',
                emptyDescription: 'Les entrées de royalties apparaîtront ici une fois les ventes/location payées réglées dans le registre.',
                table: {
                    currency: 'Devise',
                    royalty: 'Royalty',
                    events: 'Événements',
                    eventsCount: '{{count}} événements',
                },
            },
            coverage: {
                title: 'Couverture',
                description: 'Les totaux de royalties incluent déjà les événements réglés de vente/location. Les royalties de streaming apparaîtront dans ce même registre dès émission d’événements de lecture.',
            },
        },
        checkout: {
            successTitle: 'Paiement reçu',
            successDescription: 'Nous vérifions votre commande marketplace et actualisons l’accès.',
            pendingTitle: 'Paiement en attente',
            pendingDescription: 'Le callback de paiement a atteint VocalCentric. Nous attendons l’état final de la commande.',
            failureTitle: 'Paiement non finalisé',
            failureDescription: 'Le flux de paiement ne s’est pas terminé. Vous pouvez réessayer depuis la chanson ou consulter vos commandes.',
            loadStatusFailed: 'Impossible de charger l’état du paiement',
            canceledReason: 'Vous avez fermé le flux de paiement avant la fin.',
            accessExpires: 'Accès expire',
            viewOrders: 'Voir les commandes',
            viewPurchases: 'Voir les achats',
        },
        songDetail: {
            listingDetail: 'Détail de l’annonce',
            notFound: 'Chanson marketplace introuvable',
            loadFailed: 'Impossible de charger la chanson marketplace',
            checkoutInitialized: 'Paiement initialisé',
            checkoutFailed: 'Impossible de démarrer le paiement',
            songReported: 'Chanson signalée',
            reportFailed: 'Impossible de signaler la chanson',
            marketplaceSong: 'Chanson marketplace',
            premiumEligible: 'Éligible premium',
            reported: 'Signalé',
            report: 'Signaler',
            information: 'Informations',
            licensing: 'Licence',
            total: 'Total',
            openInPlayer: 'Ouvrir dans le lecteur',
            previewInPlayer: 'Prévisualiser dans le lecteur',
            openPlayer: 'Ouvrir le lecteur',
            upgrade: 'Mettre à niveau',
            rentNow: 'Louer maintenant',
            buyNow: 'Acheter maintenant',
            unlisted: 'Cette chanson n’est actuellement pas listée sur la marketplace.',
            purchase: 'Achat',
            multitracks: 'MultiTracks',
            masterRental: 'Location Master',
            daysAccess: '{{days}} jours d’accès',
            timedAccess: 'Accès temporaire',
            masterTrack: 'Piste master',
            fullMasterPreview: 'Aperçu master complet',
            masterBuy: 'Achat Master',
            masterStemsBuy: 'Achat Master + Stems',
            permanentAccess: 'Accès permanent',
            permanentFullAccess: 'Accès complet permanent',
            masterOnly: 'Master uniquement',
            masterStems: 'Master + stems',
            included: 'Inclus',
            includedWithPremium: 'Inclus avec Premium',
            alreadyUnlocked: 'Déjà déverrouillé',
            premiumUnlockHint: 'Les utilisateurs premium débloquent automatiquement cette annonce.',
            usageTerms: 'Conditions d’utilisation',
            notes: 'Notes',
            marketplaceAccess: 'Accès marketplace',
            unlocked: 'Déverrouillé',
            previewOnly: 'Aperçu uniquement',
            accessExpiresOn: 'L’accès expire le {{date}}.',
            noTags: 'Aucun tag ajouté pour le moment.',
            timed: 'Temporaire',
            rentalAccess: 'Accès location {{days}}',
            permanentLicenseAccess: 'Accès licence permanent',
            masterPlaybackOnly: 'Lecture master uniquement',
            masterStemsAccess: 'Accès master + stems',
            premiumInclusionAvailable: 'Inclusion premium disponible',
            premiumInclusionDisabled: 'Inclusion premium désactivée',
            sharedPlayerPreviewFlow: 'Flux de prévisualisation via lecteur partagé',
            artworkAlt: 'Pochette de {{song}}',
            metadata: {
                published: 'Publié',
                songTitle: 'Titre de la chanson',
                artistName: 'Nom de l’artiste',
                creator: 'Créateur',
            },
            stems: {
                readyInSharedPlayer: 'Prêt dans le lecteur partagé',
                lockedUntilAccess: 'Verrouillé jusqu’à autorisation d’accès',
                masterOnlyNotice: 'Cette annonce est master-only. Les acheteurs peuvent déverrouiller la piste principale, mais les stems restent masqués.',
                noneAvailable: 'Aucune piste supplémentaire n’est disponible pour cette annonce.',
            },
            reasons: {
                creator: 'Vous avez créé cette chanson, la lecture marketplace est déjà déverrouillée sur votre compte.',
                entitlement: 'Vous avez déjà déverrouillé cette chanson. Ouvrez-la dans le lecteur partagé ou consultez votre historique.',
                premium: 'Incluse dans votre plan premium car le créateur a activé l’accès premium.',
                purchaseRequired: 'Vous pouvez prévisualiser le master maintenant, puis louer ou acheter pour tout débloquer.',
                unlisted: 'Cette chanson n’est pas actuellement listée pour l’accès marketplace.',
                default: 'Les détails d’accès marketplace sont disponibles ci-dessous.',
            },
        },
    },
    notifications: {
        title: 'Notifications',
        subtitle: 'Gérez vos notifications et restez informé des mises à jour importantes.',
        markAllAsRead: 'Tout marquer comme lu',
        empty: 'Aucune notification pour le moment',
        timeAgo: 'il y a {{time}}',
    },
    requestSongs: {
        title: 'Demandes de chansons',
        subtitle: 'Votez pour les chansons que vous souhaitez voir sur la plateforme',
        addSongRequest: 'Ajouter une demande de chanson',
        searchPlaceholder: 'Rechercher des chansons (ex. "Way Maker by Sinach")',
        songTitle: 'Titre de la chanson',
        enterSongTitle: 'Entrez le titre de la chanson',
        artistName: 'Nom de l’artiste',
        enterArtistName: 'Entrez le nom de l’artiste',
        albumName: 'Nom de l’album',
        enterAlbumName: 'Entrez le nom de l’album',
        mediaLink: 'Lien média',
        mediaLinkPlaceholder: 'De préférence Spotify, Apple Music, AudioMac, Youtube',
        thumbnailLink: 'Lien de miniature',
        thumbnailLinkPlaceholder: 'Pochette ou image de couverture',
        save: 'Enregistrer',
        cancel: 'Annuler',
        songRequestCreated: 'Demande de chanson créée',
        songRequestFailed: 'Échec de la demande de chanson',
        tableTitle: 'Titre',
        tableGenres: 'Genres',
        tableVotes: 'Votes',
        tableActions: 'Actions',
        songVotedSuccessfully: 'Chanson votée avec succès',
        songVotingFailed: 'Échec du vote de la chanson',
        notSpecified: 'Non spécifié',
        voted: 'Voté',
        vote: 'Voter',
        iconAlt: 'icône',
    },
    requestRole: {
        title: 'Demande de rôle',
        subtitle: 'Sélectionnez le rôle souhaité pour être présélectionné.',
        applyWhitelisted: 'Postuler pour être whitelisté',
        applyDirector: 'Postuler pour être directeur',
        fillToApply: 'Remplissez correctement pour postuler.',
        noApplicationFound: 'Aucune candidature trouvée',
        goBack: 'Retour',
        goToDashboard: 'Aller au tableau de bord',
        reApply: 'Repostuler',
        uploadHelp: 'Téléchargez une vidéo montrant vos compétences et votre niveau (enseignement/jeu/chant). La durée doit être de 2 à 5 minutes. Cette vidéo servira à évaluer votre niveau vocal.',
        socialMediaPlaceholder: 'Entrez le profil de réseau social *',
        socialMediaHandle: 'Identifiant de réseau social',
        reasonPlaceholder: 'Pourquoi postulez-vous pour ce rôle ? *',
        reason: 'Raison',
        websiteLink: 'Lien du site web',
        websiteLinkOptional: 'Lien du site web (optionnel)',
        apply: 'Postuler',
        cancel: 'Annuler',
        whitelistSubmitted: 'Candidature whitelist envoyée avec succès',
        directorSubmitted: 'Candidature directeur envoyée avec succès',
        status: {
            director: {
                approved: 'Vous êtes déjà approuvé pour être Directeur',
                pending: 'Votre candidature pour être Directeur est encore en attente',
                rejected: 'Votre candidature pour être Directeur a été rejetée',
            },
            whitelisted: {
                approved: 'Vous êtes déjà approuvé pour être whitelisté',
                pending: 'Votre candidature pour être whitelisté est encore en attente',
                rejected: 'Votre candidature pour être whitelisté a été rejetée',
            },
            joinChoir: {
                approved: 'Votre demande pour rejoindre la chorale a été approuvée',
                pending: 'Votre demande pour rejoindre la chorale est encore en attente',
                rejected: 'Votre demande pour rejoindre la chorale a été rejetée',
            },
        },
    },
    rehearsal: {
        all: 'Tous',
        allDescription: 'Toutes les chansons de répétition personnelle',
        rehearsed: 'Répétées',
        rehearsedDescription: 'Chansons répétées',
        new: 'Nouvelles',
        newDescription: 'Nouvelles chansons en répétition',
        startRehearsal: 'Commencer la répétition',
        startingRehearsal: 'Démarrage de la répétition',
        tableTitle: 'Titre',
        tableAlbum: 'Album',
        tableGenre: 'Genre',
        tableVotes: 'Votes',
        tableDuration: 'Durée',
        tableAction: 'Action',
        empty: 'Aucune répétition trouvée pour vous, créez-en une maintenant !',
        loading: 'Chargement...',
        searchToAdd: 'Rechercher musique, artiste et album à ajouter à la répétition',
        generateShareLink: 'Générer un lien de partage',
        chat: {
            noMessages: 'Aucun message de chat',
            typeMessage: 'Tapez un message',
            avatarAlt: 'avatar',
            participantFallback: 'John Doe',
            participants: '{{count}} participants',
        },
        scoreSheet: 'Partition',
        songSlides: {
            selectSlide: 'Sélectionner une diapositive',
        },
        songMeta: {
            artist: 'Artiste',
            writer: 'Auteur',
            label: 'Label',
            theme: 'Thème',
            genre: 'Genre',
            album: 'Album',
            bpm: 'BPM',
            timeSig: 'Mesure',
            duration: 'Durée',
            key: 'Tonalité',
            originalKey: 'Tonalité d’origine',
            rehearsalKey: 'Tonalité de répétition',
            publicDomain: 'Domaine public',
            gospel: 'Gospel',
            na: '__',
            rehearsedBy: 'Répété par',
            votes: '{{count}} votes',
            coverArtAlt: 'Pochette de {{title}}',
        },
        tabs: {
            lyrics: 'Paroles',
            lyricsDescription: 'Paroles de cette chanson',
            slides: 'Slides',
            slidesDescription: 'Slides de cette chanson',
            practice: 'Pratique',
            practiceDescription: 'Pratiquer cette chanson',
            customHarmonies: 'Harmonies personnalisées',
            customHarmoniesDescription: 'Liste des harmonies personnalisées pour cette répétition de chorale',
            reviewPractice: 'Réviser la pratique',
            reviewPracticeDescription: 'Revues de pratique de répétition de chorale',
            practise: 'Pratique',
            practiseDescription: 'Pratique de répétition de chorale',
            addAnotherFile: 'Ajouter un autre fichier',
            noSlides: 'Aucun slide disponible',
            addSlidesToStart: 'Ajoutez des slides à cette chanson pour commencer',
        },
    },
    rehearsalPractice: {
        subtitle: 'Sélectionnez une section, inspectez la prise, relisez la note de coaching et passez à la phrase suivante sans perdre votre position.',
        personalRehearsal: 'Répétition personnelle',
        sectionFeedback: 'Retour de section',
        closeFeedback: 'Fermer le retour',
        previousSection: 'Section précédente',
        nextSection: 'Section suivante',
        takePreview: 'Aperçu de la prise',
        lock: 'Verrou',
        submitted: 'soumis',
        countIn: 'compte',
        playbackOnly: 'Lecture uniquement',
        stopClickPreview: 'Arrêter le clic de prévisualisation',
        previewClick: 'Prévisualiser le clic',
        click: 'Clic',
        singAlongGuide: 'Chanter avec la piste guide',
        recordWithoutGuide: 'Enregistrer sans la piste guide',
        singAlongEnabled: 'Mode chanter avec activé',
        singAlongDisabled: 'Mode chanter avec désactivé',
        pauseTake: 'Mettre en pause la prise',
        playTake: 'Lire la prise',
        viewFeedback: 'Voir le retour',
        stopRecording: 'Arrêter l’enregistrement',
        cancelCountIn: 'Annuler le compte',
        recordTake: 'Enregistrer la prise',
        discardTake: 'Supprimer la prise',
        submitForAiReview: 'Soumettre à la revue IA',
        recommendedNextStep: 'Étape suivante recommandée',
        retryRecording: 'Réessayer l’enregistrement',
        aiNoteTitle: 'Note IA',
        aiNoteFallback: 'Enregistrez une prise pour cette section afin de recevoir un retour ciblé de votre coach VocalCentric.',
        overallScore: 'Score global',
        performanceBreakdown: 'Détail des performances',
        performanceBreakdownSubtitle: 'Ouvrez pour comparer le résumé des métriques et l’analyse radar au même endroit.',
        nextStepRetryFocus: 'Refaites cette prise en vous concentrant sur {{metric}}. {{description}}',
        nextStepDefault: 'Enregistrez ou réenregistrez cette section, puis consultez la note mise à jour avant de passer à la phrase suivante.',
        scoreSummary: {
            strongPass: 'Très bon résultat',
            gettingCloser: 'Vous vous rapprochez',
            needsAnotherTake: 'Nécessite une autre prise',
        },
        status: {
            reviewed: 'Révisé',
            submitted: 'Soumis',
            needsWork: 'À retravailler',
            retry: 'Réessayer',
            awaitingReview: 'En attente de révision',
            notStarted: 'Non commencé',
        },
        sectionNavigator: {
            practiceProgress: 'Progression de la pratique',
            title: 'Navigateur de sections',
            subtitle: 'Accédez à n’importe quelle section, voyez son statut et ouvrez le retour sans quitter la grille.',
            reviewed: 'Révisé',
            pending: 'En attente',
            needsWork: 'À retravailler',
            vocal: 'Voix',
        },
        metrics: {
            pitch: {
                label: 'Justesse',
                description: 'Alignez plus régulièrement vos notes sur la note cible.',
            },
            rhythm: {
                label: 'Rythme',
                description: 'Améliorez votre précision rythmique avec le groove.',
            },
            energy: {
                label: 'Énergie',
                description: 'Contrôlez plus uniformément le volume et le soutien du souffle.',
            },
            chroma: {
                label: 'Chroma',
                description: 'Gardez un centre tonal stable tout au long de la phrase.',
            },
            swass: {
                label: 'SWASS',
                description: 'Travaillez la clarté et la constance du timbre vocal.',
            },
            zcr: {
                label: 'ZCR',
                description: 'Adoucissez les attaques bruitées et la dureté des consonnes.',
            },
        },
    },
    choirRehearse: {
        common: {
            loading: 'Chargement...',
            goBack: 'Retour',
        },
        unsavedLeavePrompt: 'Vous avez des modifications d’harmonies non enregistrées. Voulez-vous vraiment quitter cette page ?',
        sectionKeySaved: 'Tonalité de section mise à jour',
        sectionKeySaveFailed: 'Impossible de mettre à jour la tonalité',
        selectedHarmonyResource: 'Arrangement sélectionné pour la répétition',
        openHarmonyResource: 'Ouvrir l’arrangement',
        harmonyResourceOpenFailed: 'Impossible d’ouvrir l’arrangement sélectionné.',
        dryRun: {
            title: 'Pratique du filage', backToRehearsal: 'Retour à la répétition', audioNotFound: 'Cet audio est introuvable.', lyrics: 'Paroles et notes',
            practiceLoadFailed: 'Impossible de charger les pratiques.', microphoneFailed: 'Le microphone est indisponible.', practiceSubmitted: 'Pratique envoyée', practiceSubmitFailed: 'Impossible d’envoyer la pratique.',
            submissions: 'Pratiques envoyées', submissionProgress: '{{submitted}} membre(s) sur {{total}} ont envoyé', searchMembers: 'Rechercher des membres', filterAll: 'Tous', filterSubmitted: 'Envoyés', filterPending: 'En attente',
            nudgeAll: 'Relancer tous les membres', nudge: 'Relancer', nudgeSent: 'Rappel envoyé à {{count}} membre(s).', nudgeFailed: 'Impossible d’envoyer le rappel.', pending: 'Envoi en attente', noMatchingMembers: 'Aucun membre ne correspond.',
            takes: '{{count}} prise(s)', playbackFailed: 'Lecture de la pratique indisponible.', feedbackPlaceholder: 'Commentaire facultatif', needsImprovement: 'À améliorer', approve: 'Approuver', reviewSaved: 'Évaluation enregistrée', reviewFailed: 'Impossible d’enregistrer l’évaluation.',
            yourPractice: 'Votre pratique', part: 'Partie de chœur', selectPart: 'Sélectionnez votre partie', startRecording: 'Démarrer l’enregistrement', stopRecording: 'Arrêter l’enregistrement', recordAgain: 'Enregistrer une autre prise', discardTake: 'Supprimer la prise', submit: 'Envoyer la pratique', resubmit: 'Renvoyer la pratique', submitting: 'Envoi...',
            status: {pending: 'En attente d’évaluation', approved: 'Approuvée', needs_improvement: 'À améliorer'},
        },
        metadataEditor: {
            editButton: 'Modifier les métadonnées du chant',
            title: 'Modifier les Métadonnées du Chant',
            description: 'Mettez à jour la tonalité, le tempo et la mesure pour cette répétition.',
            tempoRangeError: 'Le tempo doit être compris entre 40 et 240 BPM.',
            timeSignatureFormatError: 'La mesure doit être dans un format valide, par exemple 4/4.',
            partialSaveError: 'Certaines métadonnées n’ont pas pu être enregistrées. Veuillez réessayer.',
            saveSuccess: 'Métadonnées du chant mises à jour',
            saveFailure: 'Échec de la mise à jour des métadonnées du chant',
        },
        lyrics: {
            mixed: 'Mixte',
            solfa: 'Solfa',
            solfaMain: 'Solfa principal',
            solfaTenor: 'Solfa ténor',
            solfaAlto: 'Solfa alto',
            solfaSoprano: 'Solfa soprano',
            chordProgression: 'Progression d’accords',
            rehearsalFallbackTitle: 'Répétition',
            comingSoon: 'Bientôt disponible !',
            referenceAudioUpload: 'Téléverser l’audio',
            referenceAudioReplace: 'Remplacer l’audio',
            referenceAudioRemove: 'Supprimer l’audio',
            referenceAudioSaving: 'Enregistrement de l’audio...',
            referenceAudioUploading: 'Téléversement de l’audio {{percent}}%',
            referenceAudioProcessing: 'Traitement de l’audio...',
            referenceAudioSaveSuccess: 'Audio de référence mis à jour pour cette chorale',
            referenceAudioUploadFailed: 'Échec du téléversement de l’audio de référence',
            referenceAudioRemoveSuccess: 'Audio de référence supprimé',
            referenceAudioRemoveFailed: 'Échec de la suppression de l’audio de référence',
        },
        lyricsEditor: {
            title: 'Modifier le contenu du chant externe',
            description: 'Ajoutez des titres de section et des lignes, puis générez les sections structurées pour enregistrer ce contenu pour cette répétition uniquement.',
            placeholder: 'Ajoutez un titre comme Couplet 1, puis les lignes de paroles en dessous.',
            generate: 'Générer les sections structurées',
            generated: '{{sectionCount}} section(s) générée(s) sur {{lineCount}} ligne(s).',
            noSections: 'Aucune section trouvée. Ajoutez des titres comme Couplet 1 ou Refrain avant de générer.',
            addCta: 'Ajouter des paroles',
            editCta: 'Modifier les paroles',
            emptyState: 'Aucune parole n’a encore été ajoutée pour ce chant externe.',
            addTarget: 'Ajouter {{target}}',
            editTarget: 'Modifier {{target}}',
            emptyStateFor: 'Aucun {{target}} n’a encore été ajouté pour ce chant externe.',
            saveSuccess: 'Paroles mises à jour pour cette répétition',
            saveSuccessFor: '{{target}} mis à jour pour cette répétition',
            saveFailure: 'Échec de la mise à jour des paroles',
        },
        lyricsSync: {
            title: 'Synchroniser les temps du chant externe',
            description: 'Alignez l’audio de répétition avec vos paroles structurées, puis réutilisez ces temps pour le solfa et la progression d’accords de cette répétition.',
            button: 'Synchroniser les temps',
            recommended: 'Recommandé',
            recommendedNote: 'Une fois les paroles principales minutées, ces horodatages seront appliqués à toutes les autres variantes structurées de cette répétition.',
            synced: 'Synchronisé',
            save: 'Enregistrer la synchronisation',
            saveSuccess: 'Temps des paroles synchronisés pour cette répétition',
            saveFailure: 'Échec de la synchronisation des temps des paroles',
        },
        submissions: {
            goToRehearsal: 'Aller à la Répétition',
            empty: 'Aucune soumission pour le moment',
        },
        practicePage: {
            performanceTab: 'Performance',
            recentPerformance: 'Performance récente',
            submitAll: 'Tout soumettre',
            submissionAnalyzing: 'Votre soumission est en cours d’analyse. Vous serez notifié sur votre tableau de bord lorsqu’elle sera prête.',
            performedVocalLabel: 'Voix interprétée :',
            alto: 'Alto',
            slideSheetAlt: 'Feuille de diapositives',
            toasts: {
                noRecordings: 'Aucun enregistrement à téléverser',
                uploadSuccess: 'Enregistrement téléversé avec succès',
                uploadError: 'Erreur lors du téléversement des enregistrements',
            },
            metrics: {
                accuracyTitle: 'Score de précision :',
                accuracyDescription: 'À quel point vous avez interprété les voix avec précision par rapport à l’enregistrement original.',
                pitchTitle: 'Précision de la justesse :',
                pitchDescription: 'À quel point vous avez respecté la justesse des voix originales.',
                timingTitle: 'Timing et rythme :',
                timingDescription: 'Votre capacité à maintenir un bon timing et un bon rythme pendant toute la performance.',
                dynamicRangeTitle: 'Plage dynamique :',
                dynamicRangeDescription: 'Évaluation de votre capacité à exprimer différents niveaux de volume et d’intensité, essentielle pour restituer les nuances des voix originales.',
                noteArticulationTitle: 'Articulation des notes :',
                noteArticulationDescription: 'Retour sur la clarté et la précision de vos notes. C’est important pour les runs et le phrasé.',
                vocalToneTitle: 'Qualité du timbre vocal :',
                vocalToneDescription: 'Évaluation de votre capacité à reproduire le timbre et la couleur vocale attendus pour la partie choisie.',
            },
        },
        reviewEntry: {
            userPracticeTab: 'Pratique de {{username}}',
            toasts: {
                correctionSuccess: 'Correction téléversée avec succès',
                correctionError: 'Erreur lors du téléversement de la correction',
            },
        },
        songListCard: {
            playAlt: 'lire',
            remove: 'Supprimer',
            noHarmoniesForKey: 'Aucune harmonie disponible pour la tonalité {{key}}',
            generateHarmonies: 'Générer des harmonies en {{key}} depuis la tonalité d’origine {{originalKey}}',
            transposeHint: 'Nous utiliserons les parties existantes de {{section}} depuis {{originalKey}} et les transposerons.',
            addHarmonyPart: '+ Ajouter une partie d’harmonie',
            uploadAllForSection: 'Téléverser toutes les parties d’harmonie pour {{section}}',
            moveUp: 'Déplacer la section vers le haut',
            moveDown: 'Déplacer la section vers le bas',
            expand: 'Développer {{section}}',
            collapse: 'Réduire {{section}}',
            reorderFailed: 'Impossible de réorganiser les sections d’harmonie. Veuillez réessayer.',
            deleteSectionTitle: 'Supprimer la section',
            deleteSectionDescription: 'Supprimer toute la section {{section}} et toutes ses parties ? Cette action est irréversible.',
            deleteSectionConfirm: 'Supprimer la section',
            visibility: {
                private: 'Privé',
                choir_only: 'Chœur uniquement',
                public: 'Public',
                mixed: 'Mixte',
            },
        },
        reuseHarmonies: {
            entryTitle: 'Réutiliser les harmonies existantes',
            entryDescription: 'Générez les parties manquantes en {{targetKey}} depuis une autre tonalité enregistrée.',
            title: 'Réutiliser les harmonies existantes',
            description: 'Choisissez la tonalité enregistrée qui générera les parties manquantes en {{targetKey}}.',
            targetKey: 'Tonalité de travail',
            selectSource: 'Sélectionner la tonalité source',
            coverage: '{{parts}} parties dans {{sections}} sections',
            generate: 'Générer les harmonies',
            generating: 'Génération...',
            queued: 'Les harmonies en {{targetKey}} sont en cours de génération',
            alreadyAvailable: 'Toutes les harmonies de cette tonalité sont déjà disponibles',
            failed: 'Impossible de réutiliser les harmonies existantes',
        },
        harmonyLibrary: {
            entryTitle: 'Harmonies de la communauté',
            entryDescription: 'Parcourez les arrangements partagés par d’autres chanteurs et chœurs.',
            title: 'Harmonies de la communauté',
            description: 'Prévisualisez et ajoutez un arrangement aux harmonies personnalisées de ce chœur.',
            search: 'Rechercher des harmonies communautaires',
            searchAction: 'Rechercher',
            retry: 'Réessayer de charger les harmonies communautaires',
            empty: 'Aucune harmonie communautaire pour le moment',
            untitled: 'Arrangement sans titre',
            community: 'Communauté Vocal Centric',
            noKey: 'Sans tonalité',
            preview: 'Aperçu',
            add: 'Ajouter',
            adding: 'Ajout...',
            unlock: 'Déverrouiller',
            added: 'Harmonie ajoutée aux harmonies personnalisées',
            alreadyAdded: 'Cette harmonie figure déjà dans les harmonies personnalisées',
            addFailed: 'Impossible d’ajouter l’harmonie communautaire',
            unlockFailed: 'Impossible de déverrouiller cette harmonie communautaire',
        },
        partRow: {
            midiTag: '• MIDI',
            pickExisting: 'Choisir existant',
            pickExistingOption: '{{name}} ({{section}}) en {{songKey}} {{midiTag}}',
            pauseAudioTooltip: 'Mettre cette piste audio en pause',
            playAudioTooltip: 'Lire cette piste audio',
            pauseAudioAria: 'Mettre en pause la piste audio',
            playAudioAria: 'Lire la piste audio',
            pauseMidiTooltip: 'Mettre cette piste MIDI en pause',
            playMidiTooltip: 'Lire cette piste MIDI',
            pauseMidiAria: 'Mettre en pause la piste MIDI',
            playMidiAria: 'Lire la piste MIDI',
            stopRecordingTooltip: 'Arrêter l’enregistrement de cette partie d’harmonie',
            recordNewTakeTooltip: 'Enregistrer une nouvelle prise audio',
            failedStartRecording: 'Impossible d’accéder au micro. Vérifiez les autorisations du navigateur et utilisez HTTPS.',
            stopRecordingAria: 'Arrêter l’enregistrement',
            recordTakeAria: 'Enregistrer une prise audio',
            uploadTooltip: 'Téléverser un fichier audio ou MIDI',
            uploadAria: 'Téléverser un fichier',
            convertToMidiTooltip: 'Convertir cette prise audio en MIDI éditable',
            convertToMidiAria: 'Convertir l’enregistrement en MIDI',
            undoConvertTooltip: 'Restaurer l’audio d’origine avant la conversion',
            undoConvertAria: 'Annuler la conversion MIDI',
            duplicateMidiTooltip: 'Dupliquer ce MIDI vers une autre partie d’harmonie',
            duplicateMidiAria: 'Dupliquer le MIDI vers une autre partie',
            closeMidiEditorTooltip: 'Fermer l’éditeur MIDI',
            openMidiEditorTooltip: 'Ouvrir l’éditeur MIDI piano',
            collapseMidiEditorAria: 'Réduire l’éditeur MIDI',
            openMidiEditorAria: 'Ouvrir l’éditeur MIDI',
            removePartTooltip: 'Supprimer cette partie d’harmonie',
            removePartAria: 'Supprimer la partie d’harmonie',
            renameTooltip: 'Renommer cette partie d’harmonie transposée',
            renameAria: 'Renommer {{part}}',
            renameSuccess: 'Partie d’harmonie renommée',
            renameFailed: 'Impossible de renommer la partie d’harmonie',
            ready: 'Prêt',
            beats: 'temps',
            bpm: 'BPM',
            clickDuringTake: 'clic pendant la prise',
            countInOnly: 'décompte uniquement',
            clickOff: 'clic désactivé',
            loadingWaveform: 'Chargement de la forme d’onde...',
            align: 'Aligner',
            earlier: 'Plus tôt',
            later: 'Plus tard',
            reset: 'Réinitialiser',
            uploadOrSelectBeforeSave: 'Veuillez téléverser ou sélectionner un fichier pour cette partie avant de sauvegarder.',
            convertingToMidi: 'Conversion de l’audio en mélodie MIDI…',
            deletePartTitle: 'Supprimer la partie d’harmonie',
            deletePartDescription: 'Supprimer {{part}} de cette section ? Cette action est irréversible.',
            deletePartConfirm: 'Supprimer la partie',
            midiEditorTitle: 'Éditeur MIDI',
            midiEditorDescription: 'Éditez et jouez la partie d’harmonie avec plus d’espace.',
            closeMidiEditorAria: 'Fermer l’éditeur MIDI',
            saveMidiChangesTitle: 'Enregistrer les modifications MIDI ?',
            saveMidiChangesDescription: 'Vous avez des modifications MIDI non enregistrées. Enregistrez-les avant de fermer l’éditeur, ou abandonnez-les.',
            keepEditing: 'Continuer l’édition',
            discard: 'Ignorer',
            save: 'Enregistrer',
            recordingSetupTitle: 'Configuration d’enregistrement',
            recordingSetupSubtitle: 'Réglez le clic et le décompte avant d’enregistrer cette partie.',
            closeRecordingSetupAria: 'Fermer la configuration d’enregistrement',
            referenceTrack: 'Piste de référence',
            none: 'Aucun',
            lockTakeToReference: 'Verrouiller la prise sur la référence',
            playReferenceInTake: 'Lire la référence pendant la prise',
            referenceVolume: 'Volume de référence',
            clickMode: {
                off: 'Désactivé',
                'count-in-only': 'Décompte uniquement',
                'count-in-and-record': 'Décompte + prise',
            },
            timeSignature: 'Mesure',
            tempo: 'Tempo',
            countInLabel: 'Décompte',
            bar: 'mesure',
            bars: 'mesures',
            countInOption: '{{bars}} {{unit}} ({{beats}} temps)',
            preview: 'Aperçu',
            previewClickTrack: 'Prévisualiser la piste de clic',
            compoundFeelNote: 'Ressenti composé actif. Le clic regroupe cette mesure en pulsations de noires pointées pour une entrée plus naturelle.',
            referenceModeNote: 'Mode référence actif. Le tempo et la mesure sont verrouillés sur la référence sélectionnée pour garder cette prise alignée.',
            startRecording: 'Démarrer l’enregistrement',
            uploadedPercent: '{{percent}}% téléversé',
            toasts: {
                noClearMelody: 'Aucune mélodie claire détectée. Essayez une prise monophonique plus propre.',
                convertedToMidi: 'Enregistrement converti en MIDI',
                failedConvertToMidi: 'Échec de la conversion de l’enregistrement en MIDI',
                restoredAudio: 'Audio restauré avant la conversion MIDI',
                duplicatedMidi: 'MIDI dupliqué vers {{targetPart}} ({{intervalLabel}})',
                failedDuplicateMidi: 'Échec de la duplication de la partie MIDI',
            },
        },
    },
    setlist: {
        yourSetlists: 'Vos setlists',
        tabs: {
            mine: 'Mes setlists',
            explore: 'Explorer',
        },
        deletedSuccessfully: 'Setlist supprimée avec succès',
        linkCopied: 'Lien copié dans le presse-papiers !',
        songCount: '{{count}} chanson(s)',
        updatedDate: 'Mis à jour : {{date}}',
        empty: 'Vous n’avez encore créé aucune setlist.',
        sharedToChoir: 'Setlist partagée avec la chorale',
        explore: {
            title: 'Explorer les setlists publiques',
            subtitle: 'Découvrez des listes de culte et de performance avec des ressources pratiques d’autres équipes.',
            searchPlaceholder: 'Rechercher des setlists',
            creatorFallback: 'Créateur VocalCentric',
            free: 'Gratuit',
            paid: 'Payant',
            premium: 'Premium',
            mixed: 'Mixte',
            resources: '{{count}} ressource(s)',
            empty: 'Aucune setlist publique trouvée.',
            loadFailed: 'Impossible de charger les setlists publiques',
            access: {
                all: 'Tous les accès',
                free: 'Gratuit',
                paid: 'Payant',
                premium: 'Premium',
                mixed: 'Mixte',
            },
        },
        owned: {
            back: 'Retour aux setlists',
            loadFailed: 'Impossible de charger la setlist',
            notFound: 'Cette setlist est introuvable.',
            personalEyebrow: 'Votre setlist',
            choirEyebrow: 'Setlist de la chorale',
            share: 'Partager la setlist',
            editDetails: 'Modifier les détails',
            setlistName: 'Nom de la setlist',
            nameRequired: 'Saisissez un nom d’au moins deux caractères.',
            scheduledFor: 'Programmée pour',
            editDetailsDescription: 'Mettez à jour le nom, la visibilité, la programmation et le partage.',
            detailsSaved: 'Détails de la setlist enregistrés',
            detailsSaveFailed: 'Impossible d’enregistrer les détails',
            shareLink: 'Lien de partage',
            loadingVideo: 'Chargement de la vidéo…',
            videoUnavailable: 'Impossible de charger cette vidéo.',
            seekBackward15Seconds: 'Reculer de 15 secondes',
            seekForward15Seconds: 'Avancer de 15 secondes',
            playSetlist: 'Lire la setlist',
            nowPlaying: 'Lecture en cours',
            listen: 'Écouter',
            songs: 'Chansons de la setlist',
            addSong: 'Ajouter une chanson',
            addSongDescription: 'Choisissez une source, vérifiez la chanson et ajoutez-la à cette setlist.',
            songRequired: 'Choisissez une chanson et ajoutez son label.',
            songLabel: 'Label de la setlist',
            songSources: {
                search: 'Bibliothèque',
                youtube: 'YouTube',
                public: 'Domaine public',
            },
            playSong: 'Lire la chanson',
            pauseSong: 'Mettre la chanson en pause',
            dockPlayer: 'Ancrer le lecteur',
            noPlayableMedia: 'Aucune vidéo',
            noSongs: 'Aucune chanson ajoutée pour le moment.',
            deleteSongConfirm: 'Retirer cette chanson de la setlist ?',
            listenTarget: 'Objectif d’écoute',
            listenTypes: {
                entire: 'Chanson entière',
                segment: 'Segment',
            },
            listenStart: 'Début',
            listenEnd: 'Fin',
            invalidListenSegment: 'Saisissez un segment d’écoute valide.',
            entireTarget: 'Écouter la chanson entière',
            segmentTarget: 'Écouter de {{start}} à {{end}}',
            prepare: 'Préparer',
            resources: 'Ressources de la setlist',
            resourcesDescription: 'Partitions, documents, liens, stems, pistes de référence et arrangements vocaux groupés pour cette setlist.',
            noResources: 'Aucune ressource ajoutée pour le moment.',
            manageResources: 'Gérer les ressources',
            manageResourcesDescription: 'Créez des ressources individuelles ou des arrangements vocaux groupés et contrôlez leur partage.',
            addResource: 'Ajouter une ressource',
            editResource: 'Modifier la ressource',
            deleteResource: 'Supprimer la ressource',
            deleteResourceConfirm: 'Supprimer cette ressource de la setlist ?',
            resourceType: 'Type de ressource',
            resourceTypes: {
                document: 'Document',
                audio: 'Audio',
                stem: 'Stem',
                chart: 'Partition',
                link: 'Lien',
                other: 'Autre',
                vocal_arrangement: 'Arrangement vocal',
            },
            arrangementEditorDescription: 'Choisissez une chanson, ajoutez des sections et téléversez chaque partie vocale séparément.',
            arrangementSong: 'Chanson',
            selectArrangementSong: 'Sélectionner une chanson',
            arrangementKey: 'Tonalité',
            arrangementKeyOptional: 'Aucune tonalité sélectionnée',
            arrangementSections: 'Sections de l’arrangement',
            sectionName: 'Nom de la section',
            addSection: 'Ajouter une section',
            removeSection: 'Supprimer la section',
            arrangementSectionRequired: 'Ajoutez au moins une section à l’arrangement.',
            arrangementPart: 'Partie vocale',
            selectArrangementPart: 'Sélectionner une partie vocale',
            addPart: 'Ajouter une partie',
            removePart: 'Supprimer la partie',
            arrangementPartRequired: 'Ajoutez au moins une partie vocale à cette section.',
            partAudio: 'Téléverser l’audio de la partie',
            replacePartAudio: 'Remplacer l’audio de la partie',
            arrangementRequired: 'Choisissez une chanson et ajoutez au moins une section avec un fichier audio pour chaque partie.',
            noArrangementParts: 'Aucune partie vocale lisible n’est disponible.',
            selectPart: 'Sélectionner {{part}}',
            resourceTitle: 'Titre',
            resourceDescription: 'Description',
            resourceAccess: 'Accès',
            premiumAccess: 'Abonnés Premium',
            resourceUrl: 'URL de la ressource',
            uploadResource: 'Téléverser la ressource',
            audioFilesSupported: 'MP3, WAV, M4A ou AAC pris en charge',
            documentFilesSupported: 'PDF ou DOCX pris en charge',
            resourcePrice: 'Prix',
            resourceCurrency: 'Devise',
            resourcePublic: 'Afficher cette ressource sur la setlist publique',
            resourceRequired: 'Ajoutez un titre et un fichier ou une URL.',
            resourceSaved: 'Ressource enregistrée',
            resourceSaveFailed: 'Impossible d’enregistrer la ressource',
            resourceDeleted: 'Ressource supprimée',
            resourceDeleteFailed: 'Impossible de supprimer la ressource',
            resourcePreview: 'Aperçu de la ressource',
            audioUnavailable: 'Impossible de charger cet audio.',
            openResourceDescription: 'Cette ressource s’ouvre dans un nouvel onglet.',
            saving: 'Enregistrement…',
            listenAudit: 'Audit d’écoute',
            auditDescription: 'Voyez qui a écouté et quelles chansons retiennent l’attention.',
            auditLoadFailed: 'Impossible de charger l’audit d’écoute',
            loadingAudit: 'Chargement de l’audit…',
            listeners: 'Auditeurs',
            listens: 'Écoutes',
            songsHeard: 'Chansons écoutées',
            noAudit: 'Aucune activité d’écoute enregistrée pour le moment.',
            nudgeMembers: 'Relancer les membres qui n’ont pas écouté',
            sendingNudge: 'Envoi du rappel…',
            nudgeSent: 'Rappel envoyé à {{count}} membre(s)',
            nudgeFailed: 'Impossible d’envoyer le rappel',
        },
        public: {
            fallbackTitle: 'Setlist',
            ogDescription: 'Une setlist sélectionnée sur VocalCentric avec {{count}} chansons.',
            copyShareLink: 'Copier le lien de partage',
            labelPrefix: 'Label :',
            listenOnSpotify: 'Écouter sur Spotify',
            watchOnYoutube: 'Regarder sur YouTube',
            listen: 'Écouter',
            resources: 'Ressources',
            free: 'Gratuit',
            paid: 'Payant',
            premium: 'Premium',
            openResource: 'Ouvrir la ressource',
            unlockResource: 'Débloquer la ressource',
            upgradeForPremium: 'Passer à Premium',
            resourceCheckoutFailed: 'Impossible de démarrer le paiement de la ressource',
        },
    },
    transactions: {
        historyTitle: 'Historique des transactions',
        detailsTitle: 'Détails de la transaction',
        tableDate: 'Date',
        tableOrderNumber: 'Numéro de commande',
        tablePrice: 'Prix',
        viewDetails: 'Voir les détails',
    },
    profile: {
        aboutTitle: 'À propos',
        noSummary: 'Aucun résumé de profil ajouté pour le moment.',
        experience: 'Expérience',
        years: '{{count}} ans',
        notSpecified: 'Non spécifié',
        availability: 'Disponibilité',
        availableForProjects: 'Disponible pour des projets',
        notCurrentlyAvailable: 'Actuellement indisponible',
        location: 'Localisation',
        timezone: 'Fuseau horaire',
        skillsTitle: 'Compétences',
        addSkill: 'Ajouter une compétence',
        noSkills: 'Aucune compétence ajoutée pour le moment.',
        editSkill: 'Modifier la compétence',
        deleteSkill: 'Supprimer la compétence',
        portfolioTitle: 'Portfolio',
        addItem: 'Ajouter un élément',
        noPortfolioItems: 'Aucun élément de portfolio pour le moment.',
        previewMedia: 'Aperçu du média',
        editPortfolioItem: 'Modifier l’élément du portfolio',
        deletePortfolioItem: 'Supprimer l’élément du portfolio',
        previewPortfolioItem: 'Aperçu de {{title}}',
        reviewsTitle: 'Avis',
        reviewsSubtitle: 'Notes et signaux de confiance issus de collaborations précédentes.',
        rating: 'Note',
        reviews: 'Avis',
        completed: 'Terminés',
        repeatHires: 'Réembauches',
        compactReviews: '({{count}} avis)',
        uploading: 'Téléversement {{progress}}%',
        uploadAvatar: 'Téléverser un avatar',
        profileAvatar: 'Avatar du profil',
        defaultHeadline: 'Professionnel créatif sur VocalCentric.',
        shareProfile: 'Partager le profil',
        editProfile: 'Modifier le profil',
        addPortfolioItem: 'Ajouter un élément au portfolio',
        follow: 'Suivre',
        unfollow: 'Ne plus suivre',
        inviteToProject: 'Inviter au projet',
        contact: 'Contacter',
        locationUnavailable: 'Localisation indisponible',
        memberSince: 'Membre depuis {{date}}',
        page: {
            inviteDisabledReason: 'Vous devez avoir au moins un projet dont vous êtes propriétaire pour envoyer des invitations.',
            unavailable: {
                title: 'Profil indisponible',
                needsInitialization: 'Votre profil professionnel n’a pas encore été créé. Créez-le d’abord, puis mettez à jour la visibilité si nécessaire.',
                ineligible: 'Votre compte n’est pas éligible pour gérer un profil professionnel.',
                ownerPrivate: 'Votre profil professionnel est actuellement privé. Rendez-le public pour l’afficher sur cette route.',
                viewerPrivateOrMissing: 'Ce profil professionnel est privé ou n’existe pas.',
            },
            options: {
                profileType: {
                    creative: 'Créatif',
                    owner: 'Propriétaire du projet',
                    both: 'Les deux',
                },
                visibility: {
                    public: 'Public',
                    private: 'Privé',
                },
                skillType: {
                    voice_part: 'Voix',
                    instrument: 'Instrument',
                    role: 'Rôle',
                    specialty: 'Spécialité',
                },
                proficiency: {
                    beginner: 'Débutant',
                    intermediate: 'Intermédiaire',
                    advanced: 'Avancé',
                    expert: 'Expert',
                },
                availability: {
                    'true': 'Disponible pour des projets',
                    'false': 'Indisponible',
                },
            },
            quickInfo: {
                title: 'Infos rapides',
                type: 'Type',
                visibility: 'Visibilité',
                defaultPart: 'Partie par défaut',
            },
            payout: {
                title: 'Comptes de paiement',
                description: 'Utilisés pour les virements de paiement des projets.',
                loading: 'Chargement des comptes de paiement...',
                empty: 'Aucun compte de paiement configuré pour le moment.',
                accountFallback: 'Compte de paiement',
                defaultTag: 'par défaut',
                noAccountNumber: 'Aucun numéro de compte',
                noBankName: 'Aucune banque',
                swiftPrefix: 'SWIFT',
            },
            actions: {
                createProfile: 'Créer le profil',
                makeProfilePublic: 'Rendre le profil public',
                applyForWhitelist: 'Demander la whitelist',
                add: 'Ajouter',
                save: 'Enregistrer',
                close: 'Fermer',
                edit: 'Modifier',
                remove: 'Retirer',
                delete: 'Supprimer',
                copyEmail: 'Copier l’e-mail',
                openEmailApp: 'Ouvrir l’appli e-mail',
                openMedia: 'Ouvrir le média',
            },
            share: {
                fallbackText: 'Voir {{title}} sur VocalCentric.',
            },
            contact: {
                mailSubject: 'Contact du profil VocalCentric : {{name}}',
                mailBody: 'Bonjour {{name}},\n\nJ’ai trouvé votre profil sur VocalCentric et j’aimerais vous contacter.',
            },
            modals: {
                editProfile: {
                    title: 'Modifier le profil',
                    description: 'Mettez à jour les informations d’identité professionnelle et les préférences du portfolio.',
                    headline: 'Accroche',
                    displayNameOverride: 'Nom d’affichage personnalisé',
                    displayNamePlaceholder: 'Comment votre nom doit apparaître publiquement',
                    portfolioSummary: 'Résumé du portfolio',
                    summaryPlaceholder: 'Résumé',
                    profileType: 'Type de profil',
                    timezone: 'Fuseau horaire',
                    selectTimezone: 'Sélectionner un fuseau horaire',
                    visibility: 'Visibilité',
                    availabilityForProjects: 'Disponibilité pour les projets',
                    city: 'Ville',
                    state: 'Région',
                    country: 'Pays',
                    selectCountry: 'Sélectionner un pays',
                    experienceYears: 'Expérience (années)',
                    experiencePlaceholder: 'Années d’expérience',
                    websiteUrl: 'URL du site web',
                    instagramUrl: 'URL Instagram',
                    youtubeUrl: 'URL YouTube',
                    tiktokUrl: 'URL TikTok',
                    linkedinUrl: 'URL LinkedIn',
                    urlPlaceholder: 'https://...',
                    primaryCategory: 'Catégorie principale',
                    selectCategory: 'Sélectionner une catégorie',
                    currency: 'Devise',
                    selectCurrency: 'Sélectionner une devise',
                    minRate: 'Tarif min',
                    maxRate: 'Tarif max',
                    numberPlaceholder: '0',
                    rateNotes: 'Notes tarifaires',
                    notesPlaceholder: 'Notes',
                },
                payoutAccount: {
                    editTitle: 'Modifier le compte de paiement',
                    addTitle: 'Ajouter un compte de paiement',
                    description: 'Ajoutez les informations de virement bancaire utilisées pour les paiements.',
                    country: 'Pays',
                    accountName: 'Nom du compte',
                    accountNamePlaceholder: 'Nom du titulaire',
                    accountNumber: 'Numéro de compte',
                    accountNumberPlaceholder: '0123456789',
                    bankName: 'Nom de la banque',
                    bankNamePlaceholder: 'Nom de la banque',
                    loadingBanks: 'Chargement des banques...',
                    selectBank: 'Sélectionner une banque',
                    swiftCode: 'Code SWIFT (optionnel)',
                    swiftCodePlaceholder: 'Pour les virements internationaux',
                    defaultLabel: 'Définir par défaut',
                    saving: 'Enregistrement...',
                    save: 'Enregistrer',
                    toast: {
                        requiredFields: 'Le pays, le nom du compte, le numéro de compte et le nom de la banque sont requis.',
                        selectBank: 'Veuillez sélectionner une banque dans la liste.',
                        updated: 'Compte de paiement mis à jour.',
                        added: 'Compte de paiement ajouté.',
                        saveFailed: 'Impossible d’enregistrer le compte de paiement',
                    },
                },
                skill: {
                    editTitle: 'Modifier la compétence',
                    addTitle: 'Ajouter une compétence',
                    skillType: 'Type de compétence',
                    skillName: 'Nom de la compétence',
                    skillNamePlaceholder: 'Nom de la compétence',
                    proficiency: 'Niveau',
                    yearsExperience: 'Années d’expérience',
                    numberPlaceholder: '0',
                    markPrimary: 'Marquer comme compétence principale',
                },
                portfolio: {
                    editTitle: 'Modifier l’élément du portfolio',
                    addTitle: 'Ajouter un élément au portfolio',
                    title: 'Titre',
                    projectName: 'Nom du projet',
                    projectNamePlaceholder: 'Nom du projet',
                    rolePerformed: 'Rôle effectué',
                    rolePlaceholder: 'Rôle',
                    category: 'Catégorie',
                    mediaUrl: 'URL du média',
                    thumbnailUrl: 'URL de la miniature',
                    externalUrl: 'URL externe',
                    urlPlaceholder: 'https://...',
                    creditedArtist: 'Artiste crédité',
                    artistNamePlaceholder: 'Nom de l’artiste',
                    yearCompleted: 'Année de réalisation',
                    yearPlaceholder: '2026',
                    featureThisWork: 'Mettre ce travail en avant',
                    description: 'Description',
                    describeWorkPlaceholder: 'Décrivez ce travail',
                },
                invite: {
                    title: 'Inviter au projet',
                    description: 'Choisissez un de vos projets et un rôle ouvert pour envoyer une invitation.',
                    project: 'Projet',
                    selectProject: 'Sélectionner un projet',
                    role: 'Rôle',
                    loadingRoles: 'Chargement des rôles...',
                    selectRole: 'Sélectionner un rôle',
                    noOpenRoles: 'Ce projet n’a aucun rôle ouvert pour le moment. Ajoutez des rôles ou ouvrez davantage de places pour envoyer une invitation.',
                    inviteeEmail: 'E-mail de l’invité',
                    inviteeEmailPlaceholder: 'user@example.com',
                    sending: 'Envoi...',
                    sendInvite: 'Envoyer l’invitation',
                },
                contact: {
                    title: 'Contact',
                    description: 'Utilisez l’e-mail du profil ci-dessous pour contacter directement.',
                    emailPlaceholder: 'user@example.com',
                },
                preview: {
                    title: 'Aperçu du portfolio',
                    externalMediaSource: 'Cet élément pointe vers une source média externe.',
                    noMedia: 'Aucun média prévisualisable n’est associé à cet élément du portfolio.',
                },
                deleteSkill: {
                    title: 'Supprimer la compétence',
                    description: 'Retirer "{{name}}" de votre profil ? Cette action est irréversible.',
                    thisSkill: 'cette compétence',
                },
                deletePortfolio: {
                    title: 'Supprimer l’élément du portfolio',
                    description: 'Supprimer "{{name}}" ? Cette action est irréversible.',
                    thisPortfolioItem: 'cet élément du portfolio',
                },
            },
            toast: {
                loadPayoutAccountsFailed: 'Impossible de charger les comptes de paiement',
                loadProjectRolesFailed: 'Impossible de charger les rôles du projet',
                profilePublic: 'Le profil est maintenant public.',
                updateVisibilityFailed: 'Impossible de mettre à jour la visibilité du profil',
                profileCreated: 'Profil professionnel créé. Vous pouvez maintenant compléter vos informations.',
                initializeProfileFailed: 'Impossible d’initialiser le profil professionnel',
                profileVisibilityUpdated: 'Le profil est maintenant {{visibility}}.',
                profileUpdated: 'Profil mis à jour.',
                updateProfileFailed: 'Impossible de mettre à jour le profil',
                skillSaved: 'Compétence enregistrée.',
                saveSkillFailed: 'Impossible d’enregistrer la compétence',
                skillRemoved: 'Compétence supprimée.',
                removeSkillFailed: 'Impossible de supprimer la compétence',
                portfolioSaved: 'Élément du portfolio enregistré.',
                savePortfolioFailed: 'Impossible d’enregistrer l’élément du portfolio',
                payoutRemoved: 'Compte de paiement supprimé.',
                removePayoutFailed: 'Impossible de supprimer le compte de paiement',
                portfolioRemoved: 'Élément du portfolio supprimé.',
                removePortfolioFailed: 'Impossible de supprimer l’élément du portfolio',
                userContactUnavailable: 'Le contact utilisateur est indisponible.',
                noContactEmail: 'Aucun e-mail de contact trouvé pour ce profil.',
                contactWorkflowFailed: 'Impossible d’ouvrir le flux de contact',
                createProjectToInvite: 'Créez un projet pour envoyer des invitations depuis les profils.',
                userUnavailableForInvite: 'L’utilisateur du profil est indisponible pour les invitations.',
                noInviteEmail: 'Aucun e-mail d’invitation disponible pour ce profil.',
                createProjectBeforeInvite: 'Créez d’abord un projet avant d’envoyer une invitation.',
                prepareInviteFailed: 'Impossible de préparer le flux d’invitation',
                selectProjectRole: 'Sélectionnez un projet et un rôle avant d’envoyer l’invitation.',
                inviteSent: 'Invitation envoyée avec succès.',
                sendInviteFailed: 'Impossible d’envoyer l’invitation',
                profileFollowed: 'Profil suivi.',
                profileUnfollowed: 'Profil non suivi.',
                toggleFollowFailed: 'Impossible de {{action}} ce profil pour le moment.',
                emailCopied: 'E-mail copié.',
                copyEmailFailed: 'Impossible de copier l’e-mail.',
                shareProfileFailed: 'Impossible de partager ce profil pour le moment.',
                profileLinkCopied: 'Lien du profil copié.',
                shareProfileLinkFailed: 'Impossible de partager le lien du profil.',
                avatarUpdated: 'Avatar mis à jour.',
                coverUpdated: 'Image de couverture mise à jour.',
                updateImageFailed: 'Impossible de mettre à jour l’image.',
                uploadImageFailed: 'Impossible de téléverser l’image.',
            },
        },
    },
    error: {
        pageNotFound: 'La page que vous recherchez n’existe pas.',
        goHome: 'Accueil',
        goBack: 'Retour',
        emptyDefault: 'Il n’y a rien ici, veuillez revenir à la page précédente.',
        comingSoon: 'Patientez, nous travaillons actuellement sur cette fonctionnalité',
        somethingWentWrong: 'Une erreur est survenue',
        tryAgain: 'Réessayer',
        loadPageFailed: 'Une erreur est survenue lors du chargement de cette page.',
        pageUpdateDetected: 'Mise à jour de page détectée',
        pageRefreshHint: 'Cet écran n’a pas pu se charger complètement. Un rafraîchissement corrige généralement le problème après une mise à jour de l’application.',
        unexpectedRenderError: 'Une erreur inattendue a empêché l’affichage de cet écran.',
        refreshApp: 'Rafraîchir l’app',
    },
    public: {
        layout: {
            gotoDashboard: 'Aller au tableau de bord',
            createSetlistsPrompt: 'Vous voulez créer vos propres setlists ?',
            copyright: '© {{year}} VocalCentric. Tous droits réservés.',
            about: 'À propos',
            privacy: 'Confidentialité',
            terms: 'Conditions',
            contact: 'Contact',
        },
        cookieNotice: {
            label: 'Avis relatif aux cookies',
            message: 'Nous utilisons des cookies pour améliorer VocalCentric.',
            dismiss: 'Fermer l’avis relatif aux cookies',
        },
        resourceHandoff: {
            fallbackTitle: 'Ressource partagée',
            signInTitle: 'Connectez-vous pour ouvrir cette ressource',
            signInDescription: 'Les liens de contribution sont accessibles aux membres VocalCentric connectés.',
            signIn: 'Se connecter pour continuer',
            unavailableTitle: 'Ressource indisponible',
            unavailableDescription: 'Cette ressource peut être dépubliée, supprimée ou ne plus être partagée avec vous.',
            eyebrow: 'Contribution partagée',
            openApp: 'Ouvrir dans VocalCentric',
            openAppHint: 'L’application VocalCentric est nécessaire pour prévisualiser ou utiliser cette ressource.',
        },
        communityThreadHandoff: {
            fallbackTitle: 'Fil de discussion communautaire',
            signInTitle: 'Connectez-vous pour ouvrir ce fil',
            signInDescription: 'Les liens de discussion sont accessibles aux membres VocalCentric connectés.',
            signIn: 'Se connecter pour continuer',
            unavailableTitle: 'Fil indisponible',
            unavailableDescription: 'Ce fil a peut-être été supprimé, ou vous devez d’abord rejoindre son salon.',
            eyebrow: 'Discussion communautaire partagée',
            openApp: 'Ouvrir dans VocalCentric',
            openAppHint: 'L’application VocalCentric est nécessaire pour voir et rejoindre cette discussion.',
        },
        contact: {
            title: 'Nous contacter',
            subtitle: 'Besoin d’aide, un retour à partager, ou envie d’un partenariat avec VocalCentric ? Envoyez-nous un message.',
            intercomTitle: 'Discuter avec le support',
            intercomSubtitle: 'Ouvrez Messenger pour lancer une conversation avec l’équipe VocalCentric.',
            openMessenger: 'Ouvrir le chat support',
            intercomFallback: 'Le chat support est indisponible pour le moment. Veuillez écrire à support@vocalcentric.com.',
            submitted: 'Message reçu. Nous vous répondrons bientôt.',
            namePlaceholder: 'Votre nom',
            emailPlaceholder: 'vous@exemple.com',
            subjectPlaceholder: 'Sélectionnez un sujet…',
            messagePlaceholder: 'Écrivez votre message…',
            sending: '...Envoi',
            send: 'Envoyer le message',
            preferEmail: 'Vous préférez l’e-mail ? Contactez-nous à',
            responseTime: 'Délai de réponse : généralement entre 24 et 72 heures (jours ouvrés).',
            subject: {
                support: 'Support / Aide',
                billing: 'Facturation / Abonnement',
                bug: 'Signalement de bug',
                feedback: 'Demande de fonctionnalité / Retour',
                partnership: 'Partenariat / Licences',
                accountDeletion: 'Suppression de compte',
                other: 'Autre',
            },
            error: {
                nameRequired: 'Le nom est requis.',
                emailRequired: 'L’e-mail est requis.',
                invalidEmail: 'Veuillez entrer une adresse e-mail valide.',
                subjectRequired: 'Veuillez sélectionner un sujet.',
                messageRequired: 'Le message est requis.',
                messageTooShort: 'Le message est trop court (minimum 10 caractères).',
                unexpected: 'Une erreur inattendue est survenue.',
            },
            toast: {
                sent: 'Message envoyé ! Nous vous répondrons rapidement.',
            },
        },
        waitlist: {
            title: 'Rejoindre la liste d’attente',
            subtitle: 'Obtenez un accès anticipé exclusif et restez informé de notre lancement.',
            submitted: 'Vous êtes officiellement sur la liste d’attente !',
            firstName: 'Prénom',
            lastName: 'Nom',
            phonePlaceholder: 'Entrez un numéro de téléphone (+212 34567890)',
            emailPlaceholder: 'vous@exemple.com',
            loading: '...Chargement',
            getNotified: 'Être notifié',
            gotEarlyAccess: 'Vous avez un accès anticipé ?',
            logIn: 'Se connecter',
            joinedCount: 'Plus de ~1,4k+ personnes ont déjà rejoint',
            days: 'Jours',
            hours: 'Heures',
            minutes: 'Minutes',
            seconds: 'Secondes',
            toast: {
                joined: 'Merci d’avoir rejoint la liste d’attente !',
            },
            error: {
                emailRequired: 'L’e-mail est requis.',
                invalidEmail: 'Veuillez entrer une adresse e-mail valide.',
                invalidPhone: 'Veuillez entrer un numéro de téléphone valide.',
                unexpected: 'Une erreur inattendue est survenue.',
            },
        },
        invitation: {
            pageTitle: 'Accepter l’invitation de chorale',
            joinChoir: 'Rejoindre la chorale {{name}}',
            confirmJoin: 'Confirmez et rejoignez {{name}} sur VocalCentric',
            completeRegistration: 'Finalisez votre inscription pour accepter l’invitation',
            firstName: 'Prénom',
            firstNamePlaceholder: 'Entrez votre prénom',
            lastName: 'Nom',
            lastNamePlaceholder: 'Entrez votre nom',
            username: 'Nom d’utilisateur',
            usernamePlaceholder: 'Entrez votre nom d’utilisateur préféré',
            password: 'Mot de passe',
            passwordPlaceholder: 'Créez un mot de passe',
            accept: 'Accepter l’invitation',
            decline: 'Refuser',
            accepted: 'Invitation acceptée avec succès !',
            declined: 'Invitation refusée avec succès.',
            error: {
                firstNameRequired: 'Le prénom est requis',
                lastNameRequired: 'Le nom est requis',
                usernameRequired: 'Le nom d’utilisateur est requis',
                passwordRequired: 'Le mot de passe est requis',
                invalidEmail: 'Veuillez entrer une adresse e-mail valide',
                usernameTaken: 'Le nom d’utilisateur est déjà pris',
                failedUsernameCheck: 'Impossible de vérifier le nom d’utilisateur',
                failedDecline: 'Impossible de refuser l’invitation',
            },
        },
        schedule: {
            loadFailed: 'Impossible de charger le planning public',
            missingToken: 'Jeton de planning manquant',
            unavailable: 'Planning public indisponible',
            couldNotLoad: 'Ce planning n’a pas pu être chargé.',
            publicChoirSchedule: 'Planning public de la chorale',
            serviceCount: '{{count}} service(s)',
        },
        harmony: {
            mixerView: 'Vue mixeur',
            mixerViewInfo: '(Recommandé sur PC) En vue mixeur, vous pouvez ajuster le volume et le panoramique de chaque piste pour une écoute personnalisée.',
            loadingWaveform: 'Chargement de la forme d’onde...',
            mute: 'Muet',
            unmute: 'Activer le son',
            solo: 'Solo',
            unsolo: 'Retirer solo',
            titleFallback: 'Harmonies',
            setlistFallback: 'Setlist',
            ogDescription: 'Une setlist sélectionnée sur VocalCentric avec des harmonies personnalisées pour différentes voix et instruments.',
            playPause: 'Lire ou mettre en pause',
            restart: 'Redémarrer',
        },
        privacy: {
            gotoDashboard: 'Aller au tableau de bord',
            policyTitle: 'Politique de confidentialité de {{companyName}}',
            lastUpdated: 'Dernière mise à jour : {{lastUpdated}}',
            intro: 'Chez {{companyName}}, nous accordons une grande importance à votre vie privée et nous engageons à protéger vos informations personnelles. Cette politique explique comment nous collectons, utilisons et protégeons les données que vous partagez lorsque vous utilisez notre plateforme, application mobile ou services associés.',
            section1Title: '1. Informations que nous collectons',
            section1Intro: 'Nous pouvons collecter les types d’informations suivants :',
            personalInfoLabel: 'Informations personnelles',
            personalInfoBody: 'Nom, adresse e-mail, numéro de téléphone, photo de profil et autres détails fournis lors de la création de compte.',
            usageDataLabel: 'Données d’usage',
            usageDataBody: 'Informations sur votre utilisation de la plateforme, y compris lectures, participation aux répétitions et interactions avec d’autres utilisateurs.',
            mediaFilesLabel: 'Fichiers multimédias',
            mediaFilesBody: 'Enregistrements audio, vidéos et autres contenus que vous téléversez ou partagez.',
            deviceInfoLabel: 'Informations sur l’appareil',
            deviceInfoBody: 'Adresse IP, type de navigateur, modèle d’appareil, système d’exploitation et version de l’application.',
            cookiesLabel: 'Cookies et données de suivi',
            cookiesBody: 'Pour améliorer votre expérience et mémoriser vos préférences.',
            section2Title: '2. Comment nous utilisons vos informations',
            section2Item1: 'Fournir et améliorer nos services.',
            section2Item2: 'Faciliter les répétitions de chorale, la lecture des chansons et les interactions communautaires.',
            section2Item3: 'Personnaliser le contenu et les recommandations.',
            section2Item4: 'Communiquer avec vous sur les mises à jour, le support ou des offres promotionnelles (avec votre consentement).',
            section2Item5: 'Assurer la sécurité et la conformité avec nos Conditions d’utilisation.',
            section3Title: '3. Comment nous partageons vos informations',
            section3Intro: 'Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos données uniquement dans les cas suivants :',
            section3ConsentLabel: 'Avec votre consentement',
            section3ConsentBody: 'Lorsque vous choisissez de partager des enregistrements ou des informations de profil avec d’autres utilisateurs.',
            section3ProvidersLabel: 'Prestataires de services',
            section3ProvidersBody: 'Avec des fournisseurs tiers qui nous aident à exploiter la plateforme (ex. hébergement cloud, prestataires de paiement).',
            section3LegalLabel: 'Obligations légales',
            section3LegalBody: 'Lorsque la loi l’exige ou en réponse à des demandes légales valides.',
            section4Title: '4. Sécurité des données',
            section4Body: 'Nous mettons en place des mesures techniques, administratives et physiques pour protéger vos données contre tout accès, utilisation ou divulgation non autorisés. Toutefois, aucune méthode de transmission sur internet ou de stockage électronique n’est sûre à 100 %.',
            section5Title: '5. Vos droits',
            section5Intro: 'Selon votre lieu de résidence, vous pouvez avoir le droit de :',
            section5Item1: 'Accéder, mettre à jour ou supprimer vos informations personnelles.',
            section5Item2: 'Limiter ou vous opposer au traitement de vos données.',
            section5Item3: 'Demander une copie des données que nous détenons sur vous.',
            section5ContactIntro: 'Pour exercer ces droits, contactez-nous à',
            section6Title: '6. Conservation des données',
            section6Body: 'Nous conservons vos données personnelles uniquement le temps nécessaire pour fournir nos services et atteindre les objectifs décrits dans cette politique, sauf si la loi impose une durée plus longue.',
            section7Title: '7. Vie privée des enfants',
            section7Body: '{{companyName}} n’est pas destiné aux enfants de moins de 13 ans (ou l’âge légal minimum dans votre pays). Nous ne collectons pas sciemment d’informations personnelles sur des enfants sans consentement parental.',
            section8Title: '8. Modifications de cette politique',
            section8Body: 'Nous pouvons mettre à jour cette politique de confidentialité de temps en temps. En cas de changements importants, nous vous en informerons par e-mail ou via une notification dans l’app.',
            section9Title: '9. Nous contacter',
            emailLabel: 'E-mail :',
            websiteLabel: 'Site web :',
            rightsReserved: '© {{year}} VocalCentric. Tous droits réservés.',
            navAbout: 'À propos',
            navPrivacy: 'Confidentialité',
            navTerms: 'Conditions',
            navContact: 'Contact',
        },
        accountDeletion: {
            title: 'Suppression de compte Google',
            subtitle: 'Cette page explique comment supprimer votre compte VocalCentric (y compris via Google Sign‑In), quelles données sont supprimées, et comment nous contacter.',
            signedInAs: 'Vous êtes connecté en tant que',
            instantDeleteHint: 'Vous pouvez supprimer votre compte instantanément depuis ici.',
            deleting: 'Suppression…',
            deleteNow: 'Supprimer mon compte maintenant',
            submitted: 'Votre demande a été envoyée. Nous vous enverrons un e-mail une fois la suppression effectuée.',
            howToRequest: 'Comment demander la suppression',
            howToRequestItems: {
                inAppOrForm: 'Utilisez l’option dans l’application (Compte → Paramètres → Supprimer le compte), ou envoyez le formulaire ci-dessous.',
                verifyOwnership: 'Nous vérifierons la propriété via votre adresse e-mail ou votre session active dans l’application.',
                deleteAfterVerification: 'Une fois vérifiée, nous supprimerons définitivement votre compte et vos données personnelles, sauf les enregistrements minimums que nous devons conserver pour la prévention de la fraude, la sécurité ou les obligations légales.',
            },
            whatWillBeDeleted: 'Ce qui sera supprimé',
            deletedItems: {
                profile: 'Profil du compte (nom, e-mail, nom d’utilisateur, avatar).',
                submissions: 'Soumissions de pratique, métadonnées de participation aux répétitions, publications communautaires liées à votre identité (le contenu peut être anonymisé si sa suppression casse des conversations).',
                history: 'Historique de lecture, préférences et associations d’appareils.',
            },
            retentionLabel: 'Conservation :',
            retentionBody: 'Nous pouvons conserver des journaux minimaux ou des enregistrements financiers lorsque la loi l’exige, ainsi que des analyses agrégées/anonymes ne permettant pas de vous identifier.',
            googleUsers: 'Utilisateurs Google Sign‑In',
            googleUsersBody: 'Si vous vous êtes inscrit via Google, supprimer votre compte VocalCentric ne supprime pas votre compte Google. Nous révoquons uniquement l’accès de notre application et supprimons vos données sur VocalCentric. Vous pouvez aussi consulter ou retirer l’accès de VocalCentric depuis votre compte Google → Sécurité → Accès tiers.',
            emailPlaceholder: 'vous@exemple.com',
            reasonPlaceholder: 'Optionnel : dites-nous pourquoi vous partez (cela nous aide à nous améliorer)',
            confirmLabel: 'Je confirme être propriétaire de cette adresse e-mail et vouloir supprimer définitivement mon compte VocalCentric ainsi que les données associées.',
            submitting: 'Envoi…',
            submitRequest: 'Envoyer la demande de suppression',
            needHelp: 'Besoin d’aide ? Écrivez à',
            toast: {
                requestReceived: 'Votre demande de suppression de compte a bien été reçue.',
                deleted: 'Votre compte a été supprimé avec succès.',
            },
            error: {
                emailRequired: 'L’e-mail est requis.',
                invalidEmail: 'Veuillez entrer une adresse e-mail valide.',
                confirmRequired: 'Vous devez confirmer la propriété et l’intention de suppression.',
                unexpected: 'Une erreur inattendue est survenue.',
                unableDeleteNow: 'Impossible de supprimer le compte pour le moment.',
            },
        },
    },
    uploads: {
        communityUpload: 'Upload communauté',
        title: 'Téléverser une chanson marketplace',
        subtitle: 'Ce flux reprend le processus interne de préparation des chansons, puis envoie la soumission dans le pipeline marketplace communautaire pour les créateurs autorisés.',
        duplicateTitle: 'Vous avez déjà soumis une chanson communautaire avec ce titre',
        steps: {
            information: 'Informations',
            vocals: 'Voix',
            lyrics: 'Paroles',
            sync: 'Sync',
            files: 'Fichiers',
        },
        actions: {
            previous: 'Précédent',
            next: 'Suivant',
            preview: 'Aperçu',
        },
        toast: {
            submitted: 'Chanson communautaire envoyée avec succès',
            submitFailed: 'Échec de l’envoi de la chanson',
        },
        submission: {
            saved: 'Soumission enregistrée',
            sentForProcessing: '{{title}} a été envoyée pour traitement marketplace.',
            processingNote: 'Votre chanson a bien été créée. Le packaging audio et la préparation marketplace se poursuivent en arrière-plan, donc les aperçus ou contrôles de listing peuvent prendre un peu de temps.',
            goToListings: 'Aller à mes annonces',
            uploadAnother: 'Téléverser une autre chanson',
            id: 'ID de soumission : {{id}}',
        },
        stepOne: {
            songOwnershipType: 'Type de propriété de la chanson',
            original: 'Originale',
            cover: 'Reprise',
            songTitle: 'Titre de la chanson',
            artistName: 'Nom de l’artiste',
            writers: 'Auteurs',
            album: 'Album',
            genre: 'Genre',
            label: 'Label',
            themeLabel: 'Thème',
            chooseTheme: 'Choisir un thème',
            theme: {
                praise: 'Louange',
                worship: 'Adoration',
                thanksgiving: 'Action de grâce',
                prayer: 'Prière',
                adoration: 'Adoration',
                faith: 'Foi',
                healing: 'Guérison',
                salvation: 'Salut',
                grace: 'Grâce',
                mercy: 'Miséricorde',
            },
            bpm: 'BPM',
            timeSignature: 'Mesure',
            chooseTimeSignature: 'Choisir une mesure',
            durationSeconds: 'Durée (secondes)',
            duration: 'Durée',
            key: 'Tonalité',
            chooseKey: 'Choisir une tonalité',
            year: 'Année',
            tags: 'Tags',
            tagPlaceholder: 'Tapez un tag puis espace ou virgule',
        },
        stepTwo: {
            whichStem: 'Quel stem téléversez-vous ?',
            uploadStem: 'Téléverser {{stem}}',
            uploadHint: 'Cliquez pour téléverser votre stem préenregistré depuis votre ordinateur ou téléphone',
        },
        stepThree: {
            tabs: {
                lyrics: 'Paroles',
                mainSolfa: 'Solfa principal',
                tenorSolfa: 'Solfa ténor',
                altoSolfa: 'Solfa alto',
                sopranoSolfa: 'Solfa soprano',
            },
            optionalNote: 'Les paroles sont facultatives pour les chansons communautaires. Ajoutez des sections si vous voulez sélectionner un aperçu par section, sinon laissez vide et définissez un intervalle personnalisé à l’étape suivante.',
            startTyping: 'Commencez à saisir {{target}}...',
            uploadMainStemHint: 'Téléversez d’abord le stem principal pour prévisualiser la forme d’onde pendant l’édition des paroles.',
        },
        stepFour: {
            previewWindow: 'Fenêtre d’aperçu',
            previewDescription: 'Choisissez ce que les acheteurs entendent en premier. Si votre chanson a des sections, vous pouvez en utiliser une directement. Sinon, définissez un intervalle personnalisé.',
            previewSource: 'Source de l’aperçu',
            customInterval: 'Intervalle personnalisé',
            previewStart: 'Début de l’aperçu',
            previewEnd: 'Fin de l’aperçu',
            defaultStart: '00:00',
            defaultEnd: '00:20',
            useCurrent: 'Utiliser le temps actuel',
            noLyricsNote: 'Les paroles sont facultatives pour les chansons communautaires. Si vous les ignorez, définissez simplement l’intervalle d’aperçu ci-dessus.',
            adjusting: 'Ajustement',
            selectLineToSync: 'Sélectionnez une ligne pour commencer la synchronisation',
            uploadMainStemToSync: 'Téléversez le stem principal pour aligner les horodatages sur la forme d’onde.',
        },
        stepFive: {
            imageUploadFailed: 'Échec du téléversement de l’image',
            title: 'Téléverser les visuels et fichiers de support',
            subtitle: 'Ces visuels seront utilisés sur la carte marketplace et la vue détail de la chanson.',
            artistImage: 'Image artiste',
            uploadArtistImage: 'Cliquez pour téléverser une image artiste',
            coverArt: 'Pochette',
            uploadCoverArt: 'Cliquez pour téléverser la pochette',
        },
        document: {
            title: 'Téléverser la partition ou un document de support',
            description: 'PDF et DOCX pris en charge (max. 20 Mo)',
            timeout: 'Le téléversement du document a expiré avant la fin du traitement',
            failed: 'Échec du téléversement du document',
        },
        preview: {
            customInterval: 'Intervalle personnalisé',
            song: 'Chanson',
            album: 'Album',
            genre: 'Genre',
            theme: 'Thème',
            duration: 'Durée',
            stemCount: 'Nombre de stems',
            previewWindow: 'Fenêtre d’aperçu',
            lyrics: 'Paroles',
            sectionsCount: '{{count}} section(s)',
            optionalNone: 'Optionnel, rien ajouté',
            previewSource: 'Source de l’aperçu',
            uploadedStems: 'Stems téléversés',
            noStems: 'Aucun stem téléversé',
            submitting: 'Envoi...',
            submit: 'Envoyer',
        },
    },
    exercises: {
        actions: {
            backToExercises: 'Retour aux exercices',
            backToSkill: 'Retour à la compétence',
            continue: 'Continuer',
            continueWithoutMic: 'Continuer sans micro',
            exit: 'Quitter',
            gotIt: 'Compris',
            keepPracticing: 'Continuer à pratiquer',
            listenBack: 'Réécouter',
            locked: 'Verrouillé',
            pausePlayback: 'Mettre en pause',
            play: 'Lire',
            playAgain: 'Rejouer',
            playExample: 'Lire l’exemple',
            practice: 'Pratiquer {{title}}',
            replay: 'Rejouer',
            retry: 'Réessayer',
            saving: 'Enregistrement...',
            skipStep: 'Passer l’étape',
            start: 'Démarrer',
            startBreathCheck: 'Démarrer le contrôle du souffle',
            startPlan: 'Démarrer le plan',
            startPulse: 'Démarrer le pouls',
            startRecording: 'Démarrer l’enregistrement',
            startTimer: 'Démarrer le minuteur',
            stopExample: 'Arrêter l’exemple',
            tryAgain: 'Réessayer',
            viewPath: 'Voir la section',
        },
        status: {
            comingSoon: 'Bientôt disponible',
            complete: 'Terminé',
            counting: 'Comptage...',
            endlessPractice: 'Pratique infinie',
            loadingPianoSamples: 'Chargement des échantillons de piano...',
            listening: 'Écoute...',
            noDrillsYet: 'Aucun exercice pour le moment',
            recording: 'Enregistrement...',
            recordingSaved: 'Enregistrement sauvegardé',
            running: 'En cours...',
        },
        units: {
            bpmPulse: '{{bpm}} BPM · comptez le pouls',
            drillCount: '{{count}} exercice',
            drillCount_other: '{{count}} exercices',
            drills: 'Exercices',
            min: '{{count}} min',
            secondEcho: 'Écho de {{count}} secondes',
            skillsDrills: '{{skills}} compétences - {{drills}} exercices',
            stars: 'Étoiles',
            stepCount: '{{count}} étapes',
            steps: 'Étapes',
            stepOfTotal: 'Étape {{step}} sur {{total}}',
            unitsDrills: '{{units}} unités - {{drills}} exercices',
        },
        skillTree: {
            benefits: {
                default: 'Un court jeu de pratique VocalCentric.',
                warmupFoundation: 'Entrez dans le chant avec une courte remise en route vocale avant un travail plus intense.',
                breathControl: 'Développez un souffle plus stable pour des phrases plus calmes et mieux contrôlées.',
                pitchAccuracy: 'Affinez la justesse et rendez votre oreille plus réactive.',
                noteRecognition: 'Travaillez le rappel rapide des noms de notes avec des séries courtes et sans pression.',
                keyboardNotes: 'Trouvez les notes directement sur un clavier type piano.',
                intervalBasics: 'Apprenez la distance entre les notes avec des exercices de nommage et d’association.',
                theoryTerms: 'Transformez le vocabulaire musical courant en rappel rapide et sûr.',
                earTrainingBasics: 'Écoutez, comparez et identifiez de courtes références de notes et d’intervalles.',
            },
            directGames: {
                scaleChoices: {title: 'Choix de gammes', tag: 'Gammes', purpose: 'Écoutez un motif de gamme, puis choisissez la réponse.'},
                modeChoices: {title: 'Choix de modes', tag: 'Mode', purpose: 'Écoutez un motif de mode, puis choisissez la réponse.'},
                listenAndChoose: {title: 'Écouter et choisir', tag: 'Oreille', purpose: 'Écoutez une note, puis choisissez la réponse.'},
                hearAndPlay: {title: 'Écouter et jouer', tag: 'Touches', purpose: 'Écoutez une note, puis trouvez-la sur le clavier.'},
                hearChords: {title: 'Écouter les accords', tag: 'Oreille', purpose: 'Écoutez un accord, puis nommez sa qualité.'},
                findNotesOnKeys: {title: 'Trouver les notes sur les touches', tag: 'Touches', purpose: 'Touchez les notes cibles directement sur le clavier.'},
                hearIntervals: {title: 'Écouter les intervalles', tag: 'Oreille', purpose: 'Écoutez deux notes, puis nommez l’intervalle.'},
                noteNameSprint: {title: 'Sprint des noms de notes', tag: 'Lecture', purpose: 'Répondez vite aux questions de noms de notes.'},
                theoryQuickfire: {title: 'Théorie rapide', tag: 'Théorie', purpose: 'Pratiquez le vocabulaire musical de base.'},
            },
            empty: 'Aucune compétence d’exercice n’est encore disponible.',
            error: 'Impossible de charger les exercices pour le moment.',
            fallbackModuleDescription: 'Exercices courts de justesse, rythme, théorie et entraînement de l’oreille.',
            fallbackModuleTitle: 'Compétences de base',
            games: 'Jeux',
            gamesDescription: 'Passez à la pratique infinie sans modifier la progression du cours.',
            headings: {
                browseLibrary: 'Sections du cours',
                choosePath: 'Cours de théorie musicale',
                continuePractice: 'Continuer la pratique',
                recommendedPractice: 'Pratique recommandée',
            },
            libraryDescription: 'Ouvrez une section pour voir ses quatre unités en diamant.',
            loading: 'Chargement de votre cours de théorie musicale...',
            moduleAudience: {
                course: 'Terminez ces quatre unités comme une section du cours.',
                default: 'Choisissez ceci pour un parcours de pratique ciblé.',
                musicianship: 'Choisissez ceci pour des jeux musicaux rapides et rejouables.',
                voice: 'Choisissez ceci avant de chanter ou de répéter.',
            },
            moduleBenefit: {
                course: 'Construisez la théorie avec de courtes leçons, des contrôles et des exercices jouables.',
                default: 'Choisissez une série ciblée de courts exercices VocalCentric.',
                musicianship: 'Entraînez notes, intervalles, rythme et réflexes d’oreille avec des jeux rapides.',
                voice: 'Échauffez-vous, contrôlez le souffle et affinez la justesse avant la répétition.',
            },
            moreStartedSkills: 'D’autres compétences commencées à terminer ensuite.',
            progress: 'Progression',
            progressCleared: '{{cleared}}/{{total}} validés',
            prompts: {
                dailyPlan: 'Plan du jour : {{label}}.',
                dailyPlanFallback: 'Le plan du jour est ajusté à vos progrès récents.',
                finishNext: 'Terminez le prochain exercice tant qu’il est frais.',
                replaySkill: 'Rejouez cette compétence pour améliorer vitesse, précision et confiance.',
                startFocused: 'Commencez par un exercice ciblé qui développe un instinct musical utile.',
            },
            quickGame: {
                buildKeyboard: 'Développez la mémoire du clavier.',
                ear: 'Oreille',
                keys: 'Touches',
                notes: 'Lecture',
                practice: 'Pratique',
                replayImprove: 'Rejouer pour progresser.',
                runFocused: 'Lancez un court exercice ciblé.',
                speed: 'Vitesse',
                theory: 'Théorie',
                trainListening: 'Entraînez les réflexes d’écoute.',
                practiceMusicIdeas: 'Pratiquez les notions musicales de base.',
            },
            viewAll: 'Voir tout {{title}}',
            showFewer: 'Afficher moins de {{title}}',
        },
        skillDetail: {
            exerciseNumber: 'Exercice {{number}}',
            fallbackDescription: 'Une série rapide pour aiguiser l’instinct musical.',
            loadError: 'Impossible de charger cette compétence.',
            loading: 'Chargement de la compétence...',
            missing: 'Compétence introuvable.',
            shortFocused: 'Court et ciblé.',
            skill: 'Compétence',
        },
        runner: {
            empty: 'Aucune étape jouable n’est encore disponible pour cette compétence.',
            fallbackPrompt: 'Écoutez, choisissez et faites confiance à votre oreille.',
            messages: {
                patternSeen: 'Motif vu.',
                readyNext: 'Prêt pour la suite.',
                referenceHeard: 'Référence entendue. Continuez.',
                resetComplete: 'Réinitialisation terminée.',
                skippedForWeb: 'Ignoré sur le web.',
            },
            result: {
                complete: 'Série terminée',
                earnedStars: 'Vous avez gagné {{count}} étoiles sur cette série.',
                fallback: 'Continuez, la prochaine série sera plus fluide.',
                niceRun: 'Belle série',
                savedLocally: 'Votre résultat est enregistré localement pour le moment. Réessayez cette série quand votre connexion sera stable.',
                youFinished: 'Vous avez terminé {{title}}.',
            },
        },
        generated: {
            chooseBest: 'Choisissez la meilleure réponse.',
            chooseHeard: 'Choisissez ce que vous avez entendu',
            namePattern: 'Nommez la {{label}}',
            recallTerm: 'Retrouvez le terme',
            scale: 'gamme',
            mode: 'mode musical',
            tapNote: 'Touchez {{note}}.',
            whatTermMean: 'Que signifie {{term}} ?',
            whichNote: 'Quelle note avez-vous entendue ?',
            whichPattern: 'Quelle {{label}} avez-vous entendue ?',
        },
        steps: {
            animation: {
                watchPulse: 'Observez le pouls pendant {{count}} temps.',
            },
            audioReference: {
                chooseHeard: 'Appuyez sur lecture, écoutez attentivement, puis choisissez ce que vous avez entendu.',
                fallbackCopy: 'Appuyez sur lecture et écoutez la couleur avant de continuer.',
                heading: 'Écouter la référence',
                noSource: 'Cette référence ne contient pas encore de source audio web lisible.',
                pianoUnavailable: 'La lecture du piano n’est pas disponible dans ce navigateur.',
                samplesLoading: 'Les échantillons de piano sont encore en cours de chargement.',
                playFailed: 'Impossible de lire cette référence.',
            },
            meter: {
                breathSkipped: 'Guide de souffle ignoré.',
                countPulse: 'Pouls calé.',
                exhale: 'Expirez',
                followCue: 'Suivez l’indication, puis gardez une expiration régulière.',
                inhaleSeconds: 'Inspirez {{count}}s',
                holdSeconds: 'Tenez {{count}}s',
                keepAirflow: 'Gardez le flux d’air stable.',
                listeningLevel: 'Écoute de votre niveau de souffle.',
                micFeedback: 'Le retour micro mesure la stabilité de l’expiration.',
                micNeeded: 'L’autorisation du micro est nécessaire pour le retour sur le souffle.',
                micUnavailable: 'L’entrée micro n’est pas disponible dans ce navigateur.',
                phase: 'Étape',
                phaseReady: 'Prêt',
                phaseInhale: 'Inspirez',
                phaseHold: 'Tenir',
                phaseExhale: 'Expirez',
                smoothExhale: 'Le souffle a vacillé. Essayez une expiration plus régulière.',
                steadyAirflow: 'Ce flux d’air est resté stable.',
                liveFeedbackUnavailable: 'Le retour de souffle en direct n’est pas disponible dans ce navigateur.',
            },
            multipleChoice: {
                chooseBest: 'Choisissez la meilleure réponse.',
                close: 'Presque. Essayez encore une fois.',
                correct: 'C’est juste.',
            },
            pairs: {
                answer: 'Associez la réponse',
                complete: 'Paires terminées. Un peu plus propre la prochaine fois.',
                perfect: 'Paires parfaites.',
                prompt: 'Touchez une consigne',
            },
            piano: {
                missed: 'Cette note a manqué la cible.',
                playHeard: 'Jouez au clavier ce que vous avez entendu.',
                right: 'Cette note est correcte.',
                tapTarget: 'Touchez {{note}}.',
                targetNote: 'la note cible',
                unavailable: 'La lecture du piano n’est pas disponible dans ce navigateur.',
                useReference: 'Utilisez la touche {{note}} indiquée comme référence d’octave.',
            },
            record: {
                challenge: {
                    echoMelody: 'Reproduisez la mélodie',
                    holdSteady: 'Tenez {{note}} stable',
                    singBack: 'Rechantez-le',
                },
                coaching: {
                    melody: 'Restez léger et laissez les notes se connecter naturellement.',
                    steady: 'Chantez léger et gardez le ton stable.',
                },
                guide: {
                    close: 'Vous êtes proche de la mélodie.',
                    focus: 'Concentrez-vous sur la forme, pas le volume.',
                    listening: 'Écoute de votre voix...',
                    moveToward: 'Restez doux et rapprochez-vous de la mélodie.',
                },
                labels: {
                    flow: 'Écouter → Chanter → Revoir',
                    melodyNotes: 'Notes de la mélodie : {{notes}}',
                },
                messages: {
                    capturedNoTarget: 'Enregistrement capturé. Cette étape nécessite une note cible claire avant que le web puisse l’évaluer.',
                    detectFailed: 'Je n’ai pas détecté de hauteur cible stable. Essayez une nouvelle prise.',
                    drifted: 'J’ai entendu la hauteur, mais elle s’est éloignée de la mélodie.',
                    matched: 'Cela correspondait à la forme de la mélodie.',
                },
                errors: {
                    micNeeded: 'L’autorisation du micro est nécessaire pour cette étape.',
                    playbackUnavailable: 'La lecture de référence n’est pas disponible dans ce navigateur.',
                    recordingUnavailable: 'L’enregistrement n’est pas disponible dans ce navigateur.',
                },
            },
            text: {
                fallback: 'Prenez cette indication, puis continuez.',
            },
            timer: {
                reset: 'Respirez, réinitialisez, puis revenez proprement.',
            },
            unsupported: {
                body: 'Vous pouvez continuer la série.',
                title: 'Cette étape d’exercice n’est pas encore disponible sur le web.',
            },
        },
        controls: {
            accidentals: 'Altérations',
            accidentalsDescription: 'Ajoutez des dièses aux choix de notes.',
            alphabet: 'Alphabétique',
            challenge: 'Défi',
            difficulty: 'Difficulté',
            difficulty_auto: 'Auto',
            difficulty_easy: 'Facile',
            difficulty_expert: 'Expert',
            difficulty_hard: 'Difficile',
            difficulty_normal: 'Normal',
            gameSettings: 'Paramètres du jeu',
            mixed: 'Mixte',
            notation: 'Écriture musicale',
            pad: 'Bourdon {{note}}',
            solfege: 'Solfège',
            tonic: 'Tonique {{note}}',
        },
    },
    training: {
        eyebrow: 'Enseignement et formation',
        title: 'Écoles',
        subtitle: 'Organisez les cours, classes, devoirs, progrès et séances en direct avec ou sans chœur.',
        choirEyebrow: 'Développement du chœur', choirTitle: 'Formation', choirDescription: 'Proposez aux membres sélectionnés des exercices, devoirs, retours et séances en direct.', choirTab: 'Formation', choirTabDescription: 'Cours et développement des membres',
        workspaces: 'Écoles', myCohorts: 'Mes classes', courses: 'Cours', courseDescription: 'Programmes réutilisables associés à plusieurs classes.', curriculum: 'Programme', curriculumDescription: 'Créez un parcours ordonné avec des exercices configurés et des ressources.', cohorts: 'Classes', cohortsDescription: 'Créez des groupes datés et associez chaque classe à un ou plusieurs cours.', mappedCourses: 'Cours associés', courseClassMappingDescription: 'Les classes appartiennent à l’École et peuvent utiliser plusieurs cours.', classCurriculumDescription: 'Programme de tous les cours associés à cette classe.', assignments: 'Devoirs', sessions: 'Séances', progress: 'Progression', staff: 'Équipe', students: 'Élèves', submissions: 'Remises', submissionsDescription: 'Évaluez chaque tentative et donnez un retour utile.', exerciseAssignment: 'Exercice à réaliser', exerciseAssignmentDescription: 'Réalisez l’exercice configuré. Vous pouvez envoyer jusqu’à {{count}} tentatives.', learningMaterials: 'Ressources pédagogiques', myAttempts: 'Mes tentatives', attemptNumber: 'Tentative {{count}}', previewTitle: 'Aperçu de l’exercice généré', pendingReviews: 'Évaluations en attente', upcomingSessions: 'Séances à venir', pendingInvitations: 'Invitations en attente', workspaceSettings: 'Paramètres de l’École', courseSettings: 'Paramètres du cours', cohortSettings: 'Paramètres de la classe', cohortStaff: 'Équipe de la classe', assignmentSettings: 'Paramètres du devoir',
        actions: {
            accept: 'Accepter', addCourse: 'Ajouter le cours', addCurriculum: 'Ajouter au programme', addStudents: 'Ajouter des élèves', applyInstructor: 'Demander à créer une École', approve: 'Approuver', archiveCohort: 'Archiver la classe', archiveCourse: 'Archiver le cours', archiveWorkspace: 'Archiver l’École', assignStaff: 'Affecter un membre', back: 'Retour', backToCohort: 'Retour à la classe', backToTeaching: 'Retour aux Écoles', cancel: 'Annuler la séance', checkIn: 'Pointer présent', createCohort: 'Créer la classe', createCourse: 'Créer le cours', decline: 'Refuser', edit: 'Modifier', editCurriculum: 'Modifier l’élément', endSession: 'Terminer la séance', enroll: 'Inscrire les utilisateurs', inviteNewStudent: 'Inviter un nouvel élève', inviteStaff: 'Inviter un membre', join: 'Rejoindre', lowerHand: 'Baisser la main', manageClasses: 'Gérer les classes', manageTraining: 'Gérer la formation', moveDown: 'Descendre', moveUp: 'Monter', needsImprovement: 'À améliorer', newCohort: 'Nouvelle classe', newCourse: 'Nouveau cours', newWorkspace: 'Nouvelle École', open: 'Ouvrir', openChoir: 'Ouvrir le chœur', openCourse: 'Ouvrir le cours', openSchool: 'Ouvrir l’École', preview: 'Prévisualiser', publishAssignment: 'Publier le devoir', raiseHand: 'Lever la main', remove: 'Retirer', resend: 'Renvoyer', revoke: 'Révoquer', scheduleSession: 'Planifier une séance', send: 'Envoyer le message', sendInvite: 'Envoyer l’invitation', share: 'Partager', start: 'Démarrer', startAssignment: 'Commencer le devoir', submit: 'Envoyer', submitApplication: 'Envoyer la demande',
        },
        fields: {
            assignmentSource: 'Source du devoir', assignmentTitle: 'Titre du devoir', attemptsAllowed: 'Tentatives autorisées', audioResponse: 'Réponse audio (facultative)', choirMembers: 'Choisir des choristes', choirPart: 'Pupitre', cohortTitle: 'Nom de la classe', course: 'Cours', courseTitle: 'Titre du cours', description: 'Description', dueAt: 'Échéance', email: 'E-mail', ends: 'Fin', enrollmentMode: 'Inscription', exerciseTemplate: 'Modèle d’exercice', feedback: 'Commentaire', instructions: 'Consignes', itemType: 'Type d’élément', level: 'Niveau', locationMode: 'Lieu', materialUrl: 'URL de la ressource', passStars: 'Étoiles requises', responseNote: 'Votre réponse', role: 'Rôle', sessionTitle: 'Titre de la séance', starts: 'Début', status: 'Statut', studentEmails: 'E-mails des élèves', title: 'Titre', verifiedScore: 'Score vérifié', verifiedStars: 'Étoiles vérifiées', workspaceName: 'Nom de l’École',
        },
        roles: {owner: 'Propriétaire', instructor: 'Formateur', assistant: 'Assistant', learner: 'Élève'}, statuses: {active: 'Actif', archived: 'Archivé', closed: 'Fermé', completed: 'Terminé', draft: 'Brouillon', enrolling: 'Inscriptions ouvertes', published: 'Publié'}, enrollmentModes: {invite: 'Sur invitation', open: 'Inscription ouverte'}, itemTypes: {exercise: 'Exercice', material: 'Ressource pédagogique'}, assignmentSources: {curriculum: 'Programme du cours', adhoc: 'Exercice ponctuel configuré'}, locationModes: {virtual: 'À distance', physical: 'En présentiel', hybrid: 'Hybride'}, units: {assignments: 'devoirs', attempts: 'tentatives', cohorts: 'cohortes', curriculumItems: 'éléments', learners: 'élèves', pending: 'en attente', submissions: 'remises'},
        placeholders: {choirPart: 'ex. soprano', emails: 'Séparez les e-mails par des virgules ou espaces', level: 'ex. Débutant', optionalCurriculumTitle: 'Facultatif — utilise le titre du programme'},
        empty: {
            assignmentsTitle: 'Aucun devoir', assignmentsDescription: 'Les devoirs publiés apparaîtront ici.', attemptsTitle: 'Aucune tentative', attemptsDescription: 'Commencez le devoir lorsque vous êtes prêt.', choirTrainingTitle: 'La formation n’est pas configurée', choirTrainingDescription: 'Un directeur ou modérateur peut créer l’École du chœur.', classCurriculumDescription: 'Associez à cette classe un cours avec programme.', cohortsTitle: 'Aucune classe', cohortsDescription: 'Vos classes actives apparaîtront ici.', courseCohortsDescription: 'Associez ce cours depuis une classe de l’École.', coursesTitle: 'Aucun cours', coursesDescription: 'Créez des cours réutilisables puis associez-les aux classes.', curriculumTitle: 'Programme vide', curriculumDescription: 'Ajoutez le premier exercice ou la première ressource.', invitationsDescription: 'Aucune invitation en attente.', noCourses: 'Aucun cours associé', noDescription: 'Aucune description.', noInstructions: 'Aucune consigne supplémentaire.', progressTitle: 'Aucune progression', progressDescription: 'Inscrivez des élèves et publiez un devoir.', sessionsTitle: 'Aucune séance planifiée', sessionsDescription: 'Les séances à venir et en direct apparaîtront ici.', submissionsTitle: 'Aucune remise', submissionsDescription: 'Les tentatives des élèves apparaîtront ici.', workspacesTitle: 'Aucune École', workspacesDescription: 'Créez une École pour vos élèves, académie ou studio.',
        },
        errors: {
            archiveCohort: 'Impossible d’archiver la classe.', archiveCourse: 'Impossible d’archiver le cours.', archiveWorkspace: 'Impossible d’archiver l’École.', assignStaff: 'Impossible d’affecter ce membre.', attendance: 'Impossible d’enregistrer la présence.', createAssignment: 'Impossible de publier le devoir.', createCohort: 'Impossible de créer la classe.', createCourse: 'Impossible de créer le cours.', createSession: 'Impossible de planifier la séance.', createWorkspace: 'Impossible de créer l’École.', endSession: 'Impossible de terminer la séance.', enroll: 'Impossible d’inscrire les élèves.', instructorApplication: 'Impossible d’envoyer la demande de formateur.', invalidInvitation: 'Ce lien d’invitation est invalide.', invitation: 'Impossible de répondre à l’invitation.', invite: 'Impossible d’envoyer l’invitation.', inviteFirst: 'Invitez ces élèves avant de les inscrire :', load: 'Impossible de charger les Écoles.', loadAssignment: 'Impossible de charger le devoir.', loadChoirTraining: 'Impossible de charger la formation du chœur.', loadCohort: 'Impossible de charger la classe.', loadCourse: 'Impossible de charger le cours.', loadSession: 'Impossible de charger la séance.', loadWorkspace: 'Impossible de charger l’École.', mapCourse: 'Impossible de modifier les cours associés à la classe.', preview: 'Impossible de générer l’aperçu.', removeCurriculum: 'Impossible de supprimer l’élément.', removeStaff: 'Impossible de retirer ce membre.', reorder: 'Impossible de réordonner le programme.', resendInvitation: 'Impossible de renvoyer l’invitation.', review: 'Impossible d’enregistrer l’évaluation.', revokeInvitation: 'Impossible de révoquer l’invitation.', saveCurriculum: 'Impossible d’enregistrer l’élément.', saveWorkspace: 'Impossible d’enregistrer l’École.', startSession: 'Impossible de démarrer la séance.', submit: 'Impossible d’envoyer le devoir.', updateAssignment: 'Impossible de modifier le devoir.', updateCohort: 'Impossible de modifier la classe.', updateCourse: 'Impossible de modifier le cours.', updateEnrollment: 'Impossible de modifier l’inscription.', updateSession: 'Impossible de modifier la séance.', updateStaff: 'Impossible de modifier ce membre.',
        },
        confirm: {archiveAssignment: 'Archiver ce devoir ? Les remises existantes seront conservées.', archiveCohort: 'Archiver cette classe ?', archiveCourse: 'Archiver ce cours ?', archiveWorkspace: 'Archiver cette École ?', cancelSession: 'Annuler cette séance ?', endSession: 'Terminer cette séance en direct ?', removeCourseFromClass: 'Retirer ce cours de la classe ?', removeCurriculum: 'Supprimer cet élément du programme ?', removeStaff: 'Retirer ce membre de la classe ?', removeStudent: 'Retirer cet élève de la classe ?'},
        attendanceStatuses: {present: 'Présent', late: 'En retard', absent: 'Absent', excused: 'Excusé'},
        classroom: {attendance: 'Présences', cancelledDescription: 'Cette séance a été annulée.', cancelledTitle: 'Séance annulée', chat: 'Discussion du cours', chatFailed: 'Impossible d’envoyer le message.', checkedIn: 'Présence enregistrée', clearContext: 'Effacer le contexte partagé', completedDescription: 'Cette séance est terminée.', completedTitle: 'Séance terminée', context: 'Contexte du cours', contextFailed: 'Impossible de partager le contexte.', handRaiseFailed: 'Impossible de mettre à jour la main levée.', joinFailed: 'Impossible de rejoindre la classe.', joinMedia: 'Rejoindre avec audio et vidéo', joiningMedia: 'Connexion…', leaveMedia: 'Quitter l’audio et la vidéo', enableAudio: 'Activer le son', listenOnly: 'Vous êtes en écoute seule. Le formateur contrôle qui peut publier l’audio et la vidéo.', liveRoom: 'Classe en direct', mediaJoinFailed: 'Impossible de rejoindre la salle audio et vidéo.', mediaPresenceFailed: 'Vous avez rejoint la salle, mais la présence n’a pas pu être mise à jour.', mediaReady: 'Rejoignez la salle quand vous êtes prêt. Le microphone est demandé lorsque vous parlez ; la caméra est réservée aux instructeurs.', mediaRenewFailed: 'Le jeton média de la classe n’a pas pu être renouvelé.', message: 'Message', muteMicrophone: 'Couper le micro', noContext: 'Aucun devoir ou support n’est partagé.', noMessages: 'Aucun message.', notCheckedIn: 'Non pointé', participants: 'Participants', physicalSession: 'Cette séance est en présentiel. La discussion, les présences et le contexte partagé restent disponibles.', present: 'Présent', selfCheckInDescription: 'Enregistrez votre présence à cette séance de classe.', turnCameraOff: 'Couper la caméra', turnCameraOn: 'Activer la caméra', unmuteMicrophone: 'Activer le micro', waitingInstructor: 'Démarrez la séance quand vous êtes prêt. Les élèves inscrits seront avertis.', waitingLearner: 'Votre formateur n’a pas encore démarré la séance. Cette page se mettra à jour automatiquement.', waitingTitle: 'En attente du début de la séance', you: 'Vous', joinStates: {idle: 'En attente de connexion', joined: 'Connecté aux commandes de classe', joining: 'Connexion à la classe'}, mediaStates: {idle: 'Média non connecté', joined: 'Audio et vidéo connectés', joining: 'Connexion audio et vidéo', reconnecting: 'Reconnexion audio et vidéo'}},
        instructorApplication: {title: 'Demande de formateur certifié', description: 'Les Écoles indépendantes nécessitent une approbation. Ajoutez une courte vidéo et décrivez votre expérience.', pending: 'Votre demande est en cours d’examen.', rejected: 'La demande précédente n’a pas été approuvée. Mettez à jour vos preuves et renvoyez-la.', video: 'Vidéo de formation ou de prestation', reason: 'Pourquoi devriez-vous être approuvé ?'},
        invitation: {eyebrow: 'Invitation à enseigner', title: 'Rejoindre cet espace d’enseignement', description: 'Acceptez pour rejoindre l’équipe ou la cohorte. Cette invitation est à usage unique et liée à votre compte.'},
        openEnrollment: {title: 'Rejoindre cette cohorte', description: 'Inscrivez-vous pour recevoir les devoirs, les retours et les séances planifiées.', unavailable: 'Cette cohorte n’accepte pas votre inscription. Demandez une invitation à l’enseignant.'},
    },
    vocalContributions: {
        title: 'Contributions vocales',
        addVocal: 'Ajouter une voix',
        tags: {
            popular: 'Populaire',
            popularDescription: 'Albums les plus populaires',
            new: 'Nouveau',
            newDescription: 'Nouvellement ajouté',
        },
        table: {
            title: 'Titre',
            dateCreated: 'Date de création',
            plays: 'Lectures',
            votes: 'Votes',
            vocal: 'Voix',
            actions: 'Actions',
        },
        actions: {
            editEntry: 'Modifier l’entrée',
            delete: 'Supprimer',
        },
        toast: {
            addedToRehearsals: 'Chanson ajoutée aux répétitions',
        },
    },
};

export default fr;
